import { docsRu } from "./docs";
import { auditRu } from "./audit/ru";
/** Базовый словарь (ru). Ключи группируются по модулям; ky/en/uz — с тем же набором ключей (проверяется типом). */
export const ru = {
  reportReset: {
    "deleteArchive": "Удалить архив",
    "deleteArchiveTitle": "Удалить архив сброса?",
    "deleteArchiveText": "Отчёты за {{period}} будут удалены из архива навсегда — скачать их снова будет нельзя. Сброс, его дата и запись в истории останутся, заказы и оплаты не удаляются.",
    "deleteArchiveSave": "Если архив ещё нужен — скачайте его перед удалением:",
    "deleteArchiveConfirm": "Удалить архив навсегда?",
    "deleteArchiveConfirmText": "Отменить удаление архива будет нельзя.",
    "archiveDeleted": "Архив удалён",
    "title": "Сброс отчётов",
    "description": "Начать учёт с чистого листа: выручка и деньги в отчётах — с выбранной даты. Ничего не удаляется, отчёты за прошлое сохраняются в архив.",
    "currentFrom": "Отчёты считаются с {{date}}",
    "currentAll": "Отчёты считаются с начала работы",
    "currentHint": "Заказы, оплаты, смены и документы не удаляются. Отчёты за прошлое — в архиве, его можно скачать в Excel или PDF.",
    "start": "Сбросить отчёты",
    "history": "История сбросов",
    "historyEmpty": "Сбросов ещё не было",
    "colFrom": "Отчёты с",
    "colArchive": "Архив за период",
   
    "colBy": "Кто и когда",
   
    "statusActive": "Действует",
    "statusCancelled": "Отменён",
    "archiveNone": "Без данных",
    "cancel": "Отменить сброс",
    "cancelTitle": "Отменить сброс отчётов?",
    "cancelText": "Отчёты снова будут считаться {{since}}. Архив этого сброса останется в истории.",
    "sinceDate": "с {{date}}",
    "sinceStart": "с начала работы",
    "cancelled": "Сброс отменён — отчёты снова видят прошлые данные",
    "stepWhat": "Что произойдёт",
    "stepArchive": "Архив",
    "stepConfirm": "Подтверждение",
    "stepOf": "Шаг {{n}} из 3 · {{name}}",
    "date": "С какой даты считать отчёты заново",
    "dateHint": "Обычно — сегодня или первое число месяца. Продажи этого дня останутся в новых отчётах.",
    "resets": "Начнутся с нуля",
    "resetRevenue": "Выручка, оплаты, возвраты, средний чек в отчётах",
    "resetFinance": "Финансы: прибыль, расходы, закупки, списания, ФОТ в отчётах",
    "resetOther": "Продажи блюд, продукты, официанты, акции, услуги и расширенные отчёты",
    "keeps": "Не изменится",
    "keepMenu": "Меню, техкарты, цены, стоп-лист",
    "keepStock": "Склад и остатки продуктов",
    "keepDebts": "Клиенты и их долги, долги поставщикам",
    "keepStaff": "Сотрудники, смены, зарплата",
    "keepJournal": "Заказы, оплаты, кассовые смены и документы в журналах — как были",
    "archivePeriod": "В архив попадут отчёты за {{from}} — {{to}}",
    "archiveEmpty": "До этой даты отчётов нет — архив будет пустым.",
    "archiveLimit": "Архив — не длиннее года и не глубже истории отчётов по тарифу. Сами данные остаются в базе.",
    "archiveText": "Скачайте отчёты за прошлый период и сохраните у себя. Позже архив можно скачать снова — в истории сбросов.",
    "archiveSaved": "Я сохранил(а) архив или он мне не нужен",
    "archiveTitle": "Архив отчётов",
    "branch": "Филиал",
    "revenue": "Выручка",
    "orders": "Заказов",
    "confirmText": "Чтобы подтвердить, введите слово {{word}}.",
    "confirmWord": "СБРОСИТЬ",
    "password": "Ваш пароль",
    "comment": "Комментарий",
    "commentPlaceholder": "Например: начало работы после обучения",
    "next": "Далее",
    "back": "Назад",
    "submit": "Сбросить отчёты",
    "finalTitle": "Сбросить отчёты?",
    "finalText": "Все отчёты у всех сотрудников начнутся с {{date}}. Данные не удаляются, сброс можно отменить в истории.",
    "done": "Отчёты сброшены — учёт с {{date}}",
    "banner": "Отчёты считаются с {{date}} — более ранние данные в архиве сброса.",
    "bannerLink": "Сброс отчётов",
  },
  nav: {
    "reportReset": "Сброс отчётов",
    "menuPacks": "Готовые меню",
    "help": "Справочник",
    "stockRequests": "Заявки на склад",
    "purchaseRequests": "Заявки на закупку",
    "conversions": "Разделка и сборка",
    "warehouses": "Склады",
    "transfers": "Перемещения",
    "expiry": "Сроки годности",
    "production": "Производство",
    site: "Сайт и QR-меню",
    employees: "Кадры",
    positions: "Должности",
    workShifts: "Рабочие смены",
    payroll: "Зарплата",
    tips: "Чаевые",
    myWork: "Мой кабинет",
    audit: "Журнал аудита",
    customers: "Клиенты",
    debts: "Долги",
    insights: "Аналитика кафе", expenses: "Расходы", suppliers: "Поставщики", supplierReturns: "Возвраты поставщикам", purchases: "Закупки", writeoffs: "Списания",
    analytics: "Аналитика", dashboard: "Дашборд", reports: "Отчёты",
    sales: "Продажи", pos: "Касса (POS)", posShort: "POS", orders: "Заказы", kitchen: "Кухня",
    venue: "Заведение", branches: "Филиалы", tables: "Залы и столы",
    shifts: "Смены и брони", cashShifts: "Кассовые смены", reservations: "Бронирование",
    catalog: "Меню и склад", menu: "Меню", products: "Продукты", costing: "Калькуляция", inventory: "Склад", inventoryCounts: "Инвентаризация", notifications: "Уведомления", security: "Безопасность",
    staff: "Персонал", users: "Сотрудники", roles: "Роли и права",
    settings: "Настройки", company: "Компания", devices: "Терминалы", subscription: "Подписка", support: "Поддержка", fraud: "Защита от злоупотреблений", sms: "SMS-рассылки", services: "Услуги и аренда", banquets: "Банкеты", promotions: "Акции", deliveries: "Доставка", courier: "Мои доставки", goals: "Цели и достижения", myGoals: "Мои цели", waiterZones: "Официанты по залам",
    kitchenStations: "Кухонные станции", more: "Ещё",
  },
  common: {
    close: "Закрыть",
    save: "Сохранить", cancel: "Отмена", create: "Создать", edit: "Изменить", delete: "Удалить", retry: "Повторить", add: "Добавить",
    done: "Готово", saved: "Изменения сохранены", search: "Поиск…", logout: "Выйти", logoutTitle: "Выйти из аккаунта?", logoutHint: "Чтобы продолжить работу, нужно будет войти снова.", profile: "Профиль", branch: "Филиал", allBranches: "Все филиалы",
    active: "Активен", inactive: "Отключён", blocked: "Заблокирован", soon: "Скоро",
    locked: "Недоступно в тарифе", upgrade: "Подключить", theme: "Тема", language: "Язык",
    name: "Название", description: "Описание", phone: "Телефон", status: "Статус", price: "Цена", actions: "Действия",
    all: "Все", no: "Нет", more: "Подробнее", filter: "Фильтр", moveUp: "Выше", moveDown: "Ниже", hasErrors: "Есть ошибки",
    nothingFound: "Ничего не найдено", nothingFoundHint: "Попробуйте изменить запрос", resetSearch: "Сбросить поиск", resetFilters: "Сбросить фильтры",
    deleteNamed: "Удалить «{{name}}»?",
  },
  ui: {
    ok: "Понятно", confirm: "Подтвердить", actionFailed: "Не удалось выполнить действие",
    typeToConfirmBefore: "Введите", typeToConfirmAfter: "для подтверждения", dialog: "Диалог", close: "Закрыть", clear: "Очистить",
    showPassword: "Показать пароль", hidePassword: "Скрыть пароль", select: "Выберите…", loadError: "Ошибка загрузки. Попробуйте ещё раз.",
    create: "Создать «{{q}}»", increase: "Увеличить", decrease: "Уменьшить", loading: "Загрузка", pages: "Страницы",
    pageRange: "{{from}}–{{to}} из {{total}}", prevPage: "Предыдущая страница", nextPage: "Следующая страница",
    selectAll: "Выбрать все", selectRow: "Выбрать", selectedCount: "Выбрано: {{count}}", clearSelection: "Снять выбор",
    grams: "г", kilograms: "кг", weight: "Вес", perKg: "за 1 кг",
  },
  currencySymbols: { KGS: "сом", KZT: "₸", UZS: "сум", RUB: "₽", TJS: "сомони" },
  errors: {
    IMPERSONATION_READ_ONLY: "Сеанс поддержки только для чтения",
    INVOICE_PAID: "Счёт оплачен — изменить нельзя",
    DOWNGRADE_BLOCKED: "Использование превышает лимиты нового тарифа",
    ADDON_UNAVAILABLE: "Дополнение недоступно на этом тарифе",
    MENU_PACK_NOT_PURCHASED: "Готовое меню ещё не оплачено — загрузить его можно после оплаты счёта",
    TWO_FACTOR_INVALID: "Неверный код подтверждения",
    CLOCK_IN_NOT_ALLOWED: "Отметка смены недоступна",
    WORK_SHIFT_OPEN: "У сотрудника уже открыта смена",
    PAYROLL_APPROVED: "Ведомость утверждена — изменить нельзя",
    CREDIT_LIMIT_EXCEEDED: "Превышен кредитный лимит клиента",
    DEPOSIT_REQUIRED: "Банкет подтверждается после внесения депозита",
    DELIVERY_ADDRESS_OUT_OF_ZONE: "Адрес вне зон доставки",
    CUSTOMER_DEBT_OVERDUE: "У клиента просроченный долг — новый кредит запрещён",
    CUSTOMER_BLOCKED: "Клиент заблокирован",
    CUSTOMER_PHONE_TAKEN: "Клиент с таким телефоном уже есть",
    CASH_SHIFT_NOT_OPEN: "Кассовая смена не открыта",
    CASH_INSUFFICIENT: "В кассе недостаточно наличных",
    INSUFFICIENT_STOCK: "Недостаточно остатка на складе",
    APPROVAL_REQUIRED: "Нужно подтверждение менеджера",
    APPROVAL_INVALID: "Подтверждение не подходит к этому действию или истекло",
    APPROVAL_USED: "Подтверждение уже использовано",
    DISCOUNT_INVALID: "Скидка больше суммы позиций, на которые она разрешена",
    BRANCH_INACTIVE: "Филиал выключен — изменения в нём недоступны",
    DOCUMENT_POSTED: "Проведённый документ нельзя изменить или удалить",
    INVENTORY_COUNT_CLOSED: "Инвентаризация уже проведена или отменена",
    PAYMENT_AMOUNT_INVALID: "Сумма безналичной оплаты больше остатка к оплате",
    CUSTOMER_REQUIRED: "Для оплаты в долг выберите клиента",
    MODIFIERS_INVALID: "Проверьте выбор модификаторов", TABLE_UNAVAILABLE: "Стол недоступен", ITEM_ALREADY_SENT: "Позиция уже отправлена на кухню — изменить нельзя, только отменить", ORDER_CLOSED: "Заказ закрыт", ORDER_HAS_PAYMENTS: "По заказу есть оплаты — отмена только через возврат", NOTHING_TO_SEND: "Нет новых позиций для отправки на кухню",
    NETWORK_ERROR: "Нет связи с сервером. Проверьте интернет", requestFailed: "Ошибка запроса", unknown: "Что-то пошло не так. Попробуйте ещё раз",
    code: "код: {{id}}…", actionFailed: "Не удалось выполнить действие",
    limitTitle: "Достигнут лимит тарифа", limitHint: "Лимит: {{max}}. Увеличьте тариф или подключите пакет в разделе «Подписка».",
    planHint: "Откройте «Настройки → Подписка», чтобы продлить или расширить тариф.",
    conflictTitle: "Данные уже изменил другой пользователь", conflictHint: "Мы загрузили актуальную версию — проверьте и повторите изменение.",
    VALIDATION_ERROR: "Проверьте правильность заполнения полей", UNAUTHENTICATED: "Требуется вход в систему", TOKEN_EXPIRED: "Сессия истекла",
    REFRESH_TOKEN_REUSED: "Сессия завершена из соображений безопасности. Войдите снова",
    DEVICE_REQUIRED: "Вход по PIN доступен только на зарегистрированном терминале", DEVICE_REVOKED: "Терминал отключён администратором",
    INVALID_CREDENTIALS: "Неверный логин или пароль", FEATURE_NOT_IN_PLAN: "Функция недоступна в вашем тарифе", PLAN_LIMIT_REACHED: "Достигнут лимит тарифа",
    SUBSCRIPTION_READ_ONLY: "Подписка в режиме только чтения", SUBSCRIPTION_SUSPENDED: "Подписка приостановлена", PERMISSION_DENIED: "Недостаточно прав",
    BRANCH_ACCESS_DENIED: "Нет доступа к филиалу", NOT_FOUND: "Не найдено", VERSION_CONFLICT: "Данные изменились. Обновите страницу",
    DUPLICATE: "Такая запись уже существует", SLUG_TAKEN: "Адрес уже занят", ENTITY_IN_USE: "Запись используется и не может быть удалена",
    ACCOUNT_LOCKED: "Аккаунт временно заблокирован", PIN_LOCKED: "Вход по PIN временно заблокирован",
    RATE_LIMITED: "Слишком много попыток. Попробуйте позже", INTERNAL_ERROR: "Внутренняя ошибка сервера",
    UNIT_CONVERSION_UNDEFINED: "Единица не переводится в единицу продукта — укажите плотность продукта",
    RECIPE_CYCLE: "Полуфабрикат не может содержать сам себя (или вложенность больше 5 уровней)",
    RECIPE_VERSION_PUBLISHED: "Опубликованную версию ТТК изменить нельзя — создайте новую",
    MENU_ITEM_UNAVAILABLE: "Позиция недоступна для продажи", TABLE_OCCUPIED: "Стол занят",
    FILE_TOO_LARGE: "Файл слишком большой (до 10 МБ)", FILE_TYPE_NOT_ALLOWED: "Допустимы изображения JPEG, PNG, WebP, AVIF, HEIC",
    SERVICE_UNAVAILABLE: "Сервис временно недоступен",
    SHIFT_ALREADY_OPEN: "На кассе уже открыта смена", SHIFT_CLOSED: "Смена уже закрыта",
    CURSOR_EXPIRED: "Данные кассы устарели — нужна полная загрузка", BATCH_TOO_LARGE: "Слишком большой пакет данных", OPEN_ORDERS_EXIST: "Есть открытые заказы — закройте их перед сменой валюты", TOTALS_MISMATCH: "Итог заказа не сходится с расчётом сервера", TERMINAL_REVOKED: "Касса отключена администратором", REFUND_EXCEEDS_PAID: "Сумма возврата больше оплаченного", ORDER_NOT_PAID: "По заказу нет оплат для возврата",
    INVALID_STATUS_TRANSITION: "Это действие недоступно в текущем статусе — обновите страницу", BUSINESS_RULE: "Действие невозможно", QUOTA_EXCEEDED: "Квота исчерпана — подключите пакет в разделе «Подписка»",
    row: "Строка {{n}}",
    detail: {
      stock: "{{product}}: есть {{available}}, нужно {{required}}", stockAt: "{{product}} ({{warehouse}}): есть {{available}}, нужно {{required}}",
      creditOff: "Клиенту не разрешена оплата в долг", credit: "Лимит {{limit}}, долг сейчас {{balance}}, новый долг {{amount}}",
      cash: "В кассе {{expected}}, нужно {{amount}}", due: "Осталось оплатить {{due}}", depositLeft: "Доступно из депозита {{available}}",
      refund: "Можно вернуть не больше {{available}}", deposit: "Нужно внести {{required}}, внесено {{paid}}", discount: "Сумма позиций, на которые разрешена скидка, — {{base}}",
      unavailable: "Недоступно: {{items}}", permission: "Нужно право: {{perms}}. Обратитесь к администратору", retry: "Попробуйте через {{min}} мин",
      quota: "Нужно {{needed}}, осталось {{remaining}}", unit: "{{product}}: «{{unit}}» не переводится в «{{base}}»", limit: "Лимит тарифа: {{max}}",
    },
  },
  /** Тексты должны совпадать с сообщениями схем @cafe/shared — по ним ищется перевод ({{x}} — переменная часть). */
  validation: {
    purchaseLine: "Выберите продукт или напишите название", purchaseDocNotFound: "Закупка не найдена в этом филиале",
    geoLat: "Укажите широту", geoLng: "Укажите долготу", geoLatRange: "Широта — от −90 до 90", geoLngRange: "Долгота — от −180 до 180", geoPair: "Укажите и широту, и долготу",
    socialWhatsapp: "Номер WhatsApp в формате +996XXXXXXXXX или ссылка", socialHandle: "Ссылка или имя аккаунта (@name)",
    lossRequired: "Укажите потери", lossMin: "Не меньше нуля", lossOnlyReceipt: "Потери — только для закупки", lossPercentMax: "Потери меньше 100%", lossQtyMax: "Потери меньше количества",
    bulkPick: "Выберите хотя бы одну запись", bulkMax: "Не больше 500 записей за раз", bulkWhat: "Выберите, что изменить", intOnly: "Введите целое число", nonZeroChange: "Изменение не может быть нулевым", bulkPercent: "Процент — от −90 до 500",
    codeRequired: "Введите код из письма",
    code6: "Код — 6 цифр", codeWrong: "Неверный код", codeExpired: "Код устарел или не запрошен — отправьте новый",
    codeTooMany: "Слишком много неверных попыток — отправьте новый код", resetLinkExpired: "Ссылка недействительна или устарела — запросите сброс ещё раз",
    nothingToPay: "Нечего выплачивать",
    tipsPeriodTaken: "За этот период чаевые уже распределены",
    tipsEmpty: "За период нет чаевых",
    noShiftParticipants: "Нет сотрудников со сменами в периоде",
    dismissSelf: "Нельзя уволить себя",
    positionNotFound: "Должность не найдена",
    debtNotFound: "Открытый долг не найден",
    customerNotFound: "Клиент не найден",
    diffReason2: "Опишите причину расхождения",
    periodMax3: "Период не больше 3 месяцев",
    periodMax2: "Период не больше 2 месяцев",
    endAfterStart2: "Окончание позже начала",
    nonZero: "Сумма не может быть 0",
    diffReason: "Опишите причину расхождения",
    selectProduct: "Выберите продукт", expenseCategory: "Выберите категорию", amountPositive: "Сумма должна быть больше нуля", qtyRequired: "Укажите количество", qtyPositive: "Количество должно быть больше нуля", unknownUnit: "Неизвестная единица", reasonSelect: "Выберите причину", amountRequired: "Укажите сумму", linesRequired: "Добавьте хотя бы одну строку", productNotFound: "Продукт не найден",
    refundPositive: "Сумма возврата больше 0",
    reasonRequired: "Укажите причину",
    refundTarget: "Укажите оплату или способ возврата",
    dateFormat: "Дата в формате ГГГГ-ММ-ДД",
    periodOrder: "Конец периода раньше начала",
    periodMax: "Период не больше года",
    endAfterStart: "Окончание позже начала",
    paymentPositive: "Сумма оплаты больше 0",
    reasonComment: "Опишите причину", tableRequired: "Для заказа в зале выберите стол",
    required: "Обязательное поле", minChars: "Минимум {{n}} символов", maxChars: "Максимум {{n}} символов", min2: "Минимум 2 символа",
    invalidId: "Некорректный идентификатор", phoneFormat: "Телефон в формате +996XXXXXXXXX", invalidEmail: "Некорректный email",
    slugChars: "Только латиница, цифры и дефис", pinFormat: "PIN — 4–6 цифр", passwordMin: "Пароль — минимум 10 символов",
    siteSlugFormat: "Поддомен: 3–40 символов, латиница, цифры и дефис", siteSlugReserved: "Это служебный адрес — выберите другой поддомен",
    passwordMax: "Пароль — максимум 128 символов", passwordChars: "Пароль должен содержать буквы и цифры",
    currencyCode: "Код валюты ISO 4217", countryCode: "Код страны ISO 3166-1", moneyInteger: "Сумма должна быть целой (minor units)",
    invalidQty: "Некорректное количество", unknownTz: "Неизвестный часовой пояс", timeFormat: "Формат ЧЧ:ММ",
    formatsRequired: "Выберите хотя бы один формат", taxId: "ИНН — 10–14 цифр", pct: "От 0 до 99.99", sku: "Латиница, цифры, . _ - (до 64)",
    barcode: "Штрихкод — 6–14 цифр", invalidPrice: "Некорректная цена", oldPrice: "Старая цена должна быть больше текущей",
    productRequired: "Для товара выберите складской продукт", oneDefaultVariant: "Вариант по умолчанию — только один",
    duplicateVariants: "Названия вариантов повторяются", modifiersRequired: "Добавьте хотя бы один модификатор",
    maxGteMin: "Максимум не меньше минимума", singleMax: "Для одиночного выбора максимум = 1",
    minTooHigh: "Минимум больше числа активных модификаторов", modifierQty: "Укажите количество списания для модификатора с продуктом",
    positive: "Больше 0", loginFormat: "Введите email или телефон в формате +996…", loginRequired: "Введите email или телефон",
    passwordRequired: "Введите пароль", ingredientRequired: "Выберите продукт или полуфабрикат",
    passwordNeedsContact: "Для входа по паролю нужен email или телефон", passwordOrPin: "Задайте пароль или PIN",
    activationCode: "Код активации — 8 символов", assignRole: "Назначьте хотя бы одну роль", invalidDate: "Некорректная дата",
    acceptTerms: "Необходимо принять условия оферты", seatsMin: "От 1 места", numberRequired: "Укажите номер", copyFactor: "Коэффициент от 0.01 до 100", copyTargets: "Выберите, куда копировать",
    goalTargetPositive: "Цель должна быть больше нуля", goalTargetInteger: "Цель — целое число", goalDates: "Укажите даты цели", goalItemOnly: "Позиция или категория — только для цели по количеству блюд", goalItemOrCategory: "Выберите позицию или категорию",
  },
  shell: {
    sections: "Разделы", home: "На главную", logo: "Логотип", skipToContent: "К содержимому", workScreens: "Рабочие экраны", hideLabels: "Скрыть подписи", showLabels: "Показать подписи",
  },
  guards: {
    noAccess: "Недостаточно прав",
    noAccessHint: "Обратитесь к владельцу или управляющему, чтобы получить доступ к разделу.",
    featureLocked: "Функция «{{feature}}» не входит в текущий тариф. Подключите дополнительную услугу или смените тариф.",
    soonTitle: "{{title}} — в разработке",
    soonHint: "Раздел появится в одном из ближайших обновлений по плану внедрения.",
  },
  auth: {
    twoFactorTitle: "Код подтверждения",
    twoFactorHint: "Откройте приложение-аутентификатор (Google Authenticator, Яндекс Ключ и т. п.) и введите 6 цифр.",
    twoFactorBackupHint: "Введите один из резервных кодов, сохранённых при включении защиты. Каждый код действует один раз.",
    twoFactorCodeLabel: "Код из приложения",
    twoFactorBackupLabel: "Резервный код",
    twoFactorCodeFormat: "Код — 6 цифр",
    twoFactorBackupFormat: "Резервный код — 8 символов, например abcd-efgh",
    twoFactorConfirm: "Войти",
    twoFactorUseBackup: "Нет доступа к приложению? Резервный код",
    twoFactorUseApp: "Ввести код из приложения",
    twoFactorWrong: "Неверный код",
    twoFactorExpired: "Время на ввод кода истекло — войдите заново",
    forgotTitle: "Восстановление пароля",
    forgotDescription: "Укажите email — пришлём ссылку для нового пароля.",
    forgotSentTitle: "Проверьте почту",
    forgotSent: "Если {{email}} зарегистрирован, на него придёт ссылка. Она действует 30 минут.",
    forgotAgain: "Запросить ссылку ещё раз",
    backToLogin: "Вернуться ко входу",
    forgotSend: "Отправить ссылку",
    resetTitle: "Новый пароль",
    resetDescription: "Придумайте новый пароль. После сохранения войдите заново на всех устройствах.",
    resetNoToken: "Ссылка неполная или устарела. Запросите новую.",
    newPassword: "Новый пароль",
    passwordRules: "Минимум 10 символов, буквы и цифры",
    resetSave: "Сохранить пароль",
    resetDone: "Пароль изменён — войдите с новым паролем",
    emailField: "Email",
    loginTitle: "Вход в систему",
    loginDescription: "Заказы, кухня, склад и аналитика вашего заведения в одном месте.",
    terms: "Пользовательское соглашение",
    loginField: "Email или телефон",
    loginPlaceholder: "owner@cafe.kg или +996…",
    password: "Пароль",
    passwordPlaceholder: "Введите пароль",
    forgot: "Забыли пароль?",
    forgotHint: "Восстановление пароля появится в ближайшем обновлении. Обратитесь к владельцу заведения.",
    signIn: "Войти",
    noAccount: "Нет аккаунта?",
    chooseCompany: "Выберите компанию",
    chooseCompanyHint: "Этот логин есть в нескольких заведениях",
    registerTitle: "Подключить заведение",
    registerDescription: "14 дней полного доступа бесплатно. Карта не нужна.",
    haveAccount: "Уже есть аккаунт?",
    companyName: "Название заведения",
    companyNamePlaceholder: "Кофейня «Утро»",
    yourName: "Ваше имя",
    yourNamePlaceholder: "Айбек Асанов",
    phoneHint: "Для уведомлений и восстановления доступа",
    passwordHint: "Минимум 10 символов, буквы и цифры",
    newPasswordPlaceholder: "Придумайте пароль",
    acceptBefore: "Принимаю",
    acceptLink: "условия оферты",
    acceptAfter: "и политику обработки персональных данных",
    startFree: "Начать бесплатно",
    registerCodeTitle: "Подтвердите email",
    registerCodeDescription: "Мы отправили код из 6 цифр на {{email}}. Он действует 10 минут.",
    registerCodeLabel: "Код из письма",
    registerCodeHint: "Не пришло? Проверьте папки «Спам» и «Промоакции».",
    registerConfirm: "Подтвердить",
    registerResend: "Отправить код ещё раз",
    registerResendIn: "Отправить ещё раз через {{sec}} с",
    registerCodeSent: "Код отправлен на {{email}}",
    registerChangeData: "Изменить данные",
    forgotSelfSent: "Ссылка для нового пароля отправлена на {{email}}",
    forgotNoEmail: "У вас не указан email — попросите администратора задать новый пароль в разделе «Сотрудники».",
  },
  terminal: {
    mode: "Режим",
    modeLogin: "Вход",
    modeClock: "Отметить смену",
    clockTitle: "Приход и уход",
    clockHint: "Введите PIN — приход или уход отметится автоматически",
    clockedIn: "{{name}}: приход отмечен",
    clockedOut: "{{name}}: уход отмечен, отработано {{h}}",
    mark: "Отметить",
    activateTitle: "Активация терминала",
    activateDescription: "Введите одноразовый код из раздела «Настройки → Терминалы».",
    code: "Код активации",
    activate: "Активировать",
    wrongPin: "Неверный PIN",
    terminal: "Терминал",
    pinTitle: "Вход по PIN",
    pinHint: "Введите свой PIN-код, чтобы начать смену",
    digitsEntered: "Введено цифр: {{count}}",
    erase: "Стереть",
    managerTitle: "Вход менеджера",
    managerHint: "PIN нужен, только чтобы вернуть заказ в работу. Повара работают на экране кухни без входа.",
    backToScreen: "Вернуться к экрану",
    appDevice: "Это касса Kafe Coco — её привязывают в приложении Kafe Coco кодом из «Терминалов», а не в браузере.",
    unsupported: "Этот тип устройства пока не работает в браузере. Создайте кассу, экран кухни или экран готовности.",
    screenFailed: "Экран не запустился",
    revoked: "Устройство отключено — активируйте его заново кодом из «Терминалов».",
  },
  dashboard: {
    hello: "Здравствуйте, {{name}}!",
    sectionsHint: "Нажмите на раздел, чтобы увидеть его страницы",
    pages: "Страниц: {{count}}",
  },
  currencies: { KGS: "кыргызский сом", KZT: "тенге", UZS: "узбекский сум", RUB: "рубль", TJS: "сомони", USD: "доллар США", EUR: "евро" },
  formats: { dine_in: "В зале", takeaway: "С собой", delivery: "Доставка", self_service: "Самообслуживание" },
  branches: {
    description: "Точки продаж компании: адреса, часы работы, форматы обслуживания.",
    add: "Добавить филиал", create: "Создать филиал", newTitle: "Новый филиал", editTitle: "Филиал «{{name}}»",
    searchPlaceholder: "Название или город", empty: "Филиалов пока нет",
    deleteTitle: "Удалить филиал «{{name}}»?", deleteHint: "Филиал будет скрыт из всех списков. История продаж сохранится.", deleted: "Филиал удалён",
    tabMain: "Основное", tabHours: "Часы работы",
    namePlaceholder: "Центральный", slug: "Адрес в ссылке (slug)", slugHint: "Используется в адресе сайта и QR-меню",
    city: "Город", cityPlaceholder: "Бишкек", address: "Адрес", addressPlaceholder: "ул. Киевская, 77",
    timezone: "Часовой пояс", currency: "Валюта", dayCutoff: "Переход бизнес-дня", dayCutoffHint: "Продажи до этого времени относятся к предыдущему дню",
    formats: "Форматы работы", formatsShort: "Форматы", tzCurrency: "Пояс / валюта", working: "Работает",
    isActive: "Филиал работает", isActiveHint: "Отключённый филиал не принимает заказы и не учитывается в лимите тарифа",
    hoursError: "Проверьте время: формат ЧЧ:ММ", dayOff: "Выходной",
    opens: "{{day}}: открытие", closes: "{{day}}: закрытие",
    overnightHint: "Закрытие раньше открытия означает работу после полуночи (например, 10:00 — 02:00).",
    days: { mon: "Понедельник", tue: "Вторник", wed: "Среда", thu: "Четверг", fri: "Пятница", sat: "Суббота", sun: "Воскресенье" },
  },
  users: {
    description: "Доступ к ERP по паролю, к терминалам — по PIN. Роли назначаются по филиалам.",
    add: "Добавить сотрудника", newTitle: "Новый сотрудник", added: "Сотрудник добавлен",
    searchPlaceholder: "Имя, телефон или email", allStatuses: "Все статусы", activeMany: "Активные", blockedMany: "Заблокированные",
    employee: "Сотрудник", you: "(вы)", contacts: "Контакты", roles: "Роли", role: "Роль", login: "Вход", lastLogin: "Последний вход",
    allBranchesLower: "все филиалы",
    status: { active: "Активен", blocked: "Заблокирован", invited: "Приглашён" },
    notFound: "Никого не найдено", empty: "Сотрудников пока нет",
    resetPin: "Сбросить PIN", resetPassword: "Сбросить пароль",
    sendResetLink: "Отправить ссылку для сброса пароля", resetLinkSent: "Ссылка для нового пароля отправлена на {{email}}",
    emailCodeLabel: "Код из письма сотруднику", emailCodeHint: "Нажмите «Отправить код» — код придёт на этот email. Попросите сотрудника назвать его.", sendCode: "Отправить код", resendIn: "Ещё раз через {{sec}} с", codeSent: "Код отправлен на {{email}}",
    block: "Заблокировать", blockTitle: "Заблокировать {{name}}?", blockHint: "Все сеансы сотрудника будут завершены немедленно, вход станет невозможен.",
    blocked: "Сотрудник заблокирован", unblock: "Разблокировать", unblocked: "Сотрудник разблокирован",
    deleteTitle: "Удалить {{name}}?", deleteHint: "Сотрудник исчезнет из списков, история его действий сохранится.", deleted: "Сотрудник удалён",
    fullName: "Имя и фамилия", fullNamePlaceholder: "Асель Токтогулова",
    access: "Способ входа", accessHint: "PIN — быстрый вход на терминале филиала. Пароль — вход в ERP (учитывается в лимите пользователей тарифа).",
    accessOptions: { pin: "Только PIN", password: "Пароль (ERP)", both: "Пароль и PIN" },
    pin: "PIN-код", pinHint: "4–6 цифр, уникален в компании",
    chooseRole: "Выберите роль", chooseBranch: "Выберите филиал", checkRoles: "Проверьте роли", assignRole: "Назначьте хотя бы одну роль",
    addRole: "Добавить роль", removeRole: "Убрать роль",
    newPin: "Новый PIN", newPassword: "Новый пароль", pinLabel: "PIN-код (4–6 цифр)", passwordLabel: "Пароль (≥ 10 символов, буквы и цифры)",
    pinChanged: "PIN изменён", passwordChanged: "Пароль изменён, все сессии сотрудника завершены",
  },
  notifications: {
    bell: "Уведомления",
    bellUnread: "Уведомления: новых {{n}}",
    title: "Уведомления",
    settings: "Настройки",
    readAll: "Прочитать все",
    new: "новое",
    empty: "Уведомлений пока нет",
    emptyHint: "Здесь появятся сводки смен, остатки, возвраты и QR-заказы.",
    settingsTitle: "Уведомления",
    settingsDescription: "Куда и какие уведомления присылать. Важное всегда видно в колокольчике в шапке.",
    telegramHint: "Подключите свой Telegram: бот {{bot}} будет присылать уведомления, доступные вашей роли.",
    telegramLinked: "Подключён {{user}}",
    telegramNotLinked: "Не подключён",
    telegramNotInPlan: "Telegram-уведомления доступны в тарифе Pro или с дополнением «Telegram».",
    telegramConnect: "Подключить Telegram",
    telegramRelink: "Подключить другой чат",
    telegramUnlink: "Отключить",
    telegramUnlinkTitle: "Отключить уведомления в Telegram?",
    telegramOpened: "Откройте Telegram и нажмите «Start» в чате с ботом",
    refresh: "Обновить статус",
    linkedAt: "Подключено {{at}}",
    channels: "Каналы",
    channelTelegram: "Сообщения от бота",
    channelEmail: "Письма на {{email}}",
    noEmail: "У вас не указан email",
    dailyReport: "Дневной отчёт",
    dailyReportHint: "Итоги дня по вашим филиалам вечером: выручка, чеки, топ блюд, списания.",
    types: "Что присылать",
    typesHint: "Включите нужные уведомления и выберите, куда их присылать. Список зависит от прав вашей роли.",
    typesEmpty: "Для вашей роли уведомлений нет",
    typesEmptyHint: "Уведомления появятся, когда вам дадут права (например, касса, склад или аналитика).",
    fromCoca: "От Coca",
    whatsNew: "Новое в Coca",
    open: "Открыть",
    typeLabels: {
      "stock_request": "Заявки на склад от филиалов",
      purchase_request: "Новые заявки на закупку",
      purchase_decision: "Мои заявки на закупку: решение и покупка",
      "stock_expiring": "Сроки годности: просрочено и истекает",
      stock_low: "Заканчиваются продукты",
      shift_closed: "Закрытие кассовой смены (Z-сводка)",
      refund_created: "Возвраты",
      report_daily: "Дневной отчёт",
      order_qr: "Новые QR-заказы",
      table_call: "Вызов официанта и просьба счёта (QR)",
      supplier_due: "Оплата поставщикам (просрочено и срок сегодня–завтра)",
      support_reply: "Ответы поддержки на ваши обращения",
      support_access: "Запросы поддержки Coca на вход в кабинет",
      fraud_alert: "Подозрительные действия сотрудников",
      sms_quota: "Квота SMS: 80% и 100%",
      goal_achieved: "Выполненные цели команды",
      achievement_earned: "Мои цели и достижения",
      waiter_table: "Мои столы: назначен или передан стол",
      platform_message: "Сообщения от Coca",
      platform_update: "Новые функции Coca",
    },
  },
  security: {
    title: "Безопасность",
    description: "Защита входа в аккаунт и активные сеансы.",
    twoFactor: "Двухфакторная защита",
    twoFactorHint: "При входе кроме пароля нужен код из приложения на телефоне.",
    on: "Включена",
    off: "Выключена",
    recommend: "Рекомендуем владельцу и администраторам: даже если пароль утечёт, без телефона войти не получится.",
    enable: "Включить",
    enableTitle: "Включить двухфакторную защиту",
    enableHint: "Отсканируйте QR-код в приложении-аутентификаторе и введите код, который оно покажет.",
    qrAlt: "QR-код для приложения-аутентификатора",
    manualKey: "Или введите ключ вручную:",
    enabledToast: "Двухфакторная защита включена",
    enabledAt: "Включена {{at}}. Осталось резервных кодов: {{n}}.",
    fewCodes: "Резервных кодов почти не осталось — создайте новые.",
    regen: "Новые резервные коды",
    regenTitle: "Новые резервные коды",
    regenHint: "Старые коды перестанут действовать. Введите код из приложения.",
    disable: "Отключить",
    disableTitle: "Отключить двухфакторную защиту?",
    disableHint: "Введите пароль и код из приложения (или резервный код).",
    disabledToast: "Двухфакторная защита отключена",
    codeOrBackup: "Код из приложения или резервный",
    backupTitle: "Резервные коды",
    backupHint: "Сохраните их в надёжном месте: они нужны, если телефон потерян. Каждый код — один вход. Больше они показаны не будут.",
    copy: "Скопировать",
    copied: "Коды скопированы",
    download: "Скачать",
    saved: "Я сохранил коды",
    sessions: "Активные сеансы",
    sessionsHint: "Где выполнен вход в ваш аккаунт.",
    current: "этот",
    lastUsed: "активность {{at}}",
    unknownDevice: "Неизвестное устройство",
    revoke: "Завершить",
    revokeTitle: "Завершить этот сеанс?",
    logoutAll: "Выйти на всех устройствах",
    logoutAllTitle: "Выйти на всех устройствах?",
    logoutAllHint: "Все сеансы, включая этот, будут завершены.",
  },
  approval: {
    descriptionVoid: "Позиция уже на кухне — удалить её может менеджер. Попросите его ввести свой PIN.",
    title: "Нужно подтверждение менеджера",
    description: "{{action}}: {{value}} — больше вашего лимита ({{limit}}). Попросите менеджера ввести свой PIN.",
    confirm: "Подтвердить",
    pin: "PIN менеджера",
    pinFormat: "PIN — 4–6 цифр",
    wrongPin: "Неверный PIN",
    noRight: "У этого сотрудника нет права подтвердить такое действие",
    self: "Подтвердить может только другой сотрудник",
    hint: "Подтверждение одноразовое и действует 2 минуты. В журнале будут оба сотрудника.",
    actions: {
      order_discount: "Скидка",
      order_void: "Удаление позиции",
      payment_refund: "Возврат",
      stock_writeoff: "Списание",
      cash_cash_out: "Изъятие из кассы",
    },
  },
  roles: {
    limitsTitle: "Лимиты без подтверждения",
    limitsHint: "Выше лимита действие подтверждает менеджер своим PIN. Пусто — без ограничения.",
    limitEmpty: "Пусто — без ограничения",
    limits: {
      orders_discount: "Скидка, не больше",
      payments_refund: "Возврат, не больше",
      stock_documents_create: "Списание, не дороже",
      cash_shifts_cash_out: "Изъятие из кассы, не больше",
    },
    description: "Набор прав сотрудника. Нельзя выдать роль с правами шире ваших собственных.",
    newTitle: "Новая роль", created: "Роль создана", updated: "Роль обновлена", deleted: "Роль удалена", deleteTitle: "Удалить роль «{{name}}»?",
    empty: "Ролей нет", system: "Системная", systemHint: "Системная роль — шаблон платформы, можно изменить права для вашей компании",
    stats: "Прав: {{perms}} · Сотрудников: {{users}}", scopeCompany: "Вся компания",
    ownerReadOnly: "Роль владельца не редактируется", ownerReadOnlyHint: "У владельца всегда полный доступ, включая подписку.",
    namePlaceholder: "Старший кассир", scope: "Действует", scopeFixed: "Область роли задаётся при создании",
    scopeHint: "На весь бизнес — для бухгалтера, аудитора; на филиал — для кассира, повара",
    inBranch: "В филиале", inCompany: "Во всей компании", permissions: "Права",
    findSection: "Найти раздел", selectedCount: "Выбрано прав: {{count}}",
  },
  systemRoles: {
    owner: "Владелец", company_admin: "Администратор компании", branch_manager: "Управляющий филиалом", accountant: "Бухгалтер",
    cashier: "Кассир", waiter: "Официант", cook: "Повар", auditor: "Аудитор", courier: "Курьер",
  },
  permResources: {
    report_resets: "Сброс отчётов",
    purchase_requests: "Заявки на закупку",
    waiter_zones: "Официанты по залам",
    goals: "Цели и достижения",
    "stock_transfers": "Перемещения",
    "production": "Производство",
    tips: "Чаевые",
    dashboard: "Дашборд", pos: "POS", orders: "Заказы", tables: "Столы", halls: "Залы", kitchen: "Кухня", menu: "Меню",
    stop_list: "Стоп-лист", recipes: "Рецептуры", costing: "Калькуляция", warehouses: "Склады", stock: "Остатки",
    stock_documents: "Складские документы", inventory_counts: "Инвентаризация", suppliers: "Поставщики", supplier_payments: "Оплаты поставщикам", customers: "Клиенты", debts: "Долги",
    payments: "Оплаты", cash_shifts: "Кассовые смены", reservations: "Брони", employees: "Сотрудники", work_shifts: "Рабочие смены", payroll: "Зарплата",
    expenses: "Расходы", analytics: "Аналитика", reports: "Отчёты", settings: "Настройки", branches: "Филиалы",
    users: "Пользователи", roles: "Роли", devices: "Терминалы", audit: "Аудит", subscription: "Подписка", support: "Поддержка", fraud: "Защита от злоупотреблений", sms: "SMS-рассылки", services: "Услуги и аренда", banquets: "Банкеты", promotions: "Акции", deliveries: "Доставка",
  },
  permActions: {
    "receive": "Приёмка",
    "complete": "Проведение выпуска",
    adjust: "Корректировка", write_off: "Списание", x_report: "X-отчёт", calculate: "Расчёт", pay: "Выплата", grant_access: "Доступ для поддержки",
    view: "Просмотр", create: "Создание", update: "Изменение", delete: "Удаление", manage: "Управление", approve: "Подтверждение",
    cancel: "Отмена", refund: "Возврат", discount: "Скидки", void: "Аннулирование", reopen: "Переоткрытие", transfer: "Перенос",
    merge: "Объединение", split: "Разделение", price_override: "Изменение цены", credit_sale: "Продажа в долг", print: "Печать",
    export: "Экспорт", post: "Проведение", unpost: "Отмена проведения", open_shift: "Открытие смены", close_shift: "Закрытие смены",
    cash_in: "Внесение", cash_out: "Изъятие", finance: "Финансы", assign: "Назначение",
  },
  venue: {
    title: "Заведение «{{name}}»: валюта и налог", description: "Настройки текущего филиала для касс Kafe Coco — изменения приходят на кассы за несколько секунд.",
    currency: "Валюта", currencyHint: "Сменить можно, только когда нет открытых заказов", symbolPosition: "Символ валюты", before: "Перед суммой", after: "После суммы",
    taxRate: "Ставка налога, %", taxIncluded: "Налог включён в цену", taxIncludedHint: "Выключите, если налог начисляется сверху на сумму чека",
  },
  company: {
    description: "Реквизиты и региональные настройки по умолчанию для новых филиалов.",
    legalName: "Юридическое название", legalNamePlaceholder: "ОсОО «…»", taxId: "ИНН",
    defaultLocale: "Язык по умолчанию", baseCurrency: "Базовая валюта", baseCurrencyHint: "Меняется через поддержку — влияет на отчёты",
  },
  geo: {
    tab: "На карте",
    cardTitle: "Контакты и места на карте",
    cardDescription: "Гости находят вас на странице «Рядом» сайта Coca: точки филиалов на карте, контакты и действующие акции. На вашем сайте появится кнопка «Маршрут».",
    openNearby: "Открыть «Рядом»",
    onMap: "На карте",
    notOnMap: "Не указано",
    set: "Указать на карте",
    noAddress: "Адрес не указан",
    modalTitle: "{{name}} на карте",
    branchHint: "Нажмите на карту или перетащите метку туда, где вход в заведение. Точка видна гостям на странице «Рядом» сайта Coca и в кнопке «Маршрут» на вашем сайте.",
    contactsHint: "Телефон, email и соцсети (Instagram, WhatsApp, Telegram…) для гостей заполняются в разделе «Сайт и QR-меню».",
    contactsLink: "Заполнить контакты",
    findAddress: "Найти по адресу",
    myLocation: "Моё местоположение",
    clear: "Убрать точку",
    noPoint: "Точка не указана",
    hint: "Клик по карте — поставить метку",
    mapAria: "Карта: выберите место филиала",
    notFound: "Адрес не найден — поставьте метку на карте вручную",
    denied: "Не удалось определить местоположение — разрешите доступ к геолокации или поставьте метку вручную",
    invalid: "Точка указана неверно — поставьте метку заново",
  },

  subscription: {
    description: "Тариф, лимиты и подключённые функции. Оплата и смена тарифа — через менеджера платформы (онлайн-оплата появится позже).",
    trialLeft: "Пробный период: осталось {{count}} дн.", trialHint: "После окончания выберите тариф, чтобы продолжить работу без ограничений.",
    payHint: "Оплатите счёт, чтобы вернуть полный доступ. Продажи на кассе продолжают работать.",
    plan: "Тариф {{plan}}", features: "Функции", featuresHint: "Отмеченные доступны в вашем тарифе", available: "Доступно", unavailable: "Недоступно",
    status: {
      trialing: "Пробный период", active: "Активна", past_due: "Ожидает оплаты", read_only: "Только чтение", suspended: "Приостановлена",
      cancelled: "Отменена", expired: "Истекла", archived: "В архиве",
    },
    limits: {
      branches: "Филиалы", terminals: "Терминалы", users: "Пользователи с паролем", warehouses: "Склады", menu_items: "Позиции меню",
      ai_requests: "Запросы к Coca AI в этом месяце",
      storage_gb: "Хранилище, ГБ", report_history_days: "История отчётов, дней", api_rps: "API, запросов/с",
    },
  },
  features: {
    core: {
      pos: "Касса и заказы", menu: "Меню", tables: "Зал и столы", kds: "Экран кухни", inventory_basic: "Склад (базовый)",
      recipes: "Техкарты и себестоимость", customers: "Клиенты", debts: "Долги клиентов", staff: "Сотрудники и смены",
      payroll_basic: "Зарплата (базовая)", analytics_basic: "Отчёты (базовые)", qr_menu: "QR-меню", website: "Сайт заведения",
    },
    addon: {
      qr_ordering: "Заказ по QR-коду", online_payments: "Онлайн-оплата", inventory_pro: "Склад (расширенный)", procurement: "Закупки и заявки",
      production: "Производство", payroll_pro: "Зарплата (расширенная)", finance: "Финансы", loyalty: "Бонусы и скидки гостям",
      promotions_pro: "Акции (расширенные)", reservations: "Бронирование столов", banquets: "Банкеты", services: "Услуги и аренда",
      delivery: "Доставка", aggregators: "Сервисы доставки (Glovo и др.)", telegram: "Telegram-бот", sms: "SMS-рассылки", analytics_pro: "Отчёты (расширенные)",
      fraud: "Защита от злоупотреблений", reviews: "Отзывы гостей", custom_domain: "Свой адрес сайта", api_access: "Подключение внешних программ", offline_mode: "Работа без интернета",
      desktop: "Программа кассы для компьютера", fiscal: "Фискальные чеки", accounting_export: "Выгрузка в 1С", ai: "Умный помощник",
      white_label: "Свой бренд вместо Coca", priority_support: "Быстрая поддержка",
    },
  },
  devices: {
    download: "Скачать программу кассы:", platforms: { windows: "Windows", macos: "macOS" },
    where: "Где работает касса", whereBrowser: "В браузере", whereApp: "Программа для компьютера",
    pair: "Привязать кассу", pairTitle: "Привязка кассы", pairHint: "Откройте программу кассы на компьютере и введите код:",
    pairOneTime: "Код одноразовый. После привязки касса загрузит меню и столы этого филиала, сотрудники входят по своему PIN.",
    description: "Кассы, экраны кухни и планшеты официантов. Вход по PIN работает только на зарегистрированных устройствах.",
    add: "Добавить терминал", newTitle: "Новый терминал", getCode: "Получить код", namePlaceholder: "Касса у входа",
    type: "Тип устройства", typeShort: "Тип", activity: "Активность",
    empty: "Терминалов пока нет", emptyHint: "Добавьте кассу или экран кухни и активируйте устройство одноразовым кодом.",
    reset: "Новый код", resetTitle: "Выдать новый код для «{{name}}»?", resetHint: "Устройство сразу потеряет доступ, сеансы на нём завершатся. Введите новый код на этом же устройстве — название, филиал и номер кассы сохранятся.", resetCodeTitle: "Новый код для «{{name}}»",
    deleteTitle: "Удалить «{{name}}»?", deleteHint: "Терминал исчезнет из списка и сразу потеряет доступ, место в лимите освободится. Заказы и журнал сохранятся.", deleted: "Терминал удалён",
    revoke: "Отключить", revokeTitle: "Отключить «{{name}}»?", revokeHint: "Устройство сразу потеряет доступ, все сеансы на нём будут завершены.", revoked: "Терминал отключён",
    openBefore: "Откройте на устройстве «{{name}}» адрес", openAfter: "и введите код:",
    codeCopied: "Код скопирован", copyCode: "Скопировать код", codeValid: "Код действует ещё {{time}}", codeExpired: "Код истёк — выдайте новый: «⋯ → Новый код» у терминала",
    oneTimeHint: "Код одноразовый. После активации на устройстве сотрудники входят по своему PIN.",
    oneTimeHintScreen: "Код одноразовый. После активации экран откроется сам — PIN вводить не нужно.",
    access: { pin: "Сотрудники входят по своему PIN, дальше — их права.", screen: "Работает без PIN: после активации сразу открывается экран.", app: "Привязывается в приложении Kafe Coco на компьютере кассы." },
    status: { pending: "Ожидает активации", active: "Активен", revoked: "Отключён" },
    types: {
      pos: "Касса (POS)", kds: "Экран кухни (KDS)", waiter: "Официант", kiosk: "Киоск самообслуживания", customer_display: "Экран покупателя",
      ready_screen: "Экран готовности", printer_bridge: "Принт-сервер", desktop: "Касса (POS)", courier: "Курьер",
    },
  },
  menu: {
    description: "Позиции, категории, модификаторы и стоп-лист. Изменения видны на кассах сразу.",
    tabItems: "Позиции", tabCategories: "Категории", tabModifiers: "Модификаторы", tabStop: "Стоп-лист",
    notForSale: "Не продаётся", stop: "Стоп", remaining: "Осталось {{count}}", hiddenInBranch: "Скрыта в филиале", priceFrom: "от {{price}}",
    pricePerKg: "{{price}}/кг",
    searchItems: "Поиск по названию или артикулу", addItem: "Добавить позицию", noItems: "В меню пока нет позиций",
    createCategoryFirst: "Сначала создайте категорию", createCategoryFirstHint: "Например, «Кофе», «Горячие блюда», «Десерты» — во вкладке «Категории».",
  },
  bulk: {
    select: "Выбрать", done: "Готово", selectAll: "Выбрать все", selectPage: "Выбрать все на странице", change: "Изменить",
    onSale: "Продавать", offSale: "Снять с продажи", showPublic: "Показать в публичном меню", hidePublic: "Скрыть из публичного меню",
    allowDiscount: "Разрешить скидку", denyDiscount: "Запретить скидку", move: "Перенести в категорию…", price: "Изменить цену…",
    fromStop: "Вернуть в продажу", setPortions: "Задать остаток", stopTitle: "На стоп: {{count}} поз.",
    priceTitle: "Цена: {{count}} поз.", priceUp: "Повысить", priceDown: "Снизить", priceMode: "Как менять", pricePercent: "На процент", priceAmount: "На сумму",
    priceHint: "Цены вариантов меняются так же. Цена не станет меньше 0, старая цена сбросится, если станет не выше новой.",
    moveTitle: "Перенести {{count}} поз.", category: "Категория",
    showCategories: "Показывать", hideCategories: "Скрыть", channelsTitle: "Каналы продаж: {{count}} кат.", keep: "Не менять", show: "Показывать", hide: "Скрыть",
    deleteItemsTitle: "Удалить позиции ({{count}})?", deleteItemsHint: "Позиции пропадут с касс и сайта, история продаж сохранится.",
    deleteCategoriesTitle: "Удалить категории ({{count}})?", deleteCategoriesHint: "Удаляются только пустые категории. Если в какой-то есть позиции — ничего не удалится.",
    updated: "Изменено: {{count}}", deleted: "Удалено: {{count}}", stopped: "На стопе: {{count}}", unstopped: "Снова в продаже",
  },
  stop: {
    hint: "Действует для текущего филиала (выбран в верхней панели). Кассы и QR-меню скрывают позицию сразу.",
    add: "Поставить на стоп", added: "Позиция в стоп-листе", portionsLeft: "Осталось порций: {{count}}",
    item: "Позиция", state: "Состояние", since: "С", return: "Вернуть", backOnSale: "Снова в продаже",
    empty: "Стоп-лист пуст", emptyHint: "Все позиции доступны для продажи.",
    portions: "Осталось порций", portionsHint: "Пусто — полностью закончилась. Число — продаётся, пока не кончится",
  },
  categories: {
    title: "Категория", newTitle: "Новая категория", image: "Изображение категории", namePlaceholder: "Кофе", slug: "Адрес (slug)",
    parent: "Родительская категория", parentHint: "До 3 уровней вложенности", topLevel: "Верхний уровень",
    channels: "Где показывать", channel: { pos: "Касса", qr: "QR-меню", website: "Сайт", delivery: "Доставка" }, visible: "Категория видна",
    deleteTitle: "Удалить категорию «{{name}}»?", deleted: "Категория удалена", itemsCount: "{{count}} поз.", hidden: "Скрыта",
    subcategory: "Подкатегория", empty: "Категорий пока нет", emptyHint: "Например: Кофе, Напитки, Горячие блюда, Десерты.",
  },
  modifiers: {
    saved: "Группа сохранена", notSelected: "Не выбран", newTitle: "Новая группа модификаторов", newGroup: "Новая группа",
    usedIn: "Группа используется в {{count}} поз. Открытые заказы сохраняют прежние модификаторы.",
    groupName: "Название группы", groupNamePlaceholder: "Добавки / Молоко / Прожарка",
    selection: "Выбор", selectionType: "Тип выбора", single: "Один вариант", multiple: "Несколько",
    min: "Минимум", minHint: "≥ 1 — обязательная группа", max: "Максимум", maxHint: "Пусто — без ограничения",
    free: "Бесплатно, шт", freeHint: "Первые N — без доплаты", allowQuantity: "Можно выбрать несколько штук одного (×2 сыра)",
    namePlaceholder: "Сыр", writeOff: "Списывать продукт", product: "Продукт", quantity: "Количество (в базовой ед.)",
    replaces: "Заменяет ингредиент", replacesHint: "Например, растительное молоко вместо коровьего", replaced: "Заменяемый",
    removes: "Исключает ингредиент", removesHint: "«Без лука»", removed: "Исключаемый",
    kitchenLabel: "Метка для кухни", kitchenLabelPlaceholder: "+сыр", isDefault: "Выбран по умолчанию", add: "Добавить модификатор",
    required: "Обязательная", optional: "По желанию", one: "Один", upTo: "До {{max}}", inItems: "В {{count}} поз.",
    deleteTitle: "Удалить группу «{{name}}»?", empty: "Групп модификаторов нет", emptyHint: "Добавки, выбор молока, степень прожарки, «без лука».",
  },
  items: {
    title: "Позиция меню", newTitle: "Новая позиция", newSaved: "Новая позиция (сохранена)",
    saved: "Позиция сохранена", createdNext: "Позиция создана — теперь можно составить ТТК",
    onSale: "В продаже", onSaleHint: "Отключённая позиция не продаётся нигде", visiblePublic: "Видна гостям", visiblePublicHint: "QR-меню и сайт",
    allowDiscount: "Разрешены скидки", isWeighted: "Продажа на вес",
    isWeightedHint: "Плов, рыба, салаты на развес: цена — за 1 кг, на кассе вводится вес в граммах или килограммах", pricePerKg: "Цена за 1 кг", recipeWeighted: "Позиция продаётся на вес: выход ТТК — в килограммах. Например, казан плова на 12 кг — выход 12; продажа 450 г спишет 0,45 / 12 от продуктов казана.",
    basePricePlaceholder: "Базовая: {{price}}", branchPrice: "Цена в филиале {{name}}",
    branchesHint: "Базовая цена общая для компании. В филиале можно скрыть позицию или задать свою цену — пустое поле означает базовую (BR-052).",
    photo: "Фото позиции", namePlaceholder: "Латте", oldPrice: "Старая цена (зачёркнутая)", sku: "Артикул",
    stockProduct: "Складской продукт", stockProductHint: "Списывается напрямую при продаже, без ТТК",
    weight: "Вес, г", volume: "Объём, мл", calories: "Калорийность, ккал", cookingTime: "Время приготовления, мин",
    descriptionPlaceholder: "Состав и подача — видно гостям в QR-меню и на сайте",
    posTags: "Теги кассы", posTagsHint: "Быстрые фильтры на кассе Kafe Coco; новый тег — наберите название", barcodes: "Штрихкоды", barcodesHint: "Для сканера на кассе: введите код и нажмите Enter", barcodePlaceholder: "4600000000017", removeBarcode: "Удалить штрихкод {{code}}",
    tagsLabel: "Метки", allergensLabel: "Аллергены",
    minAge: "Возрастное ограничение", minAgeHint: "Для алкоголя и табака кассир подтверждает возраст (BR-049)",
    variants: "Варианты", variantsHint: "Размеры и объёмы со своей ценой (S/M/L, 25/30/40 см). Без вариантов продаётся по основной цене.",
    variantPlaceholder: "Например, 300 мл", variantName: "Название варианта", variantPrice: "Цена варианта", byDefault: "По умолчанию",
    deleteVariant: "Удалить вариант", addVariant: "Добавить вариант",
    modifierGroups: "Группы модификаторов", modifierGroupsHint: "Добавки, прожарка, молоко. Обязательные группы кассир не сможет пропустить (BR-025).",
    noneSelected: "Не выбраны", groupSummary: "{{count}} шт · {{kind}}",
    recipe: "ТТК", recipeFirst: "Сначала создайте позицию — затем составьте технологическую карту.",
    types: { dish: "Блюдо", drink: "Напиток", product: "Товар", service: "Услуга", combo: "Комбо", modifier_only: "Только модификатор" },
    tags: { new: "Новинка", hit: "Хит", spicy: "Острое", vegan: "Веган", vegetarian: "Вегетарианское", halal: "Халяль" },
    allergens: {
      gluten: "Глютен", lactose: "Лактоза", eggs: "Яйца", nuts: "Орехи", peanuts: "Арахис", soy: "Соя", fish: "Рыба", shellfish: "Моллюски",
      sesame: "Кунжут", celery: "Сельдерей", mustard: "Горчица", sulfites: "Сульфиты",
    },
  },
  units: { g: "г", kg: "кг", ml: "мл", l: "л", pcs: "шт", portion: "порция" },
  recipe: {
    noConversion: "Единица не переводится в единицу продукта", checkRows: "Проверьте строки ТТК", cycle: "Циклическая ссылка",
    publishTitle: "Опубликовать ТТК?", publishHint: "Новые продажи будут списываться по этой версии. Предыдущая версия уйдёт в архив, закрытые заказы не изменятся.",
    publish: "Опубликовать", published: "ТТК опубликована", discardTitle: "Отменить черновик?", discard: "Отменить черновик",
    draftV: "Черновик v{{v}}", publishedV: "Опубликована v{{v}}", none: "Нет ТТК", salesUse: "Продажи списываются по опубликованной v{{v}}",
    incomplete: "Себестоимость неполная", output: "Выход", outputUnit: "Единица выхода",
    ingredient: "Ингредиент", gross: "Брутто", unitShort: "Ед.", waste: "Отход %", loss: "Потери %", netSum: "Нетто / сумма",
    productPlaceholder: "Продукт или полуфабрикат", noPrice: "нет цены", takeawayOnly: "Только с собой", deleteRow: "Удалить строку",
    takeawayHint: "Только для «с собой» и доставки (упаковка)", addIngredient: "Добавить ингредиент",
    cost: "Себестоимость", perPortion: "За порцию", perOutput: "За выход",
    instructions: "Технология приготовления", instructionsPlaceholder: "Порядок приготовления, температура, подача",
    draftSaved: "Черновик сохранён", saveDraft: "Сохранить черновик", history: "История версий",
    statusActive: "действует", statusDraft: "черновик", statusArchive: "архив",
    owner: "Для чего ТТК", forItem: "Блюдо (общая)", variantsHint: "У каждого варианта своя ТТК. Если у варианта её нет, при продаже списывается ТТК блюда.",
    copy: "Скопировать в…", copyTitle: "Скопировать ТТК", copyAction: "Скопировать",
    copyHint: "Состав, технология и выход попадут в черновики выбранных вариантов (их черновики заменятся). Опубликуйте каждый отдельно.",
    factorFor: "Коэффициент для «{{name}}»", factorHint: "Коэффициент умножает брутто: 1 — как есть, 1.5 — на 50% больше (S → L).",
    copied: "Скопировано ТТК: {{count}}",
  },
  products: {
    description: "Ингредиенты, товары, полуфабрикаты и упаковка — основа ТТК и склада.",
    add: "Добавить продукт", newTitle: "Новый продукт", saved: "Продукт сохранён",
    searchPlaceholder: "Название, артикул или штрихкод", allTypes: "Все типы",
    empty: "Продуктов пока нет", emptyHint: "Добавьте ингредиенты с ценой закупки — себестоимость блюд посчитается автоматически.",
    namePlaceholder: "Молоко 3.2%", baseUnit: "Учёт в", baseUnitHint: "Меняется, только если продукт не в ТТК",
    baseUnits: { g: "граммы", ml: "миллилитры", pcs: "штуки" }, unitColumn: "Учёт",
    purchasePrice: "Цена закупки", purchasePriceFor: "Цена закупки за {{unit}}", perBaseHint: "= {{price}} тыйын за {{unit}}", priceAutoHint: "Обновится автоматически при приёмке",
    purchaseLoss: "Потери при закупке по умолчанию", purchaseLossHint: "Подставляется в строку закупки: кости, очистка, разморозка", purchaseLossQtyHint: "Фикс: столько {{unit}} теряется с каждой закупки (тара, лёд)", waste: "Отход по умолчанию, %", wasteHint: "Подставляется в ТТК", barcodes: "Штрихкоды", barcodesHint: "Через запятую",
    density: "Плотность, г/мл", densityHint: "Нужна, чтобы в ТТК указывать граммы для жидкостей (и наоборот)",
    shelfLife: "Срок годности, дней", minStock: "Минимальный остаток", minStockHint: "В {{unit}} — для уведомлений",
    allergensHint: "Позиции меню наследуют аллергены ингредиентов", productionRecipe: "ТТК производства",
    types: { ingredient: "Ингредиент", goods: "Товар", semi_finished: "Полуфабрикат", packaging: "Упаковка", consumable: "Расходник" },
  },
  costing: {
    descriptionGross: "Цель food cost — {{pct}}%. Себестоимость по брутто и текущим ценам закупки.",
    descriptionNet: "Цель food cost — {{pct}}%. Себестоимость по нетто и текущим ценам закупки.",
    settingsTitle: "Настройки калькуляции", settingsSaved: "Настройки сохранены",
    target: "Целевой food cost, %", targetHint: "Позиции выше цели подсвечиваются; от него считается рекомендуемая цена",
    rounding: "Округлять рекомендуемую цену до", base: "Считать стоимость ингредиентов по", baseShort: "База расчёта", net: "Нетто",
    overTarget: "Выше цели · {{count}}", noRecipe: "Без ТТК · {{count}}", costShort: "Себест.", noRecipeBadge: "нет ТТК", noPrices: "нет цен",
    margin: "Маржа", markup: "Наценка", recommended: "Рекоменд. цена",
    empty: "Нет позиций", emptyHint: "Добавьте позиции меню и составьте для них ТТК.",
    incompleteNote: "* — себестоимость неполная: у части ингредиентов нет цены закупки.",
  },
  upload: {
    photo: "Фото", chooseImage: "Выберите изображение", tooLarge: "Файл слишком большой",
    drop: "Перетащите фото или нажмите, чтобы выбрать", formats: "JPEG, PNG, WebP, HEIC · до 10 МБ", replace: "Заменить", remove: "Убрать",
  },
  tables: {
    description: "План зала текущего филиала, статусы столов и QR-коды.",
    status: { free: "Свободен", occupied: "Занят", awaiting_payment: "Ждёт оплаты", reserved: "Забронирован", cleaning: "Уборка", unavailable: "Недоступен" },
    hallTypes: { hall: "Зал", vip: "VIP", terrace: "Терраса", room: "Комната", banquet: "Банкетный", bar: "Бар" },
    shapes: { square: "Квадрат", rect: "Прямоугольник", round: "Круглый" },
    planOf: "План зала «{{name}}»", tableAria: "Стол {{number}}, {{count}} мест, {{status}}", seatsShort: "{{count}} м.",
    hall: "Зал", newHall: "Новый зал", hallPlaceholder: "Основной зал", createHall: "Создать зал",
    noHalls: "Залов пока нет", noHallsHint: "Создайте зал и расставьте столы — официанты и кассиры будут выбирать стол из плана.",
    table: "Стол {{number}}", tableShort: "Стол", newTable: "Новый стол", tableStatus: "Статус стола",
    number: "Номер", seats: "Мест", shape: "Форма", width: "Ширина", height: "Высота", rotation: "Поворот, °",
    gridTitle: "Место на кассе", gridHint: "Позиция стола в сетке схемы зала на кассе Kafe Coco. Пусто — касса расставит сама.", gridRow: "Ряд", gridColumn: "Колонка", gridSpan: "Ширина, колонок",
    nameOptional: "Название (необязательно)", namePlaceholder: "У окна", isActive: "Стол используется",
    qr: "QR-код стола", copy: "Копировать", linkCopied: "Ссылка скопирована", qrSticker: { open: "QR-код", title: "QR-код стола {{number}}", preview: "Наклейка для стола", print: "Печать", png: "Скачать PNG", table: "Стол", hintOrder: "Меню, заказ и вызов официанта", hintMenu: "Меню заведения" },
    regenerate: "Перевыпустить", regenerateTitle: "Перевыпустить QR?", regenerateHint: "Старые наклейки перестанут работать.",
    deleteTable: "Удалить стол {{number}}?", planSaved: "План зала сохранён",
    view: "Вид", plan: "План", list: "Список", savePlan: "Сохранить план", arrange: "Расставить",
    renameHall: "Переименовать зал", deleteHall: "Удалить зал", deleteHallTitle: "Удалить зал «{{name}}»?", deleteHallHint: "Столы зала тоже будут удалены.",
    statuses: "Статусы", dragHint: "Перетащите столы мышью или пальцем. Сетка — {{grid}} единиц.",
    noTables: "В зале нет столов", addTable: "Добавить стол",
  },
  orders: {
    payments: "Оплаты",
    refunds: "Возвраты",
    refund: "Оформить возврат",
    refundTitle: "Возврат по заказу {{n}}",
    refundAmount: "Сумма возврата",
    refundReason: "Причина возврата",
    refundPayment: "Оплата",
    refundAvailable: "Доступно к возврату: {{amount}}",
    refundDone: "Возврат оформлен",
    paidSum: "Оплачено",
    refundedSum: "Возвращено",
    tax: "Налог",
    taxIncluded: "В т.ч. налог",
    methods: {
      qr: "QR",
      credit: "В долг",
      cash: "Наличные",
      card: "Карта",
      deposit: "Депозит банкета",
    },
    anyPayment: "Без привязки к оплате",
    title: "Заказы",
    description: "Заказы филиала: открытые и история.",
    open: "Открытые",
    all: "Все",
    number: "Номер",
    dailyNo: "№{{n}}",
    type: "Тип",
    table: "Стол",
    tableN: "Стол {{n}}",
    items: "Позиций",
    total: "Сумма",
    opened: "Открыт",
    empty: "Заказов нет",
    emptyHint: "Новые заказы создаются на кассе",
    history: "История",
    search: "Номер или имя гостя",
    guests: "Гостей",
    guest: "Гость",
    comment: "Комментарий к заказу",
    cancel: "Отменить заказ",
    cancelTitle: "Отменить заказ {{n}}?",
    cancelHint: "Отправленные позиции будут аннулированы, кухня получит отмену.",
    reason: "Причина",
    reasonComment: "Комментарий",
    void: "Аннулировать",
    voidTitle: "Аннулировать «{{name}}»?",
    voidSentHint: "Позиция уже на кухне — повар получит отмену.",
    cancelled: "Заказ отменён",
    voided: "Позиция аннулирована",
    details: "Заказ {{n}}",
    openInPos: "Открыть на кассе",
    events: {
      line_added: "Добавлена позиция",
      qty_changed: "Изменено количество",
      payment: "Оплата",
      refund: "Возврат",
      "order.update": "Изменён",
      created: "Создан",
      items_added: "Добавлены позиции",
      item_updated: "Изменена позиция",
      item_voided: "Аннулирована позиция",
      sent_to_kitchen: "Отправлен на кухню",
      cancelled: "Отменён",
      transferred: "Перенесён на другой стол",
      updated: "Изменён",
    },
    statuses: {
      draft: "Черновик",
      open: "Открыт",
      confirmed: "Подтверждён",
      cooking: "Готовится",
      ready: "Готов",
      served: "Подан",
      paid: "Оплачен",
      completed: "Закрыт",
      cancelled: "Отменён",
      refunded: "Возврат",
      partially_refunded: "Частичный возврат",
    },
    itemStatuses: {
      new: "Новая",
      sent: "На кухне",
      accepted: "Принята",
      cooking: "Готовится",
      ready: "Готова",
      served: "Подана",
      voided: "Аннулирована",
      returned: "Возврат",
    },
    types: {
      dine_in: "В зале",
      takeaway: "С собой",
      delivery: "Доставка",
      self_service: "Самообслуживание",
      pickup: "Самовывоз",
    },
    reasons: {
      guest_mistake: "Ошибка гостя",
      waiter_mistake: "Ошибка персонала",
      long_wait: "Долгое ожидание",
      out_of_stock: "Нет в наличии",
      quality: "Качество",
      other: "Другое",
    },
  },
  pos: {
    transferWaiter: "Передать официанту",
    transfer: "Передать",
    noWaiters: "Нет официантов: добавьте их в зоны в разделе «Официанты по залам» или отметьте смену.",
    waiter: "Официант",
    pickWaiter: "Выберите официанта",
    waiterIs: "Официант: {{name}}",
    transferred: "Стол передан",
    promotions: "Акции",
    promotionsHint: "Подходящие акции посчитаются автоматически и будут пересчитываться при изменении заказа.",
    applyPromotions: "Акции",
    promotionsOn: "Акции включены",
    promotionsSwitch: "Применять акции",
    promotionsSwitchHint: "Выключите, чтобы снять все акции с заказа",
    promoCodes: "Промокоды",
    promoCodesHint: "Через запятую, например WELCOME10",
    promoCodeInvalid: "Промокод не найден или не действует",
    promotionsSaved: "Акции пересчитаны",
    discount: "Скидка",
    discountHint: "На позиции, где скидка разрешена. Выше вашего лимита — нужен PIN менеджера.",
    applyDiscount: "Применить",
    removeDiscount: "Убрать скидку",
    discountKind: "Вид скидки",
    discountPercent: "Процент",
    discountAmount: "Сумма",
    discountReason: "Причина",
    discountValueRequired: "Укажите размер скидки",
    discountPreview: "Скидка составит",
    discountSaved: "Скидка применена",
    addDiscount: "Добавить скидку",
    changeDiscount: "Изменить скидку",
    discountReasons: {
      regular: "Постоянный гость",
      compliment: "Комплимент",
      staff: "Сотрудник",
      promo: "Акция",
      complaint: "Жалоба гостя",
      other: "Другое",
    },
    pickCustomer: "Клиент",
    clearCustomer: "Убрать клиента",
    noShift: "Кассовая смена не открыта",
    noShiftHint: "Попросите кассира или управляющего открыть смену веб-кассы.",
    creditNoCustomer: "Чтобы продать в долг, выберите клиента",
    creditOverLimit: "Кредит недоступен или превышен лимит. Доступно: {{left}}",
    creditInfo: "{{name}}: долг {{debt}} из лимита {{limit}}",
    reference: "RRN или последние 4 цифры",
    referenceHint: "Необязательно — для сверки с терминалом",
    payTitle: "Оплата заказа {{n}}",
    due: "К оплате",
    method: "Способ оплаты",
    amount: "Сумма оплаты",
    received: "Получено от гостя",
    tip: "Чаевые",
    change: "Сдача",
    payConfirm: "Принять {{amount}}",
    paidDone: "Заказ оплачен",
    partPaid: "Оплачено {{paid}} из {{total}}",
    tax: "Налог",
    taxIncluded: "В т.ч. налог",
    exact: "Без сдачи",
    notEnough: "Получено меньше суммы оплаты",
    paidAlready: "Оплачено",
    printReceipt: "Печать чека",
    title: "Касса",
    newOrder: "Новый заказ",
    openOrders: "Открытые заказы",
    orderHistory: "История заказов",
    reservations: "Брони",
    noOpen: "Открытых заказов нет",
    searchMenu: "Поиск по меню…",
    orderDetails: "Детали заказа",
    orderInfo: "Информация о заказе",
    customerName: "Имя гостя",
    selectTable: "Выберите стол",
    tableN: "Стол {{n}}",
    addNote: "Заметка к заказу",
    notePlaceholder: "Напишите заметку к заказу…",
    addToOrder: "Добавить в заказ",
    empty: "Добавьте позиции из меню",
    subtotal: "Подытог",
    total: "Итого",
    send: "На кухню",
    sendN: "На кухню · {{n}}",
    sent: "Отправлено на кухню",
    precheck: "Пречек",
    pay: "Оплатить",
    paySoon: "Приём оплаты появится в следующем обновлении",
    stopped: "Стоп",
    left: "Осталось {{n}}",
    modifiersTitle: "Выберите опции",
    required: "обязательно",
    upTo: "до {{n}}",
    chooseOne: "выберите один",
    quantity: "Количество",
    itemComment: "Комментарий к позиции",
    weight: "Вес", weightHint: "Цена {{price}} за 1 кг — взвесьте и введите вес", changeWeight: "Изменить вес", weightLine: "{{weight}} × {{price}}/кг", saveWeight: "Сохранить вес",
    add: "Добавить · {{price}}",
    variant: "Размер",
    course: "Курс {{n}}",
    guestsN: "Гостей: {{n}}",
    back: "Назад",
    switchUser: "Сменить пользователя",
    online: "Онлайн",
    reconnecting: "Переподключение…",
    offline: "Нет связи",
    orderReady: "Заказ №{{n}} готов",
    cart: "Заказ · {{n}}",
    tableSelect: "Выбор стола",
    noHalls: "Нет залов — создайте их в разделе «Залы и столы»",
    noOrder: "Заказ не выбран",
    quick: {
      noOnion: "без лука",
      spicy: "острее",
      noIce: "без льда",
      hot: "погорячее",
    },
  },
  kds: {
    title: "Кухня",
    station: "Станция",
    chooseStation: "Выберите станцию",
    noStations: "Нет станций — откройте «Кухонные станции»",
    new: "Новые",
    cooking: "Готовятся",
    ready: "Готово",
    start: "Начать",
    done: "Готово",
    serve: "Выдать",
    recall: "Вернуть",
    accept: "Принять",
    empty: "Нет заказов",
    emptyHint: "Новые заказы появятся здесь автоматически",
    minutes: "{{n}} мин",
    soundOn: "Звук включён",
    soundOff: "Включить звук",
    keyboardHint: "1–9 — выбрать тикет, Enter — следующий шаг",
    recalled: "Возвращено в работу",
    print: "Печать",
    repeatReadySound: "Повторить звук готовности",
    exit: "Выход",
    newTicket: "Новый заказ №{{n}}",
    managerLogin: "Вход менеджера",
  },
  readyBoard: {
    title: "Готовность заказов",
    preparing: "Готовится",
    ready: "Готово — заберите",
    empty: "Заказов пока нет",
    fullscreen: "На весь экран",
    background: "Фон табло",
    backgrounds: { white: "Белый фон", warm: "Тёплый фон", gray: "Светло-серый", graphite: "Графитовый" },
    palette: "Цветовая палитра",
    palettes: { coca: "Coca", ocean: "Океан", forest: "Изумруд", violet: "Фиолетовая" },
    voice: "Озвучка",
    enableVoice: "Включить звук",
    speech: "Заказ номер {{number}} готов",
    speechNamed: "{{name}}, ваш заказ номер {{number}} готов",
  },
  stations: {
    "warehouse": "Склад станции",
    "warehouseHint": "Продажи позиций этой станции списываются с выбранного склада",
    "mainWarehouse": "Основной склад филиала",
    title: "Кухонные станции",
    description: "Цеха и экраны кухни: куда уходят позиции заказа.",
    add: "Добавить станцию",
    type: "Тип",
    norm: "Норма приготовления, мин",
    normHint: "Тикет желтеет после нормы и краснеет после 1,5 нормы",
    simple: "Простой режим",
    simpleHint: "Кофейня: тикет сразу «Готово» одним касанием",
    isDefault: "По умолчанию",
    defaultHint: "Сюда уходят позиции без станции",
    active: "Активна",
    activeTickets: "Активных тикетов: {{n}}",
    empty: "Станций нет",
    emptyHint: "При первой отправке на кухню создастся станция «Кухня»",
    deleteTitle: "Удалить станцию «{{name}}»?",
    itemStation: "Станция кухни",
    itemStationHint: "Пусто — станция филиала по умолчанию",
    types: {
      hot: "Горячий цех",
      cold: "Холодный цех",
      bar: "Бар",
      coffee: "Кофе",
      bakery: "Выпечка",
      pizza: "Пицца",
      grill: "Гриль",
      dessert: "Десерты",
      packing: "Упаковка",
      expo: "Раздача",
    },
  },
  print: {
    document: "Документ",
    print: "Печать",
    savePdf: "Сохранить PDF",
    excel: "Скачать Excel",
    pdfHint: "В окне печати выберите «Сохранить как PDF»",
    printedAt: "Распечатано",
    precheck: "Пречек",
    notFiscal: "Не является фискальным документом",
    table: "Стол",
    guests: "Гостей",
    total: "Итого",
    thanks: "Спасибо!",
    printed: "Отправлено на печать",
    usb: {
      title: "Принтер чеков (USB)",
      description: "Чеки, пречеки, кухонные тикеты и отчёты смены печатаются сразу на принтер — без окна печати. Настройка хранится на этом устройстве.",
      menu: "Принтер чеков",
      pick: "Выбрать USB-принтер",
      change: "Другой",
      connected: "Принтер подключён",
      savedHere: "Подключён к этому устройству",
      howTo: "Подключите чековый принтер (ESC/POS) кабелем USB к этому компьютеру и нажмите кнопку ниже — браузер покажет список устройств.",
      enabled: "Печатать на USB-принтер",
      enabledHint: "Выключено — печать через окно браузера",
      paper: "Ширина ленты",
      mm: "{{n}} мм",
      cut: "Отрезать ленту после чека",
      test: "Пробная печать",
      testTitle: "Пробная печать",
      drawer: "Открыть денежный ящик",
      forget: "Отключить",
      busyHint: "Если принтер не отвечает, в Windows он занят своим драйвером: замените драйвер на WinUSB (программа Zadig). В Linux отключите модуль usblp.",
      unsupportedTitle: "Браузер не поддерживает USB-печать",
      unsupported: "Нужен Google Chrome или Microsoft Edge на компьютере и адрес по https. В Safari, Firefox и на iPhone печать — через окно браузера.",
      errors: {
        notFound: "USB-принтер не найден: проверьте кабель и питание. Печать — через окно браузера.",
        busy: "Принтер занят драйвером системы. В Windows замените драйвер на WinUSB (Zadig), в Linux отключите usblp.",
        noEndpoint: "Это устройство не похоже на чековый принтер.",
        notConfigured: "USB-принтер не выбран.",
        cancelled: "Принтер не выбран.",
        denied: "Браузер запретил доступ к USB на этой странице.",
        failed: "Не удалось напечатать на USB-принтере: {{message}}",
      },
    },
  },
  reports: {
    title: "Отчёт о продажах",
    description: "Выручка по оплатам и возвратам, заказы, средний чек и топ блюд за период.",
    from: "С",
    to: "По",
    groupBy: "Группировка",
    byHour: "По часам",
    byDay: "По дням",
    revenue: "Выручка",
    revenueHint: "Оплаты − возвраты",
    orders: "Заказов",
    avgCheck: "Средний чек",
    refunds: "Возвраты",
    tips: "Чаевые",
    tax: "Налог",
    cancelled: "Отменено",
    payments: "Оплаты",
    cash: "Наличные",
    card: "Карта",
    chart: "Выручка по времени",
    top: "Топ блюд",
    product: "Блюдо",
    qty: "Кол-во",
    sum: "Сумма",
    noData: "Нет продаж за период",
    mismatches: "Продано не по цене меню",
    mismatchHint: "Касса приняла заказ по своей цене (например, офлайн до обновления меню). Сервер не пересчитывает такие заказы.",
    menuPrice: "Цена меню",
    soldPrice: "Цена продажи",
    lines: "Строк",
    presets: {
      today: "Сегодня",
      yesterday: "Вчера",
      week: "7 дней",
      month: "30 дней",
    },
  },
  reservations: {
    title: "Бронирование",
    description: "Брони столов: касса видит их сразу и отмечает стол за час до прихода гостей.",
    add: "Новая бронь",
    edit: "Бронь",
    customer: "Имя гостя",
    phone: "Телефон",
    guests: "Гостей",
    date: "Дата",
    time: "Время",
    duration: "Длительность",
    startsAt: "Начало",
    endsAt: "Окончание",
    tables: "Столы",
    note: "Комментарий",
    status: "Статус",
    statuses: {
      booked: "Забронировано",
      seated: "Гости пришли",
      completed: "Завершена",
      cancelled: "Отменена",
      no_show: "Не пришли",
    },
    empty: "Броней нет",
    emptyHint: "Создайте бронь — касса увидит её и отметит стол",
    cancel: "Отменить бронь",
    cancelTitle: "Отменить бронь «{{name}}»?",
    cancelled: "Бронь отменена",
    saved: "Бронь сохранена",
    seat: "Гости пришли",
    noShow: "Не пришли",
    complete: "Завершить",
    conflict: "Бронь изменили на другом устройстве — данные обновлены",
    minutes: "{{n}} мин",
    hours: "{{n}} ч",
    noTables: "Без стола",
    prevDay: "Предыдущий день",
    nextDay: "Следующий день",
    today: "Сегодня",
    guestsN: "{{n}} гост.",
  },
  orderTypes: {
    dine_in: "В зале",
    takeaway: "С собой",
    delivery: "Доставка",
    self_service: "Самообслуживание",
    pickup: "Самовывоз",
  },
  expenseCategories: {
    rent: "Аренда",
    salary: "Зарплата",
    utilities: "Коммунальные",
    repair: "Ремонт",
    marketing: "Реклама",
    transport: "Транспорт",
    household: "Хозтовары",
    taxes: "Налоги",
    other: "Прочее",
  },
  writeoffReasons: {
    spoilage: "Порча",
    expired: "Просрочка",
    cooking_error: "Ошибка приготовления",
    breakage: "Бой",
    staff_meal: "Питание персонала",
    tasting: "Дегустация",
    internal_use: "Внутренние нужды",
    unknown: "Другое",
  },
  insights: {
    depositNote: "Депозиты банкетов: пришло {{dep}}, зачтено в заказы {{applied}}.",
    laborCost: "ФОТ", laborHint: "Начислено по расчётам зарплаты", laborPct: "Labor cost {{pct}}%", laborReplaced: "Вместо ручных расходов «Зарплата» ({{sum}})", salaryPaid: "Выплачено зарплаты", tipPoolNote: "Чаевые за {{n}} дн. распределены пулом — суммы взяты из распределения, а не по заказам.", profitHint: "Выручка − себестоимость − списания − расходы − ФОТ",
    methods: { cash: "Наличные", card: "Карта", qr: "QR", credit: "В долг", deposit: "Депозит банкета" }, debtNote: "Пришло = выручка − продано в долг ({{credit}}) + погашено долгов ({{repaid}}).",
    title: "Аналитика кафе",
    description: "Выручка, расходы, прибыль, продажи блюд, расход продуктов, списания и официанты за период.",
    period: "Период",
    presets: {
      today: "Сегодня",
      yesterday: "Вчера",
      week: "7 дней",
      month: "Этот месяц",
    },
    tabs: {
      abc: "ABC-анализ",
      matrix: "Матрица меню",
      costs: "Food и labor cost",
      heatmap: "По часам",
      branches: "Филиалы",
      finance: "Финансы",
      items: "Блюда",
      categories: "Категории",
      products: "Продукты",
      writeoffs: "Списания",
      waiters: "Официанты",
    },
    byDays: "По дням",
    date: "Дата",
    noData: "Нет данных за период",
    noSales: "Нет продаж за период",
    revenue: "Выручка",
    revenueHint: "Возвраты: {{refunds}} · чаевые: {{tips}}",
    costOfSales: "Себестоимость",
    foodCost: "Food cost {{pct}}%",
    costHint: "Продукты по ТТК",
    expenses: "Расходы",
    expensesHint: "Аренда, зарплата и прочее",
    profit: "Прибыль",
    margin: "Маржа {{pct}}%",
    grossProfit: "Валовая прибыль",
    grossProfitHint: "Выручка − себестоимость",
    purchases: "Закупки",
    writeoffs: "Списания",
    cashLeft: "Осталось денег",
    cashLeftHint: "Пришло − закупки − расходы",
    noRecipeTitle: "Не у всех блюд есть ТТК",
    noRecipeHint: "Себестоимость и расход продуктов не посчитаны для: {{items}}. Заполните техкарты в меню.",
    whereFrom: "Откуда выручка",
    whereFromHint: "По категориям меню (сумма позиций)",
    noCategory: "Без категории",
    whereTo: "Куда ушли деньги",
    whereToHint: "Расходы, закупки и списания",
    noExpenses: "Нет расходов за период",
    byOrderType: "По типу заказа",
    ordersN: "заказов: {{n}}",
    byMethod: "По способу оплаты",
    moneyFlow: "Движение денег",
    moneyFlowHint: "Сколько пришло, сколько ушло и сколько осталось",
    cameIn: "Пришло",
    purchasesPaid: "Оплачено за закупки",
    supplierCreditNote: "Закупки в долг у поставщиков: {{amount}} — уйдут из денег при оплате",
    profitByDay: "Прибыль по дням",
    categoriesQty: "Продано по категориям",
    categoriesHint: "Сколько штук продано в каждой категории; нажмите на строку — по дням",
    pcs: "шт",
    category: "Категория",
    sold: "Продано",
    perDay: "В среднем за день",
    itemsTitle: "Продажи по блюдам",
    itemsHint: "Нажмите на блюдо, чтобы увидеть продажи по дням",
    searchItem: "Найти блюдо или категорию",
    purchased: "Закуплено",
    usedCost: "Израсходовано на сумму",
    usedHint: "По ТТК проданных блюд",
    writtenOff: "Списано",
    topUsed: "Больше всего расходуется",
    topUsedHint: "По стоимости израсходованного",
    noUsage: "Нет движения продуктов за период",
    productsTitle: "Продукты",
    searchProduct: "Найти продукт",
    product: "Продукт",
    used: "Израсходовано",
    noWriteoffs: "Нет списаний за период",
    documents: "Документов",
    byReason: "По причинам",
    docsN: "{{n}} док.",
    byProduct: "По продуктам",
    reasons: "Причины",
    noWaiter: "Без официанта",
    waitersRevenue: "Выручка по официантам",
    waiter: "Официант",
    guests: "Гостей",
    itemsSold: "Позиций",
    serviceTime: "Время обслуживания",
    minutes: "{{n}} мин",
    cancels: "Отмены / удаления",
    pro: {
      locked: "Доступно с дополнением «Отчёты (расширенные)»",
      lockedHint: "ABC-анализ, матрица меню, food cost и labor cost, продажи по часам и сравнение филиалов — что приносит деньги, а что стоит убрать или поднять в цене.",
      export: "Выгрузить CSV",
      abcBy: "Показатель",
      abcByOptions: {
        revenue: "Блюда по выручке",
        margin: "Блюда по марже",
        qty: "Блюда по количеству",
        products: "Продукты по расходу",
        customers: "Клиенты по сумме",
      },
      abcClass: "Класс {{c}}",
      abcClassHint: "{{count}} поз. · {{value}}",
      pareto: "Pareto: верхние 20%",
      paretoHint: "Доля {{count}} лучших позиций",
      abcHint: "A — дают первые 80%, B — следующие 15%, C — остальное. Позиции класса C — кандидаты на замену.",
      name: "Название",
      value: "Показатель",
      share: "Доля",
      cumulative: "Нарастающим",
      class: "Класс",
      noRecipe: "нет техкарты",
      matrixHint: "Популярно — доля в продажах от {{pop}}; выгодно — маржа с порции от {{margin}}. Себестоимость — по техкартам.",
      matrixNoRecipes: "Заполните техкарты — без них маржу не посчитать.",
      quad: {
        star: "Звёзды",
        plowhorse: "Рабочие лошадки",
        puzzle: "Загадки",
        dog: "Собаки",
      },
      quadHint: {
        star: "Популярны и выгодны — держите качество и место в меню.",
        plowhorse: "Продаются хорошо, но мало прибыли — поднимите цену или снизьте себестоимость.",
        puzzle: "Выгодны, но мало продаж — продвигайте: фото, место в меню, совет официанта.",
        dog: "Мало продаж и мало прибыли — кандидаты на замену.",
      },
      matrixRow: "{{qty}} шт · маржа {{margin}} · fc {{fc}}",
      withoutRecipe: "Без техкарты — не в матрице",
      foodCost: "Food cost",
      laborCost: "Labor cost",
      primeCost: "Prime cost",
      primeCostHint: "Себестоимость + ФОТ",
      perLaborHour: "Выручка на час труда",
      laborHours: "{{hours}} ч по рабочим сменам",
      foodCostByDays: "Food cost по дням",
      byCategory: "По категориям",
      revenue: "Выручка",
      hours: "Часы",
      branchesTitle: "Сравнение филиалов",
      branchesTotal: "Всего: {{revenue}}, заказов {{orders}}, прибыль {{profit}}",
      orders: "Заказы",
      avgCheck: "Средний чек",
      profit: "Прибыль",
      heatmapTitle: "Выручка по дням недели и часам",
      heatmapHint: "Чем темнее — тем больше выручка. Время — местное заведения.",
      ordersN: "заказов: {{count}}",
      less: "меньше",
      more: "больше",
      heatmapDays: "{{from}} — {{to}}",
      weekdays: {
        "1": "Пн",
        "2": "Вт",
        "3": "Ср",
        "4": "Чт",
        "5": "Пт",
        "6": "Сб",
        "7": "Вс",
      },
    },
  },
  expenses: {
    title: "Расходы",
    description: "Аренда, зарплата, коммунальные и прочие расходы заведения. Закупки продуктов — в разделе «Закупки».",
    add: "Добавить расход",
    editTitle: "Изменить расход",
    saved: "Расход сохранён",
    category: "Категория",
    date: "Дата",
    amount: "Сумма",
    comment: "Комментарий",
    commentPlaceholder: "Например: аренда за октябрь",
    deleteTitle: "Удалить расход «{{name}}» на {{sum}}?",
    allCategories: "Все категории",
    total: "Итого",
    empty: "Расходов пока нет",
    emptyHint: "Добавляйте расходы — они попадут в финансовый отчёт и прибыль.",
  },
  inventory: {
    stockTitle: "Остатки на складе",
    stockDescription: "Сколько продуктов на складе филиала и на какую сумму. Продажи списывают продукты по техкартам автоматически.",
    search: "Продукт, артикул или штрихкод",
    onlyLow: "Только «мало» и «в минусе»",
    showAll: "С продуктами без движений",
    quantity: "Остаток",
    minStock: "Минимум",
    value: "Стоимость",
    totalValue: "Стоимость остатков",
    state: "Состояние",
    states: {
      ok: "В норме",
      low: "Мало",
      negative: "В минусе",
    },
    empty: "Остатков пока нет",
    emptyHint: "Проведите закупку или инвентаризацию — остатки появятся здесь.",
    card: "Карточка движения",
    opening: "На начало",
    closing: "На конец",
    incoming: "Приход",
    outgoing: "Расход",
    balance: "Остаток после",
    operation: "Операция",
    when: "Когда",
    order: "заказ №{{n}}",
    noMovements: "Движений за период нет",
    moveTypes: {
      "disassembly": "Разделка",
      "assembly": "Сборка",
      "return_to_supplier": "Возврат поставщику",
      "transfer_out": "Перемещение (расход)",
      "transfer_in": "Перемещение (приход)",
      "production": "Производство",
      receipt: "Закупка",
      writeoff: "Списание",
      consumption: "Продажа",
      inventory_adjustment: "Инвентаризация",
      reversal: "Сторно",
      cost_adjustment: "Корректировка цены",
    },
    countsTitle: "Инвентаризация",
    countsDescription: "Пересчёт продуктов. Продажи во время подсчёта учитываются, разница проводится актом.",
    newCount: "Начать инвентаризацию",
    newCountHint: "Остаток по системе зафиксируется в момент старта, продажи можно не останавливать.",
    start: "Начать",
    scope: "Что считаем",
    scopes: {
      "location": "Место хранения",
      all: "Все продукты",
      category: "Категория",
      products: "Выбранные продукты",
    },
    pickProducts: "Выберите продукты",
    blind: "Слепая",
    blindHint: "Тот, кто считает, не видит остаток по системе",
    blindNote: "Слепая инвентаризация: остаток по системе и разница скрыты.",
    started: "Инвентаризация №{{n}} начата",
    countTitle: "Инвентаризация №{{n}}",
    number: "Номер",
    status: "Статус",
    statuses: {
      counting: "Идёт подсчёт",
      posted: "Проведена",
      cancelled: "Отменена",
    },
    counted: "Подсчитано",
    countedOf: "Подсчитано {{n}} из {{total}}",
    system: "По системе",
    fact: "Факт",
    diff: "Разница",
    shortage: "Недостача",
    surplus: "Излишек",
    result: "Итог",
    onlyDiff: "Только расхождения",
    notCounted: "не подсчитано",
    noDiff: "Расхождений нет",
    saveCounts: "Сохранить подсчёт",
    savedCounts: "Подсчёт сохранён",
    post: "Провести",
    postTitle: "Провести инвентаризацию №{{n}}?",
    postHint: "Неподсчитанные строки не изменятся. Недостача спишется по партиям, излишек оприходуется по последней цене закупки.",
    posted: "Инвентаризация проведена",
    cancel: "Отменить",
    cancelTitle: "Отменить инвентаризацию №{{n}}?",
    cancelHint: "Остатки не изменятся.",
    cancelled: "Инвентаризация отменена",
    emptyCounts: "Инвентаризаций ещё не было",
    emptyCountsHint: "Начните первую — она же задаст начальные остатки склада.",
  },
  stockDocs: {
    backToList: "К закупкам",
    receiptPageDescription: "Что купили, сколько и почём. Потери при приёмке (кости, очистка, разморозка) уменьшают приход на склад — цена за единицу считается от чистого веса.",
    newProduct: "Новый продукт",
    createProduct: "Добавить продукт «{{name}}»",
    loss: "Потери",
    lossMode: "Потери в процентах или количестве",
    lossQty: "Потери",
    toStock: "На склад",
    wasPrice: "было {{price}}",
    "expiresAt": "Годен до",
    "expiresHint": "пусто — по сроку хранения продукта",
    receiptsTitle: "Закупки",
    writeoffsTitle: "Списания",
    receiptsDescription: "Что и почём купили. Закупка обновляет цену продукта — от неё считается себестоимость блюд.",
    writeoffsDescription: "Испорченные, просроченные и другие списанные продукты с причиной.",
    newReceipt: "Новая закупка",
    newWriteoff: "Новое списание",
    post: "Провести",
    saved: "Документ проведён",
    supplier: "Поставщик",
    supplierPlaceholder: "Выберите или добавьте поставщика",
    dueTitle: "Перенести срок оплаты",
    returnEmpty: "Укажите, сколько вернуть",
    returnFromReceipt: "Возврат поставщику по закупке",
    returnReason: "Причина: брак, пересорт…",
    returnable: "Можно вернуть {{qty}} из {{bought}}",
    returnSum: "Сумма возврата (по ценам закупки)",
    returnHint: "Товар спишется со склада из партии этой закупки, долг поставщику уменьшится на сумму возврата; если закупка уже оплачена — сумма станет авансом.",
    returnToSupplier: "Вернуть поставщику",
    byReceipt: "по закупке",
    toPay: "К оплате",
    price: "Цена",
    returned: "Возвращено",
    settlements: "Оплаты и зачёты",
    returnsTitle: "Возвраты по закупке",
    returnsPageTitle: "Возвраты поставщикам",
    returnsPageDescription: "Товар, возвращённый поставщикам: со склада по ценам закупки, сумма уменьшает долг или становится авансом",
    searchReturn: "Поставщик, продукт или комментарий",
    emptyReturns: "Возвратов поставщикам нет",
    allSuppliers: "Все поставщики",
    newReturn: "Возврат поставщику",
    return: "Возврат поставщику",
    createSupplier: "Добавить поставщика «{{name}}»",
    payment: "Оплата",
    onCredit: "В долг",
    mixedUnpaid: "Закупка проведена, но оплачена не полностью — доплатите из карточки поставщика.",
    dueDate: "Оплатить до",
    dueHint: "Отсрочка поставщика: {{n}} дн.",
    paymentAll: "Все закупки",
    paymentUnpaid: "Не оплачены",
    reason: "Причина",
    addLine: "Добавить продукт",
    byLastPrice: "по последней цене закупки",
    byFifo: "по партиям FIFO при проведении",
    receipt: "Закупка",
    writeoff: "Списание",
    products: "Продукты",
    open: "Открыть",
    deleteTitle: "Удалить документ от {{date}} на {{sum}}?",
    deleteHint: "Остатки вернутся к состоянию до проведения, документ пропадёт из отчётов. Цена продукта не откатится.",
    searchReceipt: "Поставщик, продукт, комментарий",
    searchWriteoff: "Продукт, комментарий",
    emptyReceipts: "Закупок за период нет",
    emptyWriteoffs: "Списаний за период нет",
    emptyHint: "Документы попадают в аналитику продуктов и финансов.",
  },
  cash: {
    title: "Кассовые смены",
    description: "Смена веб-кассы: размен, внесения и изъятия, X-отчёт и закрытие с Z-отчётом. Архив смен всех касс филиала.",
    webRegister: "Веб-касса",
    register: "Касса",
    shift: "Смена",
    open: "Открыть смену",
    openHint: "Укажите размен — наличные в кассе на начало смены.",
    opened: "Смена открыта",
    close: "Закрыть смену",
    closeHint: "Пересчитайте наличные в кассе. Z-отчёт после закрытия изменить нельзя.",
    closeAndPrint: "Закрыть и напечатать Z",
    closed: "Смена закрыта",
    noShift: "Смена не открыта",
    noShiftHint: "Откройте смену, чтобы принимать оплаты на веб-кассе.",
    statusOpen: "Открыта",
    statusClosed: "Закрыта",
    status: "Статус",
    openedAt: "Открыта",
    closedAt: "Закрыта",
    cashier: "Кассир",
    float: "Размен",
    expected: "Ожидается наличных",
    counted: "Фактически",
    difference: "Расхождение",
    diffComment: "Комментарий к расхождению",
    diffCommentRequired: "Опишите причину расхождения",
    sales: "Продажи",
    refunds: "Возвраты",
    net: "Выручка",
    checks: "Чеков",
    avgCheck: "Средний чек",
    tips: "Чаевые",
    cancelled: "Отменено заказов",
    debtRepaymentsCash: "Погашения долгов наличными",
    operation: "Внесение / изъятие",
    operationType: "Операция",
    operationDone: "Операция проведена",
    operations: "Операции",
    amount: "Сумма",
    reason: "Причина",
    xReport: "X-отчёт",
    zReport: "Z-отчёт",
    printX: "Печать X-отчёта",
    printZ: "Печать Z-отчёта",
    archive: "Архив смен",
    archiveEmpty: "Смен ещё не было",
    ops: {
      banquet_deposit: "Депозит банкета",
      banquet_refund: "Возврат депозита банкета",
      salary_payout: "Выплата зарплаты",
      supplier_payment: "Оплата поставщику",
      supplier_refund: "Возврат денег от поставщика",
      cash_in: "Внесение",
      cash_out: "Изъятие",
      collection: "Инкассация",
      expense: "Расход из кассы",
      tip_payout: "Выплата чаевых",
      debt_repayment: "Погашение долга",
      correction_in: "Корректировка +",
      correction_out: "Корректировка −",
    },
  },
  suppliers: {
    avgShort: "средняя {{price}}",
    payAdvance: "Внести аванс",
    refund: "Вернуть деньги",
    refunded: "Возврат денег проведён",
    refundTitle: "Поставщик возвращает деньги: {{name}}",
    refundShort: "Возврат денег от поставщика",
    refundCashHint: "Наличные поступят в открытую кассовую смену",
    voidRefundTitle: "Отменить возврат денег {{amount}}?",
    voidRefundHint: "Аванс у поставщика восстановится. Наличные будут изъяты из кассы, если смена ещё открыта.",
    products: "Товары",
    noProducts: "У этого поставщика ещё не было закупок",
    bought: "Закуплено",
    returnedQty: "возвращено {{qty}}",
    lastPrice: "Последняя цена",
    avgPrice: "Средняя цена",
    refundMethods: {
      cash: "Наличными в кассу",
      bank: "На счёт",
    },
    advance: "Аванс",
    advanceHint: "Можно заплатить больше долга — остаток зачтётся в следующие закупки",
    advanceAlert: "Аванс у поставщика: {{amount}} — зачтётся в следующую закупку",
    advanceLeft: "Аванс: {{amount}}",
    advancesNote: "Авансы поставщикам: {{amount}} — зачтутся в следующие закупки",
    statement: {
      open: "Акт сверки",
      title: "Акт сверки взаиморасчётов",
      print: "Печать",
      period: "за период с {{from}} по {{to}}",
      date: "Дата",
      operation: "Операция",
      increase: "Закупки, возврат денег",
      decrease: "Оплаты, возврат товара",
      balance: "Сальдо",
      opening: "Сальдо на начало",
      closing: "Сальдо на конец",
      turnover: "Обороты за период",
      empty: "За период операций нет",
      weOwe: "Задолженность в пользу поставщика: {{amount}}",
      theyOwe: "Задолженность в пользу покупателя (переплата): {{amount}}",
      settled: "Задолженности нет",
      kinds: {
        receipt: "Закупка",
        return: "Возврат поставщику",
        payment: "Оплата",
        refund: "Возврат денег от поставщика",
      },
    },
    title: "Поставщики",
    description: "Справочник поставщиков, закупки в долг и оплаты им",
    add: "Добавить поставщика",
    all: "Все поставщики",
    payablesTab: "Сколько мы должны",
    search: "Название, ИНН, телефон",
    empty: "Поставщиков пока нет",
    emptyHint: "Добавьте поставщика или выберите его прямо в закупке — долг посчитается сам",
    name: "Название",
    contactPerson: "Контактное лицо",
    phone: "Телефон",
    email: "Email",
    terms: "Отсрочка оплаты",
    termsHint: "Дней от даты закупки до срока оплаты; 0 — оплата сразу",
    taxId: "ИНН",
    legalName: "Юридическое название",
    address: "Адрес",
    notes: "Заметки",
    active: "Активен",
    activeHint: "Неактивного поставщика нельзя выбрать в новой закупке",
    inactive: "Неактивен",
    info: "Реквизиты",
    lastPurchase: "Последняя закупка",
    nextDue: "Ближайший срок",
    weOweShort: "Мы должны",
    weOwe: "Мы должны: {{amount}}",
    overdue: "Просрочено",
    dueSoon: "К оплате за 7 дней",
    purchased: "Закуплено всего",
    paidTotal: "Оплачено всего",
    noTerms: "Сразу",
    overdueAlert: "Просрочена оплата поставщику: {{amount}}",
    documents: "Закупки",
    noDocuments: "Закупок пока нет",
    noDocumentsHint: "Проведите закупку и выберите этого поставщика",
    payments: "Оплаты",
    noPayments: "Оплат пока нет",
    voided: "Отменена",
    pay: "Оплатить",
    paid: "Оплата проведена",
    payTitle: "Оплата поставщику: {{name}}",
    payDoc: "Закупка от {{date}}, к оплате {{amount}}",
    method: "Способ оплаты",
    methods: {
      cash: "Наличными из кассы",
      bank: "Переводом",
      return: "Возврат товара",
    },
    reference: "Номер платёжки",
    cashHint: "Наличные выдаются из открытой кассовой смены и уменьшают сумму в кассе",
    fifoHint: "Сумма гасит самые старые неоплаченные закупки",
    void: "Отменить оплату",
    voidTitle: "Отменить оплату {{amount}}?",
    voidHint: "Долг перед поставщиком вернётся. Наличные вернутся в кассу, если смена ещё открыта.",
    deleteTitle: "Удалить поставщика «{{name}}»?",
    deleteHint: "Закупки останутся в истории. Поставщика с долгом удалить нельзя.",
    statuses: {
      paid: "Оплачено",
      partially_paid: "Оплачено частично",
      unpaid: "Не оплачено",
      overdue: "Просрочено",
    },
    segments: {
      all: "Все",
      debt: "С долгом",
      overdue: "Просрочена оплата",
      inactive: "Неактивные",
    },
    aging: {
      d1_30: "Просрочка 1–30 дн.",
      d31_60: "Просрочка 31–60 дн.",
      d60: "Просрочка > 60 дн.",
    },
    creditors: "Кому мы должны",
    noCreditors: "Долгов перед поставщиками нет",
    unpaidDocs: "Неоплаченных закупок",
  },
  customers: {
    title: "Клиенты",
    description: "База гостей: история заказов, любимые блюда, скидки и долги. Общая для всех филиалов.",
    add: "Новый клиент",
    search: "Телефон (последние цифры) или имя",
    empty: "Клиентов пока нет",
    emptyHint: "Добавляйте гостей на кассе или здесь",
    name: "Клиент",
    firstName: "Имя",
    lastName: "Фамилия",
    phone: "Телефон",
    email: "Email",
    birthDate: "Дата рождения",
    discount: "Персональная скидка",
    notes: "Заметки",
    consent: "Согласие на рассылки",
    consentHint: "Маркетинговые сообщения — только с согласием (дата фиксируется)",
    creditAllowed: "Разрешить продажу в долг",
    creditHint: "Касса сможет оплачивать заказы клиента «в долг» в пределах лимита",
    creditLimit: "Кредитный лимит",
    creditBadge: "Кредит до {{limit}}",
    blocked: "Заблокирован",
    blockedHint: "Без новых кредитов и онлайн-заказов",
    orders: "Заказов",
    ordersN: "заказов: {{n}}",
    spent: "Сумма покупок",
    avgCheck: "Средний чек",
    lastVisit: "Последний визит",
    visitEvery: "Приходит раз в",
    days: "{{n}} дн.",
    debt: "Долг",
    debtShort: "долг {{amount}}",
    overdueAlert: "Просрочено: {{amount}} — новый кредит недоступен",
    favorites: "Любимые блюда",
    history: "Заказы",
    noOrders: "Заказов нет",
    anonymize: "Удалить персональные данные",
    anonymizeTitle: "Удалить персональные данные клиента?",
    anonymizeHint: "Имя, телефон, email и заметки будут стёрты. Заказы и долг останутся. Действие необратимо.",
    anonymized: "Данные удалены",
    pick: "Клиент заказа",
    quickAdd: "Новый клиент",
    createAndPick: "Создать и выбрать",
    segments: {
      all: "Все клиенты",
      debtors: "Должники",
      overdue: "Просрочка",
      inactive: "Давно не приходили",
      vip: "По сумме покупок",
      blocked: "Заблокированные",
      birthday: "День рождения на этой неделе",
    },
  },
  debts: {
    owedToUs: "Нам должны",
    weOwe: "Мы должны поставщикам",
    title: "Долги",
    description: "Должники, просрочка и возраст долгов. Погашение — в карточке клиента.",
    total: "Всего долгов",
    overdue: "Просрочено",
    debtors: "Должники",
    noDebtors: "Должников нет",
    oldest: "Старейший долг",
    aging: {
      d0_7: "До 7 дней",
      d8_30: "8–30 дней",
      d31_60: "31–60 дней",
      d60: "Больше 60 дней",
    },
    ledger: "Журнал долга",
    noEntries: "Долгов не было",
    repay: "Погасить",
    repayTitle: "Погашение долга: {{name}}",
    repaid: "Долг погашен",
    balance: "Текущий долг: {{amount}}",
    amount: "Сумма",
    comment: "Комментарий",
    reason: "Причина",
    cashHint: "Наличные поступят в открытую смену веб-кассы.",
    adjustTitle: "Корректировка долга",
    increase: "Начислить",
    decrease: "Уменьшить",
    dueDate: "Срок оплаты",
    due: "до {{date}}",
    remaining: "осталось {{amount}}",
    writeOff: "Списать",
    writeOffTitle: "Списать долг {{amount}}?",
    writeOffHint: "Безнадёжный долг будет списан целиком. Действие попадёт в аудит.",
    writeOffComment: "Безнадёжный долг",
    writtenOff: "Долг списан",
    kinds: {
      charge: "Начисление",
      repayment: "Погашение",
      adjustment: "Корректировка",
      write_off: "Списание",
    },
    statuses: {
      open: "Открыт",
      partially_paid: "Частично погашен",
      paid: "Погашен",
      overdue: "Просрочен",
      written_off: "Списан",
    },
  },
  staff: {
    employeesTitle: "Кадры",
    employeesDescription: "Сотрудники филиала: должность, дата приёма, схема оплаты, кто сейчас на смене. Увольнение блокирует вход, данные сохраняются.",
    employee: "Сотрудник",
    position: "Должность",
    noPosition: "Без должности",
    hiredAt: "Дата приёма",
    payScheme: "Оплата",
    own: "своя",
    ownScheme: "Своя схема оплаты",
    ownSchemeHint: "Иначе — по схеме должности",
    employmentHint: "Должность, приём и схема оплаты. Изменение ставок попадает в аудит.",
    status: "Статус",
    offShift: "Не на смене",
    onShiftSince: "На смене с {{time}}",
    dismissedAt: "Уволен {{date}}",
    noEmployees: "Сотрудников нет",
    dismiss: "Уволить",
    dismissTitle: "Уволить {{name}}?",
    dismissHint: "Вход и PIN будут заблокированы, открытая смена закроется. Данные и расчёты сохранятся.",
    dismissDate: "Дата увольнения",
    dismissReason: "Причина",
    dismissed: "Сотрудник уволен",
    restore: "Восстановить",
    restoreTitle: "Восстановить {{name}}?",
    positionsTitle: "Должности",
    positionsDescription: "Должности и схема оплаты по умолчанию для их сотрудников.",
    addPosition: "Новая должность",
    deletePosition: "Удалить должность «{{name}}»?",
    noPositions: "Должностей пока нет",
    defaultScheme: "Схема оплаты по умолчанию",
    scheme: {
      hourlyRate: "Ставка в час",
      shiftRate: "Ставка за смену",
      monthlySalary: "Оклад в месяц",
      salesPercent: "% от личных продаж",
      tierFrom: "Повышенный % с суммы",
      tierHint: "Ступень: часть продаж сверх суммы",
      tierPercent: "Повышенный %",
      nightCoef: "Коэффициент ночных",
      nightHint: "1,5 — ночные часы +50% (22:00–06:00)",
      tipsViaPayroll: "Выплачивать чаевые с зарплатой",
      perHour: "{{v}}/час",
      perShift: "{{v}}/смена",
      perMonth: "{{v}}/мес",
      ofSales: "{{v}}% продаж",
    },
  },
  shifts: {
    title: "Рабочие смены",
    description: "Приход и уход сотрудников: отметка по PIN на терминале, из кабинета или вручную. Корректировки с причиной, утверждение табеля.",
    add: "Смена вручную",
    onShift: "Сейчас на смене: {{n}}",
    nobody: "Никого нет на смене",
    list: "Смены",
    timesheet: "Табель",
    date: "Дата",
    time: "Время",
    worked: "Отработано",
    night: "Ночные",
    total: "Итого",
    shiftsCount: "Смен",
    unapproved: "не утверждено: {{n}}",
    empty: "Смен за период нет",
    select: "Выбрать смену",
    approveAll: "Утвердить все ({{n}})",
    approveSelected: "Утвердить выбранные ({{n}})",
    approvedN: "Утверждено смен: {{n}}",
    clockIn: "Начало",
    clockOut: "Конец",
    breakMinutes: "Перерыв, мин",
    reason: "Причина",
    correctTitle: "Корректировка: {{name}}",
    correctHint: "Исходное время сохранится, изменение попадёт в аудит.",
    original: "Было: {{in}} — {{out}}",
    statuses: {
      open: "На смене",
      closed: "Закрыта",
      auto_closed: "Закрыта автоматически",
      corrected: "Скорректирована",
      approved: "Утверждена",
    },
  },
  payroll: {
    title: "Зарплата",
    description: "Расчёт за период по схемам оплаты, проверка, утверждение и выплата. Утверждённая ведомость не меняется — исправления в следующем периоде.",
    calculate: "Рассчитать",
    runs: "Расчёты",
    noRuns: "Расчётов ещё не было",
    period: "Период",
    version: "Версия",
    employees: "Сотрудников",
    gross: "Начислено",
    net: "К выплате",
    calculatedAt: "Рассчитано",
    sheetTitle: "Ведомость {{from}} — {{to}} (v{{v}})",
    approve: "Утвердить",
    approved: "Ведомость утверждена",
    immutableHint: "Ведомость утверждена и не меняется. Исправления — бонусом или удержанием в следующем периоде.",
    payCash: "Выплатить из кассы {{amount}}",
    payBank: "Выплатить банком",
    payOne: "Выплатить {{amount}}",
    paid: "Выплата проведена",
    noLines: "Начислений нет — проверьте схемы оплаты и смены",
    employeeTotals: "Начислено {{gross}} · к выплате {{net}} · выплачено {{paid}}",
    adjustments: "Бонусы и удержания",
    noAdjustments: "Бонусов и удержаний нет",
    addAdjustment: "Бонус или удержание",
    adjustmentHint: "Попадёт в расчёт периода по дате. Причина обязательна.",
    type: "Тип",
    amount: "Сумма",
    date: "Дата",
    reason: "Причина",
    statuses: {
      calculated: "Рассчитана",
      approved: "Утверждена",
      paid: "Выплачена",
      superseded: "Заменена пересчётом",
    },
    components: {
      hourly: "Почасовая",
      night: "Ночные",
      fixed_shift: "За смены",
      fixed_monthly: "Оклад",
      personal_sales_percent: "% от продаж",
      tips: "Чаевые",
      bonus: "Бонус",
      penalty: "Штраф",
      advance: "Аванс",
      deduction: "Удержание",
      carry_over: "Перенос удержаний",
      carry_in: "Удержание с прошлого периода",
    },
    basis: {
      hourly: "{{h}} ч × {{rate}}",
      night: "{{h}} ночных ч, коэф. {{coef}}",
      shifts: "{{n}} смен × {{rate}}",
      monthly: "{{days}} дн. из оклада {{salary}}",
      sales: "{{pct}}% от продаж {{sales}}",
    },
  },
  tips: {
    title: "Чаевые",
    description: "Чаевые гостей — не выручка заведения. Распределение: официанту заказа, пулом поровну или по отработанным часам; выплата из кассы или с зарплатой.",
    mode: "Распределение",
    modes: {
      individual: "Официанту заказа",
      pool_equal: "Пул поровну",
      pool_hours: "Пул по часам",
    },
    modeHints: {
      individual: "Каждый получает чаевые своих заказов; без официанта — поровну между работавшими.",
      pool_equal: "Все чаевые периода поровну между работавшими в периоде.",
      pool_hours: "Пропорционально отработанным часам в периоде.",
    },
    total: "Чаевых за период: {{amount}}",
    distribute: "Распределить",
    created: "Чаевые распределены",
    empty: "За период нет чаевых",
    basis: "Основание",
    hours: "{{h}} ч",
    ownOrders: "Свои заказы",
    equalShare: "Равная доля",
    amount: "Сумма",
    pools: "Распределения",
    noPools: "Распределений ещё не было",
    payout: "Выплатить",
    payoutAll: "Выплатить всем {{amount}}",
    paidOut: "Чаевые выплачены",
    paidCash: "Выплачено",
    viaPayroll: "С зарплатой",
    statuses: {
      calculated: "Распределено",
      paid: "Выплачено",
    },
  },
  me: {
    title: "Мой кабинет",
    description: "Мои смены, продажи, чаевые и расчётные листки.",
    onShift: "Вы на смене с {{since}}",
    offShift: "Вы не на смене",
    clockIn: "Начать смену",
    clockOut: "Закончить смену",
    clockedIn: "Смена начата",
    clockedOut: "Смена закончена",
    worked: "Отработано",
    orders: "Заказов",
    sales: "Продажи",
    tips: "Чаевые",
    payslip: "Расчётный листок {{from}} — {{to}}",
    payslipTotals: "К выплате {{net}} · выплачено {{paid}}",
    shifts: "Мои смены",
  },
  audit: {
    title: "Журнал аудита",
    description: "Кто, что и когда изменил: цены, отмены, возвраты, кассовые операции, долги, смены и зарплата.",
    actionFilter: "Раздел",
    at: "Время",
    action: "Действие",
    user: "Кто",
    entity: "Объект",
    system: "Система",
    empty: "Записей нет",
    before: "Было",
    after: "Стало",
    ...auditRu,
  },
  docs: docsRu,
  billing: {
    pageDescription: "Тариф, лимиты, дополнения и счета. Изменения с доплатой вступают в силу после оплаты счёта, понижение тарифа — с начала следующего периода.",
    plans: "Тарифы",
    period: "Период оплаты",
    periods: {
      month: "Месяц",
      quarter: "Квартал",
      year: "Год",
    },
    periodTill: "{{period}}, оплачено до {{date}}",
    current: "Текущий",
    choose: "Выбрать",
    changePeriod: "Сменить период",
    changeTo: "Тариф «{{plan}}»",
    byContract: "По договору",
    pay: "Оплатить",
    save: "выгода {{pct}}%",
    planInvoice: {
      term: "Срок оплаты",
      custom: "По дату",
      customHint: "Своя дата окончания: месяцы — по цене периода, остальные дни — по дням",
      until: "Оплачено по (включительно)",
      perMonth: "{{amount}} в месяц",
      saving: "{{amount}} в месяц · выгода {{pct}}% ({{save}})",
      termLine: "Срок: {{from}} – {{to}}",
      trialHint: "Тариф включится сразу, оплаченный срок начнётся после пробного периода.",
      paidHint: "Срок начнётся после уже оплаченного — с {{date}}. Тариф сменится после оплаты счёта.",
      noPrice: "У тарифа нет цены — обратитесь в поддержку Coca.",
    },
    planLimits: "Филиалов: {{branches}} · терминалов: {{terminals}} · пользователей: {{users}}",
    addons: "Дополнения",
    addonsHint: "Подключаются сразу после оплаты; отключение — в конце периода, данные сохраняются.",
    addon: "Дополнение",
    price: "Цена за период",
    included: "Входит в тариф",
    active: "Подключено",
    enable: "Подключить",
    enableAddon: "Подключить «{{name}}»",
    disable: "Отключить",
    addonCancelled: "Дополнение отключится в конце периода",
    endsAt: "Отключится {{date}}",
    apply: "Применить",
    issueInvoice: "Выставить счёт на {{amount}}",
    toPay: "К оплате",
    discount: "Скидка",
    afterPayment: "Изменение вступит в силу после оплаты счёта.",
    trialFree: "Во время пробного периода изменения бесплатны и вступают в силу сразу.",
    term: {
      label: "Срок",
      subscription: "С подпиской",
      custom: "Свой срок",
      subscriptionHint: "До конца оплаченного срока — по {{date}}, дальше продлевается вместе с подпиской.",
      subscriptionTrialHint: "Первый оплачиваемый период — по {{date}}, дальше продлевается вместе с подпиской.",
      from: "С",
      to: "По (включительно)",
      months: "{{count}} мес.",
      customHint: "Оплачивается один раз за выбранные дни и само не продлевается.",
      past: "Не раньше сегодня",
      order: "Раньше даты начала",
    },
    paidUntil: "Оплачено по {{date}}",
    startsAt: "С {{date}}",
    extend: "Продлить",
    scheduled: "Изменение вступит в силу {{date}} — с начала следующего периода.",
    scheduledChange: "Запланировано со следующего периода: тариф {{plan}}, период {{period}}",
    downgradeBlocked: "Использование превышает лимиты нового тарифа: отключите лишние филиалы, терминалы или пользователей.",
    addonsDropped: "Отключатся дополнения, которых нет на новом тарифе: {{names}}. Данные сохранятся.",
    invoiceIssued: "Выставлен счёт {{n}}",
    changeApplied: "Изменение применено",
    invoices: "Счета",
    noInvoices: "Счетов пока нет",
    number: "Номер",
    issued: "Выставлен",
    due: "Оплатить до",
    total: "Сумма",
    print: "Печать",
    bankTitle: "Реквизиты для оплаты",
    invoiceStatus: {
      open: "Ожидает оплаты",
      paid: "Оплачен",
      void: "Аннулирован",
      refunded: "Возврат",
      draft: "Черновик",
    },
    limitNear: "Почти исчерпан",
    limitReached: "Исчерпан",
    banner: {
      trial: "После окончания выберите тариф и оплатите счёт.",
      past_due: "Оплатите счёт до {{date}}, иначе доступ станет только для чтения.",
      read_only: "Доступ только для чтения: продажи на кассе работают, остальное — после оплаты. До приостановки: {{date}}.",
      suspended: "Подписка приостановлена. Оплатите счёт, чтобы вернуть доступ.",
      expired: "Пробный период закончился. Выберите тариф.",
      archived: "Подписка в архиве.",
      cancelled: "Подписка отменена и действует до {{date}}.",
    },
    bannerPastDue: "Подписка ожидает оплаты — оплатите счёт, чтобы не потерять доступ.",
    bannerReadOnly: "Доступ только для чтения: касса продаёт, изменения недоступны до оплаты.",
    payNow: "Оплатить",
    choosePlan: "Выбрать тариф",
    supportReadOnly: "Сеанс поддержки Coca — только просмотр",
    supportFull: "Сеанс поддержки Coca — с правом изменений",
    supportExit: "Завершить сеанс",
    supportLinkInvalid: "Ссылка сеанса поддержки недействительна",
    inviteTitle: "Добро пожаловать в Coca",
    inviteHint: "Придумайте пароль для входа в ERP.",
    inviteInvalid: "Ссылка приглашения недействительна",
    inviteExpired: "Ссылка устарела? Задайте пароль через восстановление",
    inviteSubmit: "Задать пароль и войти",
  },
  onboarding: {
    title: "Настройка заведения",
    defaultHall: "Основной зал",
    next: "Далее",
    back: "Назад",
    skip: "Пропустить",
    skipped: "пропущено",
    todo: "Сделать",
    optional: "Необязательно",
    company: {
      title: "Компания",
      hint: "Как называется ваш бизнес. Юр. данные можно добавить позже.",
      name: "Название",
      country: "Страна",
      legalName: "Юридическое название",
      taxId: "ИНН",
    },
    branch: {
      title: "Заведение",
      hint: "Формат задаёт типы заказов по умолчанию — функции ограничивает только тариф.",
      format: "Формат заведения",
      name: "Название точки",
      phone: "Телефон",
      city: "Город",
      address: "Адрес",
    },
    currency: {
      title: "Валюта и время",
      hint: "Валюта цен и чеков, часовой пояс и граница бизнес-дня для отчётов.",
      currency: "Валюта",
      timezone: "Часовой пояс",
      cutoff: "Граница дня",
      cutoffHint: "Продажи до этого времени относятся к прошлому дню",
    },
    menu: {
      packsTitle: "Нужно полное меню?", packsHint: "В разделе «Каталог → Готовые меню» — наборы для шаурмичной, кофейни, кафе-мороженого, национальной кухни, пиццерии, суши-бара и других форматов: блюда с фото и описаниями, продукты, полуфабрикаты и техкарты с калькуляцией. Покупаются один раз.",
      title: "Меню",
      hint: "Загрузите демо-меню по формату — цены и позиции можно поменять или удалить.",
      manual: "Создам меню сам",
      load: "Загрузить",
      loaded: "Демо-меню загружено",
      has: "В меню уже {{n}} позиций",
      templates: {
        coffee: "Кофе (размеры, молоко, сиропы), чай, выпечка, десерты",
        cafe: "Салаты, супы, горячее, напитки — кухня и бар",
        fast_food: "Бургеры с добавками, закуски с соусами, напитки",
      },
    },
    tables: {
      title: "Столы",
      hint: "Быстрый план зала: столы расставятся сеткой, у каждого — QR для меню.",
      hall: "Зал",
      count: "Столов",
      capacity: "Мест за столом",
      generate: "Создать столы",
      created: "Создано столов: {{n}}",
      has: "Уже есть столов: {{n}}",
    },
    employees: {
      title: "Сотрудники",
      hint: "Кассиры и официанты входят на кассе по PIN — пароль не нужен.",
      name: "Имя",
      role: "Роль",
      pinHint: "4–6 цифр",
      add: "Добавить сотрудника",
    },
    cash: {
      title: "Касса",
      hint: "Откройте смену веб-кассы с разменом — и можно продавать. Терминалы подключаются в «Настройки → Терминалы».",
      open: "Открыть смену",
    },
    finish: {
      title: "Готово к первой продаже",
      hint: "Пропущенные шаги можно завершить позже в настройках.",
      openPos: "Открыть кассу",
      openDashboard: "Перейти на дашборд",
    },
    steps: {
      company: "Компания",
      branch: "Заведение",
      currency: "Валюта и время",
      menu: "Меню",
      tables: "Столы",
      employees: "Сотрудники",
      cash: "Касса",
      finish: "Готово",
    },
    formats: {
      cafe: "Кафе с официантами",
      coffee: "Кофейня",
      fast_food: "Фастфуд",
      self_service: "Самообслуживание",
      food_court: "Фудкорт",
    },
    formatHints: {
      cafe: "Зал, столы, оплата после еды",
      coffee: "С собой и в зале, модификаторы напитков",
      fast_food: "Номер заказа, оплата сразу",
      self_service: "Заказ у стойки, экран готовности",
      food_court: "Общий зал, несколько кухонь",
    },
    countries: {
      KG: "Кыргызстан",
      KZ: "Казахстан",
      UZ: "Узбекистан",
      TJ: "Таджикистан",
      RU: "Россия",
    },
  },
  site: {
    contacts: { title: "Контакты и соцсети", hint: "Покажутся в подвале и на главной сайта. Пустые поля на сайте не видны. Соцсети — ссылкой или именем аккаунта (@name).", phone: "Телефон заведения", email: "Email для гостей" },
    title: "Сайт и QR-меню",
    description: "Публичный сайт заведения, QR-меню на столах и заказ гостей с телефона.",
    open: "Открыть сайт",
    slug: "Адрес сайта (поддомен)",
    heroTitle: "Заголовок на главной",
    about: "О заведении",
    seoTitle: "SEO-заголовок",
    seoTitleHint: "До 60 символов",
    seoDescription: "SEO-описание",
    seoDescriptionHint: "До 155 символов",
    qrOrdering: "Заказ гостей через QR",
    qrOrderingHint: "Гости заказывают со своего телефона, заказ сразу появляется на кассе",
    qrOrderingAddon: "Доступно с дополнением «Заказ по QR» — подключите его на странице «Подписка»",
    requireName: "Спрашивать имя гостя",
    autoKitchen: "Сразу отправлять на кухню",
    autoKitchenHint: "Иначе заказ ждёт подтверждения официантом",
    qrTitle: "QR-коды столов",
    qrHint: "Наклейки на столы: гость сканирует и видит меню, может заказать и позвать официанта.",
    printAll: "Печать наклеек ({{n}})",
    noTables: "Столов пока нет — создайте их в «Залы и столы».",
    counterQr: "QR для стойки и витрины",
    scanCaption: "Сканируйте для меню",
    callWaiter: "Стол {{n}} зовёт официанта",
    requestBill: "Стол {{n}} просит счёт",
    domain: {
      title: "Свой адрес сайта",
      description: "Сайт и QR-меню на вашем домене — например, navat.kg вместо адреса платформы.",
      addon: "Доступно с дополнением «Свой адрес сайта»",
      addonHint: "Подключите его на странице «Подписка» — сайт откроется по вашему адресу, ссылки с адреса платформы будут вести туда же.",
      input: "Ваш домен",
      inputHint: "Домен должен быть уже куплен у регистратора (например, navat.kg или menu.navat.kg)",
      connect: "Подключить",
      none: "Свой адрес не подключён.",
      pending: "Ждём настройки DNS",
      active: "Работает",
      since: "Подтверждён {{date}}",
      steps: "Добавьте эти записи в панели регистратора домена и нажмите «Проверить». Изменения DNS обычно доходят за 5–30 минут, иногда до суток.",
      type: "Тип",
      name: "Имя",
      value: "Значение",
      copy: "Скопировать",
      copied: "Скопировано",
      verify: "Проверить",
      change: "Сменить адрес",
      remove: "Отключить адрес",
      removeTitle: "Отключить свой адрес?",
      removeHint: "Сайт останется доступен по адресу платформы. Записи DNS у регистратора можно удалить.",
      noTxt: "Запись TXT пока не видна. Проверьте имя и значение или подождите — DNS обновляется не сразу.",
      noRouting: "Домен ещё не направлен на нас (запись CNAME или A). Пока её нет, сайт по этому адресу не откроется.",
      sslHint: "Защищённое соединение (https) включается само в течение нескольких минут после того, как домен направлен на нас.",
      activeToast: "Адрес {{domain}} подтверждён",
    },
  },
  supportAccess: {
    title: "Поддержка Coca просит доступ",
    description: "Сотрудник поддержки {{name}} хочет войти в ваш кабинет. Без вашего разрешения он не войдёт.",
    approve: "Разрешить вход",
    deny: "Отклонить",
    mode: "Режим",
    modeReadOnly: "Только просмотр",
    modeFull: "Просмотр и изменения",
    reason: "Причина",
    until: "Ответить до",
    readOnlyHint: "Сотрудник увидит кабинет вашими глазами, но ничего не сможет изменить. Сеанс — до 60 минут, всё попадёт в журнал аудита.",
    fullHint: "Сотрудник сможет вносить изменения от имени владельца. Разрешайте, только если сами просили помочь. Сеанс — до 60 минут, все действия попадут в журнал аудита.",
    approved: "Вход разрешён — сотрудник поддержки может войти в течение 10 минут",
    denied: "Запрос отклонён",
  },
  support: {
    title: "Поддержка",
    description: "Напишите нам — ответим в разделе и пришлём уведомление.",
    new: "Написать в поддержку",
    empty: "Обращений пока нет",
    emptyHint: "Если что-то не работает или есть вопрос — напишите, мы поможем.",
    subject: "Тема",
    category: "Тип обращения",
    body: "Сообщение",
    bodyHint: "Опишите, что произошло и что вы ожидали. Номер заказа или экран — помогут.",
    send: "Отправить",
    reply: "Ответить",
    replyPlaceholder: "Ваш ответ…",
    close: "Вопрос решён",
    closeConfirm: "Закрыть обращение?",
    closeHint: "Если вопрос вернётся — просто напишите в этом же обращении.",
    sent: "Обращение отправлено",
    replied: "Сообщение отправлено",
    closed: "Обращение закрыто",
    you: "Вы",
    supportName: "Поддержка Coca",
    number: "№ {{n}}",
    createdBy: "Автор",
    updated: "Последнее сообщение",
    slaNormal: "Отвечаем в течение {{hours}} ч",
    slaHigh: "Быстрая поддержка: ответ в течение {{hours}} ч, ваши обращения — первыми",
    slaUpsell: "Нужно быстрее? Подключите «Быструю поддержку» — ответ за 2 часа.",
    slaUpsellAction: "Подписка",
    waitUntil: "Ответим до {{time}}",
    overdue: "Задерживаем ответ — уже занимаемся",
    statuses: {
      open: "Ждёт ответа",
      answered: "Есть ответ",
      closed: "Решено",
    },
    categories: {
      question: "Вопрос",
      problem: "Что-то не работает",
      billing: "Оплата и подписка",
      idea: "Предложение",
    },
    filterAll: "Все",
    priorityHigh: "Срочно",
  },
  brand: {
    title: "Свой бренд",
    description: "Ваше название, логотип и цвет вместо Coca — в программе, на сайте и в письмах.",
    addon: "Доступно с дополнением «Свой бренд вместо Coca»",
    addonHint: "Сотрудники и гости будут видеть только ваш бренд: шапка программы, цвет кнопок, сайт без «работает на Coca», письма от вашего имени.",
    name: "Название",
    nameHint: "В шапке, на вкладке браузера и в подписи писем. Пусто — название компании",
    color: "Основной цвет",
    logo: "Логотип",
    logoHint: "Лучше PNG с прозрачным фоном, вытянутый по горизонтали",
    colors: {
      orange: "Оранжевый (Coca)",
      red: "Красный",
      rose: "Малиновый",
      violet: "Фиолетовый",
      blue: "Синий",
      teal: "Бирюзовый",
      green: "Зелёный",
      brown: "Коричневый",
    },
  },
  fraud: {
    title: "Защита от злоупотреблений",
    description: "Подозрительные действия сотрудников: удаления, возвраты, скидки, недостачи. Проверяется само каждый час.",
    scan: "Проверить сейчас",
    scanFound: "Найдено новых: {{count}}",
    scanNothing: "Новых подозрительных действий нет",
    settings: "Правила",
    alertsTab: "Сигналы",
    peopleTab: "Сотрудники",
    peopleTitle: "Кто чаще попадает в сигналы",
    peopleHint: "Риск — сумма весов: серьёзный 5, средний 3, низкий 1. Ложные тревоги не считаются.",
    empty: "Подозрительных действий нет",
    emptyHint: "За выбранный период правила ничего не нашли.",
    all: "Все",
    status: "Статус",
    rule: "Что случилось",
    employee: "Сотрудник",
    date: "Дата",
    amount: "Сумма",
    risk: "Риск",
    alerts: "Сигналы",
    noUser: "Без сотрудника",
    decision: "Решение",
    comment: "Комментарий",
    statuses: {
      new: "Новый",
      reviewed: "Просмотрено",
      dismissed: "Ложная тревога",
      confirmed: "Нарушение",
    },
    severities: {
      low: "Низкий",
      medium: "Средний",
      high: "Серьёзный",
    },
    units: {
      count: "Больше, раз",
      percent: "Больше, %",
      days: "Дней без оплаты",
      sigma: "Выше среднего, σ",
    },
    rules: {
      void_many: "Много удалённых позиций",
      void_after_kitchen: "Удаление позиции после кухни",
      cancel_after_kitchen: "Отмена заказа после кухни",
      refunds_many: "Много возвратов",
      refund_cash_for_card: "Возврат наличными за оплату картой",
      discount_share: "Много ручных скидок",
      price_below_menu: "Продажа дешевле меню",
      writeoff_outlier: "Необычно крупное списание",
      cash_shortage: "Недостача в кассе",
      credit_unpaid: "Долг без погашений",
    },
    ruleHints: {
      void_many: "Сотрудник удалил из заказов больше позиций за день, чем обычно.",
      void_after_kitchen: "Блюдо уже готовили, а потом удалили — продукты потрачены, денег нет.",
      cancel_after_kitchen: "Заказ ушёл на кухню, а потом его отменили.",
      refunds_many: "Больше возвратов за день, чем обычно.",
      refund_cash_for_card: "Гость платил картой, а возврат выдан наличными — классическая схема вывода денег.",
      discount_share: "Ручные скидки сотрудника — заметная доля его продаж за день.",
      price_below_menu: "Позиции проданы дешевле цены меню.",
      writeoff_outlier: "Списание намного больше обычного для этого заведения.",
      cash_shortage: "При закрытии смены наличных меньше, чем должно быть. Повторная за 30 дней — серьёзно.",
      credit_unpaid: "Продажа в долг, по которой давно нет ни одного погашения.",
    },
    d: {
      count: "{{count}} раз (порог {{threshold}})",
      order: "заказ № {{n}}",
      pct: "{{pct}}% (порог {{threshold}}%)",
      lines: "позиций: {{count}}",
      average: "обычно около {{avg}}",
      repeats: "повторно: {{count}} за 30 дней",
      customer: "клиент {{name}}",
      paidBy: "оплата: {{methods}}",
    },
  },
  sms: {
    title: "SMS-рассылки",
    description: "Сообщения клиентам по сегментам: акции, новинки, напоминания. Только тем, кто согласился на рассылки.",
    usage: "SMS за {{month}}",
    usageValue: "{{used}} из {{quota}}",
    noQuota: "SMS на месяц нет",
    lowQuota: "Осталось SMS: {{count}}",
    packHint: "Пакет «SMS 1000» подключается на странице «Подписка» и действует каждый месяц.",
    buyPack: "Подписка",
    new: "Новая рассылка",
    test: "Тестовое SMS",
    campaigns: "Рассылки",
    empty: "Рассылок пока нет",
    emptyHint: "Создайте первую — например, приглашение на выходные со скидкой.",
    name: "Название",
    nameHint: "Для себя, клиенты его не видят",
    segment: "Кому",
    allCustomers: "Всем клиентам с согласием",
    tag: "Тег клиента",
    tagHint: "Необязательно: только клиенты с этим тегом",
    text: "Текст",
    counter: "{{length}} симв. · {{parts}} SMS (по {{perPart}})",
    noRecipients: "Нет получателей: нужен телефон и отметка «согласен на рассылки» в карточке клиента.",
    previewText: "Получателей: {{recipients}}, SMS: {{total}}. Осталось в этом месяце: {{remaining}}.",
    notEnough: "Не хватает SMS — докупите пакет.",
    consentHint: "Получат только клиенты с отметкой «согласен на рассылки», с телефоном и не заблокированные.",
    confirmTitle: "Отправить рассылку?",
    confirmText: "Получателей: {{recipients}}, будет израсходовано SMS: {{total}}. Отменить после отправки нельзя.",
    send: "Отправить",
    started: "Рассылка запущена — сообщения уйдут в течение минуты",
    phone: "Номер",
    testText: "Проверка SMS от нашего кафе",
    testQueued: "SMS отправляется",
    date: "Когда",
    recipients: "Получателей",
    delivered: "Доставлено",
    notSent: "не ушло: {{count}}",
    statuses: {
      sending: "Отправляется",
      sent: "Отправлена",
    },
  },
  services: {
    title: "Услуги и аренда",
    description: "Кальян, караоке, аренда комнат: таймер идёт на сервере, при остановке услуга сама попадает в заказ.",
    start: "Начать услугу",
    startTimer: "Запустить таймер",
    sell: "Продать",
    started: "Таймер запущен",
    sold: "Услуга добавлена в заказ",
    stopped: "Услуга добавлена в заказ",
    tabs: {
      now: "Сейчас",
      rooms: "Комнаты",
      tariffs: "Тарифы",
      report: "Отчёт",
    },
    statuses: {
      running: "Идёт",
      paused: "Пауза",
      stopped: "Завершена",
      cancelled: "Отменена",
    },
    pause: "Пауза",
    resume: "Продолжить",
    stop: "Завершить",
    stopTitle: "Завершить и добавить в заказ?",
    stopHint: "Время посчитается по тарифу (шаг и округление), сумма попадёт в заказ.",
    cancel: "Отменить",
    cancelTitle: "Отменить без оплаты?",
    cancelHint: "Время не будет оплачено. Действие попадёт в журнал.",
    elapsed: "Прошло {{time}}",
    planned: "Оплачено до {{time}}",
    overPlanned: "Оплаченное время закончилось",
    noActive: "Сейчас ничего не идёт",
    noActiveHint: "Запустите услугу — кальян, караоке или аренду комнаты.",
    recent: "Последние",
    when: "Начало",
    duration: "Время",
    amount: "Сумма",
    service: "Услуга",
    room: "Комната",
    noRoom: "Без комнаты",
    busy: "занята",
    free: "Свободна",
    quantity: "Количество",
    plannedMinutes: "Оплаченное время, мин",
    plannedHint: "Необязательно: таймер подсветится, когда время выйдет",
    orderHint: "Без выбранного заказа будет создан новый — к столу комнаты, если он указан.",
    noReady: "Нет настроенных услуг: добавьте позицию меню типа «Услуга» и задайте тариф на вкладке «Тарифы».",
    billing: "Как считать",
    billingHourly: "По времени",
    billingUnit: "Штучно",
    unitHint: "Цена — из меню ({{price}}); с техкартой списываются продукты (табак, уголь).",
    hourlyPrice: "Цена за час",
    minDuration: "Минимум, мин",
    step: "Шаг, мин",
    rounding: "Округление",
    roundings: {
      up: "Вверх",
      nearest: "До ближайшего",
      down: "Вниз",
    },
    tierLabel: "Другая цена после первого часа",
    tierHint: "Например: первый час 1000, дальше по 800",
    tierFrom: "С какой минуты",
    tierPrice: "Цена часа дальше",
    commission: "Комиссия",
    commissions: {
      none: "Без комиссии",
      fixed: "Сумма",
      percent: "Процент",
      mixed: "Сумма + процент",
    },
    commissionPercent: "Процент",
    commissionFixed: "Сумма",
    addRoom: "Добавить комнату",
    roomName: "Название",
    minOrder: "Минимальный заказ",
    minOrderHint: "При завершении аренды заказ доплачивается до этой суммы",
    deposit: "Депозит",
    roomActive: "Используется",
    inactive: "Выключена",
    noRooms: "Комнат пока нет",
    noRoomsHint: "Добавьте VIP-комнату или караоке-зал.",
    tariffsHint: "Услуги — это позиции меню с типом «Услуга». Здесь — как их считать и комиссия исполнителю.",
    noServices: "Услуг пока нет",
    noServicesHint: "Создайте в меню позицию с типом «Услуга».",
    notConfigured: "Не настроена",
    perHour: "{{price}} за час, шаг {{step}} мин",
    perUnit: "{{price}} за шт.",
    revenue: "Выручка",
    roomsLoad: "Загрузка комнат",
    hours: "Часы",
    sessions: "Сессии",
    load: "Загрузка",
    commissionsTitle: "Комиссии сотрудникам",
    commissionsHint: "Возвраты и удалённые позиции не учитываются.",
    noCommissions: "Комиссий нет",
    employee: "Сотрудник",
    sales: "Продажи",
  },
  banquets: {
    title: "Банкеты",
    description: "Свадьбы, дни рождения, корпоративы: меню на гостя, депозиты, бронь зала и заказ в день мероприятия.",
    new: "Новый банкет",
    empty: "Банкетов нет",
    emptyHint: "Создайте заявку — меню и депозит можно добавить позже.",
    name: "Название",
    type: "Тип",
    startsAt: "Начало",
    endsAt: "Окончание",
    guests: "Гостей",
    guestsN: "Гостей: {{count}}",
    halls: "Залы",
    hallsHint: "После подтверждения залы закрываются для обычных броней",
    depositRequired: "Депозит для подтверждения",
    depositRequiredHint: "0 — подтверждать без депозита",
    notes: "Заметки",
    types: {
      wedding: "Свадьба",
      birthday: "День рождения",
      corporate: "Корпоратив",
      anniversary: "Юбилей",
      other: "Другое",
    },
    statuses: {
      inquiry: "Заявка",
      tentative: "Предварительно",
      confirmed: "Подтверждён",
      in_progress: "Идёт",
      completed: "Завершён",
      cancelled: "Отменён",
    },
    statusActions: {
      inquiry: "В заявки",
      tentative: "Предварительно",
      confirmed: "Подтвердить",
      in_progress: "Начать",
      completed: "Завершить",
      cancelled: "Отменить",
    },
    cancelTitle: "Отменить банкет?",
    cancelHint: "Залы освободятся. Невозвращённые депозиты верните на вкладке «Депозиты».",
    cancelReason: "Отменён в ERP",
    start: "Начать банкет",
    startTitle: "Начать банкет?",
    startHint: "Будет создан заказ из меню, депозит зачтётся в оплату. Нужна открытая кассовая смена.",
    started: "Заказ банкета создан",
    complete: "Завершить",
    completed: "Банкет завершён",
    print: "Предложение",
    proposal: "Коммерческое предложение",
    orderN: "Заказ № {{n}}",
    tabs: {
      menu: "Меню",
      deposits: "Депозиты",
      summary: "Итоги",
    },
    addItem: "Добавить блюдо",
    menuEmpty: "Меню пустое",
    menuEmptyHint: "Добавьте блюда — количество можно указать на гостя.",
    dish: "Блюдо",
    course: "Подача",
    qty: "Кол-во",
    perGuest: "на гостя",
    price: "Цена",
    sum: "Сумма",
    menuTotal: "Итого {{total}} · на гостя {{perGuest}}",
    depositState: "Внесено {{paid}} из {{required}}; зачтено в заказ {{applied}}",
    depositAmount: "Сумма депозита",
    method: "Способ",
    methods: {
      cash: "Наличные",
      card: "Карта",
      bank: "Перевод",
    },
    takeDeposit: "Принять",
    depositAdded: "Депозит принят",
    noDeposits: "Депозитов нет",
    when: "Когда",
    refunded: "Возвращён",
    refund: "Вернуть",
    refundTitle: "Вернуть депозит?",
    refundHint: "{{amount}} — наличные выдаются из кассы.",
    menuSum: "Меню",
    orderSum: "Заказ № {{n}}",
    costSum: "Себестоимость по техкартам",
    costPartial: "не у всех блюд есть техкарта",
    extraCosts: "Доп. расходы",
    profit: "Прибыль",
    deposits: "Депозиты",
    due: "К оплате",
    productsTitle: "Продукты под банкет",
    productsHint: "По техкартам меню на всех гостей; сколько докупить сверх остатка.",
    missingRecipes: "Без техкарты: {{names}}",
    noProducts: "Нет блюд с техкартами",
    product: "Продукт",
    need: "Нужно",
    inStock: "На складе",
    toBuy: "Докупить",
  },
  promotions: {
    title: "Акции",
    description: "Скидки по правилам: happy hours, комбо, «2+1», подарки, промокоды. Совместимость — по приоритету и группам.",
    posHint: "На кассе акции включаются кнопкой «Акции» у заказа — там же вводится промокод.",
    new: "Новая акция",
    empty: "Акций пока нет",
    emptyHint: "Например: «Пиво −30% с 17 до 19» или «Бургер + фри + напиток = 450».",
    tabs: {
      list: "Акции",
      report: "Во что обошлись",
    },
    name: "Название",
    code: "Промокод",
    codeHint: "Необязательно: акция сработает только с этим кодом",
    type: "Тип",
    types: {
      percent: "Скидка в процентах",
      fixed: "Скидка суммой",
      combo: "Комбо по спеццене",
      bogo: "Купи X — получи Y",
      gift: "Подарок",
    },
    percent: "Процент",
    amount: "Сумма скидки",
    buyQty: "Купи",
    getQty: "Получи",
    getPercent: "Скидка на «получи», %",
    slot: "Слот {{n}}",
    addSlot: "Слот",
    removeSlot: "Убрать слот",
    comboPrice: "Цена набора",
    gift: "Подарок",
    giftHint: "Позиция должна быть в заказе — она станет бесплатной",
    target: "На что действует",
    scopes: {
      order: "Весь заказ",
      categories: "Категории",
      items: "Позиции",
    },
    conditions: "Условия",
    minSubtotal: "Заказ от",
    days: "Дни недели",
    daysHint: "Пусто — каждый день",
    timeFrom: "С",
    timeTo: "До",
    timeHint: "Happy hours; через полночь тоже можно",
    dateFrom: "Действует с",
    dateTo: "Действует по",
    customerTag: "Тег клиента",
    customerTagHint: "Например: staff — скидка сотрудникам",
    usageLimit: "Лимит использований",
    firstOrder: "Только первый заказ клиента",
    stackGroup: "Группа совместимости",
    stackGroupHint: "Из одной группы применяется одна, самая выгодная",
    priority: "Приоритет",
    exclusive: "Эксклюзивная",
    exclusiveHint: "Если подходит — другие акции не применяются",
    active: "Действует",
    on: "Действует",
    off: "Выключена",
    orders: "Заказов",
    cost: "Скидка",
    revenue: "Выручка заказов",
    reportEmpty: "За период акции не применялись",
    deleteTitle: "Удалить акцию?",
    fromSum: "от {{sum}}",
    limitN: "лимит {{n}}",
  },
  deliveries: {
    formatOff: "Филиал не работает на доставку",
    formatOffHint: "Включите формат «Доставка» в настройках филиала — без него заказ доставки не создать.",
    formatOffAction: "Настройки филиала",
    title: "Доставка",
    description: "Диспетчерская: заказы по статусам, таймеры до обещанного времени, курьеры и зоны.",
    new: "Новая доставка",
    createAndOpen: "Создать и открыть в кассе",
    created: "Доставка оформлена — добавьте позиции",
    empty: "Доставок в работе нет",
    emptyHint: "Оформите доставку — позиции добавляются в кассе.",
    tabs: {
      board: "В работе",
      done: "Завершённые",
      zones: "Зоны",
      couriers: "Курьеры",
    },
    statuses: {
      new: "Новая",
      confirmed: "Подтверждена",
      cooking: "Готовится",
      ready: "Готова",
      courier_assigned: "Курьер назначен",
      on_the_way: "В пути",
      delivered: "Доставлена",
      failed: "Не удалось",
      cancelled: "Отменена",
      returned: "Возвращена",
    },
    statusActions: {
      new: "Новая",
      confirmed: "Подтвердить",
      cooking: "Готовится",
      ready: "Готова",
      courier_assigned: "Назначить",
      on_the_way: "В пути",
      delivered: "Доставлена",
      failed: "Не удалось",
      cancelled: "Отменить",
      returned: "Вернулась",
    },
    payments: {
      prepaid: "Оплачено",
      cash: "Наличные курьеру",
      card: "Карта курьеру",
    },
    changeFrom: "сдача с {{sum}}",
    changeFromLabel: "Сдача с купюры",
    lateBy: "опоздание {{n}} мин",
    leftN: "осталось {{n}} мин",
    noItems: "позиций ещё нет",
    noCourier: "Без курьера",
    courier: "Курьер",
    openPos: "В кассе",
    reasonHint: "Действие попадёт в журнал.",
    byDispatcher: "Отмечено диспетчером",
    customer: "Имя гостя",
    phone: "Телефон",
    street: "Улица, дом",
    entrance: "Подъезд",
    floor: "Этаж",
    apartment: "Квартира",
    comment: "Комментарий курьеру",
    zone: "Зона",
    zoneHint: "По координатам определяется сама",
    noZone: "Без зоны (стоимость вручную)",
    coords: "Координаты",
    coordsHint: "Широта, долгота — из карт (необязательно)",
    payment: "Оплата",
    scheduledAt: "Ко времени",
    scheduledHint: "Пусто — как можно скорее",
    entranceN: "подъезд {{n}}",
    floorN: "этаж {{n}}",
    aptN: "кв. {{n}}",
    address: "Адрес",
    promised: "Обещано",
    newZone: "Новая зона",
    zoneName: "Название",
    zoneKind: "Форма",
    kinds: {
      circle: "Круг",
      polygon: "Многоугольник",
    },
    center: "Центр",
    radius: "Радиус, м",
    polygon: "Вершины",
    polygonHint: "По одной на строке: широта, долгота",
    fee: "Стоимость",
    freeFrom: "Бесплатно от",
    freeFromHint: "0 — всегда платно",
    minOrder: "Мин. заказ",
    eta: "Время доставки, мин",
    zoneActive: "Действует",
    off: "Выключена",
    noZones: "Зон пока нет",
    noZonesHint: "Без зон адрес не проверяется — стоимость указывается вручную.",
    radiusN: "радиус {{n}} м",
    pointsN: "{{n}} точек",
    freeFromN: "бесплатно от {{sum}}",
    minN: "{{n}} мин",
    noCouriers: "Курьеров нет",
    noCouriersHint: "Добавьте сотрудника с ролью «Курьер».",
    activeN: "В работе",
    onHand: "Наличные на руках",
    handover: "Принять наличные",
    handoverTitle: "Принять наличные у {{name}}?",
    handoverHint: "Курьер сдаёт {{sum}}.",
    handedOver: "Наличные приняты",
    reportTitle: "Отчёт по курьерам",
    noData: "Нет данных",
    delivered: "Доставлено",
    lateCount: "Опоздания",
    failedCount: "Не удалось",
    avgTime: "Среднее время",
    cash: "Наличные",
  },
  courier: {
    title: "Мои доставки",
    description: "Заказы, назначенные вам: адрес, звонок, маршрут и статус.",
    empty: "Доставок нет",
    emptyHint: "Когда диспетчер назначит заказ, он появится здесь.",
    paid: "Оплачено",
    collectCash: "Получить наличными {{sum}}",
    collectCard: "Оплата картой {{sum}}",
    call: "Позвонить",
    route: "Маршрут",
    go: "Выехал",
    delivered: "Доставлено",
    failed: "Не удалось",
    failTitle: "Не удалось доставить?",
    failHint: "Диспетчер увидит причину и решит, что делать.",
    failReason: "Не получилось вручить",
    deliveredToast: "Отмечено: доставлено",
  },
  ai: {
    "quota": {
      "left": "Осталось {{remaining}} из {{limit}} запросов в этом месяце",
      "more": "Добавить запросы",
      "exhausted": "Запросы к Coca AI на этот месяц закончились. Подключите пакет «+500 запросов к помощнику» в разделе «Подписка» или дождитесь следующего месяца."
    },
    "hint": {
      "title": "Совет Coca AI",
      "updated": "Обновлено {{time}}",
      "get": "Получить совет",
      "refresh": "Обновить совет (1 запрос)",
      "hide": "Скрыть",
      "topics": {
        "sales": "Что важно в продажах за период — 1 запрос",
        "menu": "Что поменять в меню — 1 запрос",
        "writeoffs": "Как сократить списания — 1 запрос",
        "products": "Где перерасход продуктов — 1 запрос",
        "waiters": "Как работает команда — 1 запрос",
        "finance": "Куда уходят деньги — 1 запрос",
        "stock": "Что дозаказать — 1 запрос"
      }
    },
    "button": "Coca AI — скоро",
    "title": "Coca AI",
    "soon": "Скоро",
    "eyebrow": "Coca AI · скоро",
    "heroTitle": "Ваш ресторан обретает",
    "heroAccent": "собственный интеллект",
    "heroText": "Второй пилот, который видит каждый чек, каждую смену и каждый грамм на складе. Он предсказывает, советует и действует раньше, чем вы успеете спросить.",
    "explore": "Что он умеет",
    "notify": "Сообщить мне первым",
    "notified": "Вы в списке первых",
    "notifyDone": "Готово! Вы узнаете о запуске Coca AI первыми.",
    "featuresTitle": "Суперсилы для",
    "featuresAccent": "всей команды",
    "featuresText": "Нейросеть, обученная на данных вашего заведения: меню, продажи, склад, персонал и гости — в одной картине.",
    "finalEyebrow": "Будущее общепита",
    "soonBig": "Скоро",
    "finalText": "Мы обучаем Coca AI прямо сейчас. Оставьте заявку — и ваше заведение получит доступ одним из первых.",
    "chat": {
      "button": "Coca AI — помощник",
      "eyebrow": "Coca AI · бета",
      "ask": "Задать вопрос",
      "text": "Спросите о продажах, меню, официантах, списаниях или складе — помощник сам посмотрит отчёты вашего филиала и ответит цифрами. Видит только то, что разрешено вашей роли.",
      "subtitle": "Отвечает по данным вашего филиала",
      "live": "Работает",
      "hello": "Здравствуйте! Я смотрю отчёты этого филиала. Спросите, например:",
      "suggestions": {
        "yesterday": "Как прошёл вчерашний день?",
        "menu": "Какие блюда продаются хуже всего за месяц?",
        "stock": "Что заканчивается на складе?",
        "waiters": "Кто из официантов лучше всех за неделю?"
      },
      "placeholder": "Ваш вопрос…",
      "send": "Отправить",
      "clear": "Начать заново",
      "voice": "Голосовой ввод",
      "voiceStop": "Остановить запись",
      "voiceDenied": "Нет доступа к микрофону — разрешите его в настройках браузера.",
      "voiceFailed": "Не удалось распознать речь. Попробуйте ещё раз.",
      "thinking": "Смотрю данные…",
      "sources": "Смотрел",
      "tools": {
        "sales_report": "продажи",
        "menu_report": "продажи по блюдам",
        "waiters_report": "официанты",
        "writeoffs_report": "списания",
        "products_report": "продукты",
        "finance_report": "финансы",
        "low_stock": "склад"
      },
      "empty": "Не удалось сформулировать ответ. Попробуйте спросить иначе.",
      "notConfigured": "Помощник не подключён: на сервере не задан ключ ИИ (Claude или Gemini).",
      "unavailable": "Помощник временно недоступен. Попробуйте через минуту.",
      "disclaimer": "Ответы готовит ИИ — важные решения сверяйте с отчётами."
    },
    "demo": {
      "eyebrow": "Просто спросите",
      "heading": "Разговаривайте с бизнесом на человеческом языке",
      "text": "Никаких фильтров и выгрузок. Задайте вопрос, как управляющему, — Coca AI ответит цифрами, причинами и готовым планом действий.",
      "title": "Coca AI",
      "subtitle": "Аналитик, шеф и маркетолог в одном окне",
      "thinking": "ИИ думает",
      "dialogs": {
        "revenue": {
          "q": "Почему во вторник выручка ниже на 18%?",
          "a": "Средний чек не изменился, но вечером было на 40 гостей меньше: дождь и футбол. В похожие дни работает комбо «ужин на двоих» — запустить его на следующий вторник?"
        },
        "purchase": {
          "q": "Что заказать поставщикам на выходные?",
          "a": "Прогноз: +35% к будням. Говядина — 14 кг, сливки — 9 л, лосось — 6 кг. Черновики заказов уже готовы, осталось подтвердить."
        },
        "menu": {
          "q": "Какие блюда убрать из меню?",
          "a": "3 позиции продаются редко и почти не приносят маржи. «Паста с креветками» — ваша звезда: поднимите её в меню, и заработок с неё может вырасти на 12%."
        }
      }
    },
    "features": {
      "forecast": {
        "title": "Прогноз спроса",
        "text": "Предсказывает гостей, выручку и загрузку кухни по часам с учётом погоды, праздников и событий в городе.",
        "tag": "Предиктивная аналитика"
      },
      "purchasing": {
        "title": "Автозакупки",
        "text": "Сам считает, что и сколько заказать, чтобы ничего не закончилось и ничего не пропало.",
        "tag": "Ноль списаний"
      },
      "menu": {
        "title": "ИИ-шеф меню",
        "text": "Находит звёзд и балласт меню, подсказывает цены и новые блюда из того, что уже лежит на складе.",
        "tag": "Меню-инжиниринг"
      },
      "fraud": {
        "title": "Радар злоупотреблений",
        "text": "Замечает подозрительные удаления, скидки и недостачи раньше, чем они станут привычкой.",
        "tag": "Защита 24/7"
      },
      "staff": {
        "title": "Умный график",
        "text": "Составляет смены под прогноз загрузки: людей хватает в час пик и нет лишних в тихие часы.",
        "tag": "Экономия ФОТ"
      },
      "marketing": {
        "title": "Маркетинг на автопилоте",
        "text": "Сегментирует гостей, пишет SMS и акции под каждого и сам выбирает лучший момент для отправки. Возвращает тех, кто давно не заходил.",
        "tag": "Персонализация"
      },
      "voice": {
        "title": "Голосовой помощник",
        "text": "Официант говорит заказ — касса его записывает. Руки свободны, ошибок меньше.",
        "tag": "Голос → заказ"
      }
    },
    "stats": {
      "title": "Цели, ради которых мы обучаем Coca AI",
      "waste": {
        "value": "−30%",
        "label": "списаний продуктов"
      },
      "check": {
        "value": "+15%",
        "label": "к среднему чеку"
      },
      "hours": {
        "value": "10 ч",
        "label": "в неделю экономии управляющему"
      },
      "always": {
        "value": "24/7",
        "label": "на связи и без выходных"
      }
    },
    "steps": {
      "title": "Как это работает",
      "data": {
        "title": "Данные",
        "text": "Продажи, склад, смены и гости уже собраны в Coca — ничего настраивать не нужно."
      },
      "brain": {
        "title": "Интеллект",
        "text": "Модель находит закономерности, которые не видны в таблицах, и объясняет их простыми словами."
      },
      "action": {
        "title": "Действие",
        "text": "Каждый совет — с кнопкой: заказать, запустить акцию, поправить график. Решение всегда за вами."
      }
    }
  },
  "warehouse": {
    "warehouse": "Склад",
    "pick": "Склад",
    "kinds": {
      "main": "Основной",
      "kitchen": "Кухня",
      "bar": "Бар",
      "central": "Центральный",
      "other": "Прочий"
    },
    "title": "Склады",
    "description": "Остатки хранятся по складам. С основного склада продажи списываются по техкартам, кухня и бар получают товар перемещением.",
    "add": "Добавить склад",
    "editTitle": "Склад",
    "name": "Название",
    "namePlaceholder": "Кухня горячего цеха",
    "kind": "Назначение",
    "mainKindHint": "У основного склада назначение не меняется",
    "negative": "Разрешить уход в минус",
    "negativeHint": "Списания и перемещения больше остатка не будут блокироваться",
    "negativeShort": "Можно в минус",
    "makeDefault": "Сделать основным",
    "defaultHint": "Продажи по техкартам будут списываться с этого склада",
    "default": "Основной",
    "defaultChanged": "Основной склад: {{name}}",
    "deleteTitle": "Удалить склад «{{name}}»?",
    "deleteHint": "Удалить можно только пустой склад без перемещений в пути.",
    "count": "Складов: {{count}}",
    "limit": "лимит тарифа — {{n}}",
    "products": "Продуктов с остатком",
    "openStock": "Остатки",
    "onlyMain": "Пока только основной склад",
    "onlyMainHint": "Добавьте кухню, бар или центральный склад — и перемещайте товар между ними."
  },
  "expiry": {
    "title": "Сроки годности",
    "description": "Партии со сроком годности по складам филиала. Продажи и списания берут сначала то, что раньше истекает.",
    "expired": "Просрочено партий",
    "soon": "Истекает за {{n}} дн.",
    "filter": "Показать",
    "states": {
      "expired": "Просрочено",
      "soon": "Скоро истекает",
      "dated": "Все со сроком",
      "all": "Все партии"
    },
    "days": "Срок",
    "inDays": "в течение {{count}} дн.",
    "received": "Поступило",
    "expiresAt": "Годен до",
    "noDate": "Без срока",
    "overdue": "Просрочено на {{count}} дн.",
    "today": "Истекает сегодня",
    "left": "Осталось {{count}} дн.",
    "writeoff": "Списать",
    "writeoffTitle": "Списать «{{name}}»?",
    "writeoffHint": "Будет списано {{qty}} на {{sum}}. Партии с ближайшим сроком списываются первыми.",
    "writeoffComment": "Срок годности до {{date}}",
    "writtenOff": "Списано",
    "empty": "Нет партий с истекающим сроком",
    "emptyExpired": "Просроченных партий нет",
    "emptyHint": "Указывайте срок годности при закупке или задайте срок хранения продукта — он подставится сам."
  },
  "transfers": {
    "title": "Перемещения",
    "description": "Товар между складами: внутри филиала — сразу, в другой филиал — «в пути» до приёмки.",
    "new": "Новое перемещение",
    "from": "Откуда",
    "to": "Куда",
    "pickBoth": "Выберите оба склада",
    "addLines": "Добавьте продукты и количество",
    "send": "Отправить",
    "move": "Переместить",
    "externalHint": "Склад филиала «{{branch}}»: товар уйдёт «в пути», остаток у получателя появится после приёмки.",
    "internalHint": "Склад вашего филиала: товар переместится сразу.",
    "doneInternal": "Перемещение №{{n}} проведено",
    "doneSent": "Перемещение №{{n}} отправлено в «{{branch}}»",
    "titleN": "Перемещение №{{n}}",
    "sent": "Отправлено",
    "received": "Принято",
    "receive": "Принять",
    "receiveHint": "Проверьте количество: если пришло меньше — укажите фактическое, недостача зафиксируется.",
    "receiveComment": "Комментарий к приёмке",
    "receiveCommentPlaceholder": "Например: пакет повреждён",
    "receivedToast": "Перемещение №{{n}} принято",
    "cancel": "Отменить перемещение",
    "cancelTitle": "Отменить перемещение №{{n}}?",
    "cancelHint": "Товар вернётся на склад-отправитель.",
    "print": "Акт",
    "actTitle": "Акт перемещения №{{n}}",
    "signFrom": "Отпустил",
    "signTo": "Принял",
    "shipped": "Отправлено",
    "receivedAt": "Принято",
    "shortage": "Недостача",
    "shortageNote": "При приёмке недостача на {{sum}}.",
    "statuses": {
      "in_transit": "В пути",
      "received": "Принято",
      "cancelled": "Отменено"
    },
    "incoming": "Входящих перемещений: {{count}}",
    "incomingHint": "Товар отправлен в ваш филиал — примите его, чтобы он появился в остатках.",
    "showIncoming": "Показать",
    "direction": "Направление",
    "dirAll": "Все",
    "dirIn": "Входящие",
    "dirOut": "Исходящие",
    "allStatuses": "Все статусы",
    "route": "Маршрут",
    "empty": "Перемещений пока нет",
    "emptyHint": "Переместите продукты со склада на кухню или в другой филиал."
  },
  "production": {
    "suggest": "Предложить план",
    "suggestComment": "По прогнозу",
    "suggestCreated": "Запланировано заказов: {{count}}",
    "suggestTitle": "План на {{date}} по прогнозу",
    "suggestHint": "Средний расход по тому же дню недели за {{weeks}} нед. + запас {{pct}}% − остаток на складах − уже запланированное.",
    "suggestCreate": "Запланировать: {{count}}",
    "suggestEmpty": "Нет полуфабрикатов с техкартой",
    "suggestEmptyHint": "Создайте продукт типа «Полуфабрикат» и опубликуйте его техкарту.",
    "suggestSales": "Расход по неделям",
    "suggestAvg": "Прогноз",
    "suggestHave": "Есть и в плане",
    "suggestMake": "Сделать",
    "title": "Производство",
    "description": "Полуфабрикаты по техкартам: план на день, выпуск с точной себестоимостью, сроки годности и этикетки.",
    "new": "Запланировать производство",
    "newHint": "Выберите полуфабрикат с техкартой и сколько нужно сделать — потребность в сырье посчитается сама.",
    "plan": "Запланировать",
    "product": "Полуфабрикат",
    "productHint": "Тип «Полуфабрикат» с опубликованной техкартой",
    "productPlaceholder": "Тесто, соус, бульон…",
    "qty": "Сколько сделать",
    "date": "Дата",
    "rawWarehouse": "Склад сырья",
    "outWarehouse": "Склад готового",
    "requirements": "Потребность в сырье",
    "estTotal": "Оценка стоимости",
    "shortagesTitle": "Не хватает продуктов: {{count}}",
    "shortagesHint": "Докупите или переместите продукты на склад сырья до выпуска.",
    "fillProduct": "Выберите полуфабрикат и количество",
    "created": "Заказ №{{n}} запланирован",
    "raw": "Сырьё",
    "semi": "ПФ",
    "need": "Нужно",
    "used": "Списано",
    "cost": "Стоимость",
    "available": "На складе",
    "short": "Не хватает {{qty}}",
    "enough": "Хватает",
    "estCost": "Оценка",
    "completeTitle": "Выпуск: {{name}}",
    "completeHint": "Сырьё спишется со склада, полуфабрикат придёт на склад партией со сроком годности.",
    "complete": "Провести выпуск",
    "actual": "Фактический выход",
    "planned": "План: {{qty}}",
    "expiresAt": "Годен до",
    "shelfLife": "Срок хранения продукта: {{count}} дн.",
    "noShelfLife": "Срок хранения у продукта не задан",
    "deviation": "Отклонение выхода от плана: {{pct}}%",
    "customUsage": "Расход отличался от техкарты",
    "customUsageHint": "Укажите, сколько сырья фактически ушло",
    "shortWarn": "Сырья на складе меньше, чем нужно: выпуск не пройдёт, если склад не разрешает уход в минус.",
    "fillActual": "Укажите фактический выход",
    "completedToast": "Выпуск №{{n}} проведён",
    "start": "Начать",
    "cancel": "Отменить",
    "cancelTitle": "Отменить заказ №{{n}}?",
    "cancelHint": "Остатки не изменятся.",
    "cancelDoneTitle": "Отменить выпуск №{{n}}?",
    "cancelDoneHint": "Сырьё вернётся на склад, полуфабрикат спишется. Если его уже израсходовали — отмена не пройдёт.",
    "statuses": {
      "planned": "Запланировано",
      "in_progress": "В работе",
      "completed": "Готово",
      "cancelled": "Отменено"
    },
    "planShort": "План",
    "fact": "Факт",
    "rawCost": "Стоимость сырья",
    "unitCost": "Себестоимость за {{unit}}",
    "unitCostShort": "Себестоимость",
    "lowYield": "Выход ниже плана на {{pct}}% — проверьте закладку и потери.",
    "label": "Этикетка",
    "labelHint": "Название, дата выпуска, срок годности до {{date}}, повар",
    "copies": "Копий",
    "printLabel": "Печать этикеток",
    "labelMade": "Сделано",
    "labelUntil": "Годен до",
    "labelQty": "Кол-во",
    "labelBy": "Повар",
    "createdBy": "Создал: {{name}}, {{at}}",
    "completedBy": "Выпустил: {{name}}, {{at}}",
    "yield": "Выход {{pct}}%",
    "prevDay": "Предыдущий день",
    "nextDay": "Следующий день",
    "today": "Сегодня",
    "addToPlan": "Добавить в план",
    "emptyDay": "На этот день ничего не запланировано",
    "emptyDayHint": "Запланируйте заготовки — кухня увидит их здесь.",
    "emptyColumn": "Пусто",
    "allStatuses": "Все статусы",
    "planFact": "План / факт",
    "empty": "Производственных заказов нет",
    "tabPlan": "План на день",
    "tabHistory": "Все заказы",
    "tabReport": "Отчёт",
    "repOrders": "Выпусков",
    "repLowYield": "Позиций с выходом ниже плана",
    "repYield": "Выход",
    "repEmpty": "За период выпусков нет"
  },
  "promo": {
    "badge": "Дополнение · не подключено",
    "genericTagline": "«{{name}}» не входит в ваш тариф. Подключите — и раздел заработает сразу.",
    "connect": "Подключить",
    "connectFor": "Подключить за {{price}} в месяц",
    "changePlan": "Сменить тариф",
    "openSubscription": "Открыть подписку",
    "askOwner": "Подключить может владелец или администратор — попросите их открыть «Подписку».",
    "allAddons": "Все дополнения",
    "inPlans": "Входит в тариф: {{plans}}",
    "fineprint": "Сначала покажем сумму — подключение только после вашего подтверждения. Отключить можно в любой момент.",
    "insideTitle": "Что внутри",
    "bandTitle": "Готовы попробовать?",
    "bandText": "«{{name}}» включается за минуту — данные и настройки сохранятся.",
    "items": {
      "inventory_pro": {
        "title": "Склад без потерь: несколько складов, сроки и перемещения",
        "tagline": "Кухня, бар и центральный склад — каждый со своими остатками. Система следит за сроками годности, списывает сначала то, что скоро испортится, и переносит товар между точками за пару кликов.",
        "b1": {
          "t": "Сроки годности под контролем",
          "d": "Каждая партия помнит свой срок. Каждое утро — список того, что истекает, а продажи списывают сначала самое «старое»."
        },
        "b2": {
          "t": "Несколько складов",
          "d": "Основной склад, кухня, бар, центральный склад сети — остатки и стоимость видны отдельно по каждому."
        },
        "b3": {
          "t": "Перемещения между точками",
          "d": "Склад → кухня — сразу; в другой филиал — «в пути» до приёмки. Недостача при приёмке фиксируется сама."
        },
        "b4": {
          "t": "Меньше списаний — больше прибыли",
          "d": "Видно, что и на какую сумму вот-вот пропадёт, — успеете пустить в работу или в акцию."
        },
        "f1": "FEFO: сначала уходит то, что раньше истекает",
        "f2": "Срок партии: при закупке или сам — по сроку хранения",
        "f3": "Уведомление «истекает» в приложении и Telegram",
        "f4": "Перемещения с актом для печати",
        "f5": "Остатки и карточка движения по каждому складу",
        "f6": "Инвентаризация отдельного склада",
        "who": "Для заведений с кухней и баром, сетей с центральным складом и всех, кто работает со скоропортящимися продуктами."
      },
      "production": {
        "title": "Производство полуфабрикатов",
        "tagline": "Тесто, соусы, бульоны и заготовки — по техкарте, с точной себестоимостью и сроком годности. Повар видит план на день, а вы — сколько стоил каждый килограмм.",
        "b1": {
          "t": "План на день",
          "d": "Кухня видит, что и сколько заготовить сегодня: «запланировано» → «в работе» → «готово»."
        },
        "b2": {
          "t": "Себестоимость до тыйына",
          "d": "Сырьё списывается по техкарте, себестоимость ПФ = стоимость сырья ÷ фактический выход. Она же идёт в себестоимость блюд."
        },
        "b3": {
          "t": "Контроль выхода",
          "d": "Отклонение фактического выхода от планового видно сразу — понятно, где теряется продукт."
        },
        "b4": {
          "t": "Этикетки и сроки",
          "d": "Партия ПФ получает срок годности, этикетка печатается в один клик: название, дата, срок, повар."
        },
        "f1": "Потребность в сырье и нехватка до начала работы",
        "f2": "Выпуск одним действием: сырьё списано, ПФ на складе",
        "f3": "Свой расход сырья, если он отличался от техкарты",
        "f4": "При продаже списывается готовый ПФ, а не мука и вода",
        "f5": "Отчёт: план, факт, отклонение выхода, себестоимость",
        "f6": "Отмена выпуска — сторно с возвратом сырья",
        "who": "Для пиццерий, пекарен, кафе с заготовками и кухонь, которые готовят соусы и полуфабрикаты впрок."
      },
      "procurement": {
        "title": "Закупки и поставщики",
        "tagline": "Все поставщики, их счета, сроки оплаты и долги — в одном окне. Никаких тетрадей и забытых платежей.",
        "b1": {
          "t": "Долги поставщикам под контролем",
          "d": "Сколько, кому и до какого числа нужно заплатить — с напоминаниями о просрочке."
        },
        "b2": {
          "t": "Оплаты и авансы",
          "d": "Наличными из кассы или переводом, частями, наперёд — всё сходится само."
        },
        "b3": {
          "t": "Возвраты поставщику",
          "d": "Вернули товар — долг уменьшился автоматически, по ценам закупки."
        },
        "b4": {
          "t": "Акт сверки за минуту",
          "d": "Печатаете акт сверки за период и закрываете вопросы с поставщиком."
        },
        "f1": "Справочник поставщиков с отсрочкой оплаты",
        "f2": "Закупка = счёт поставщика со сроком",
        "f3": "Уведомление о сроке оплаты и просрочке",
        "f4": "Возвраты товара и возврат денег от поставщика",
        "f5": "Что и почём закупали у каждого",
        "f6": "Акт сверки на A4",
        "who": "Для всех, кто работает с поставщиками в долг или с отсрочкой."
      },
      "finance": {
        "title": "Финансы заведения",
        "tagline": "Прибыль, расходы и движение денег — каждый день, а не в конце месяца. Видно, куда уходят деньги и сколько вы реально зарабатываете.",
        "b1": {
          "t": "Прибыль за любой период",
          "d": "Выручка, себестоимость, зарплата, аренда и прочие расходы — в одном отчёте."
        },
        "b2": {
          "t": "Расходы по категориям",
          "d": "Аренда, коммуналка, маркетинг — вносятся за секунды, отчёт считает сам."
        },
        "b3": {
          "t": "Движение денег",
          "d": "Сколько пришло и ушло наличными и безналом, сколько должны вам и вы."
        },
        "b4": {
          "t": "Решения на цифрах",
          "d": "Понятно, что сократить, а что развивать."
        },
        "f1": "Отчёт о прибылях и убытках",
        "f2": "Расходы по категориям и филиалам",
        "f3": "Зарплата и чаевые попадают в отчёт сами",
        "f4": "Долги гостей и поставщикам — в движении денег",
        "f5": "Расходы из кассы — сразу в отчёте",
        "who": "Для владельцев, которые хотят знать реальную прибыль, а не только выручку."
      },
      "fraud": {
        "title": "Защита от злоупотреблений",
        "tagline": "Система каждый час проверяет удаления, скидки, возвраты и недостачи и сразу сообщает о подозрительном. Касса под присмотром, даже когда вас нет рядом.",
        "b1": {
          "t": "Подозрительное видно сразу",
          "d": "Удаления после кухни, возвраты наличными за карту, скидки сверх нормы — в одной ленте."
        },
        "b2": {
          "t": "Риск по сотрудникам",
          "d": "У каждого сотрудника — баллы риска: видно, к кому присмотреться."
        },
        "b3": {
          "t": "Уведомления в Telegram",
          "d": "О серьёзном — сразу, раз в неделю — сводка."
        },
        "b4": {
          "t": "Ваши правила",
          "d": "Пороги для каждого правила настраиваются под ваше заведение."
        },
        "f1": "Удаления позиций и отмены после кухни",
        "f2": "Возвраты, в том числе наличными за карту",
        "f3": "Доля ручных скидок и продажи ниже цены меню",
        "f4": "Необычно большие списания",
        "f5": "Недостачи в кассе и их повторы",
        "f6": "Решения: проверено, ложная тревога, подтверждено",
        "who": "Для владельцев, которые не могут быть в заведении каждый день."
      },
      "sms": {
        "title": "SMS-рассылки гостям",
        "tagline": "Напомните о себе в нужный момент: акция, новое меню, поздравление с днём рождения. Отправка выбранным гостям в пару кликов.",
        "b1": {
          "t": "Точно в цель",
          "d": "Сегменты и теги: постоянные, давно не приходили, именинники недели."
        },
        "b2": {
          "t": "Только с согласия",
          "d": "Рассылка уходит лишь гостям, согласившимся получать сообщения."
        },
        "b3": {
          "t": "Прозрачный расход",
          "d": "Видно, сколько SMS осталось в месяце; на 80% и 100% придёт предупреждение."
        },
        "b4": {
          "t": "Возвращайте гостей",
          "d": "Короткое предложение в SMS — и гость снова у вас."
        },
        "f1": "Рассылка по сегменту или тегу",
        "f2": "Поздравления с днём рождения",
        "f3": "Подсчёт частей SMS до отправки",
        "f4": "Тестовое SMS себе",
        "f5": "Статусы доставки",
        "who": "Для заведений с базой гостей, которые хотят чаще видеть постоянных клиентов."
      },
      "services": {
        "title": "Услуги и аренда",
        "tagline": "Караоке, бильярд, кальян, VIP-комнаты — почасовая тарификация с таймером на сервере, минимальный заказ и комиссии персоналу считаются сами.",
        "b1": {
          "t": "Таймер, которому верят",
          "d": "Время идёт на сервере, паузы учитываются — никаких споров с гостем."
        },
        "b2": {
          "t": "Гибкие тарифы",
          "d": "Цена за час, шаг округления, минимум, ступени и цена по расписанию."
        },
        "b3": {
          "t": "Минимальный заказ комнаты",
          "d": "Не добрали — доплата добавится в счёт сама."
        },
        "b4": {
          "t": "Комиссии персоналу",
          "d": "Фиксированные, процентом или смешанные — сразу в отчёте."
        },
        "f1": "Почасовые и штучные услуги",
        "f2": "Комнаты с минимальным заказом",
        "f3": "Пауза и продолжение сессии",
        "f4": "Услуга сразу в счёте гостя",
        "f5": "Комиссии сотрудникам и отчёт",
        "who": "Для караоке, лаунж-баров, бильярдных, кальянных и заведений с VIP-комнатами."
      },
      "banquets": {
        "title": "Банкеты и мероприятия",
        "tagline": "От заявки до закрытия счёта: меню на гостя, депозиты, бронирование залов и себестоимость — всё в одной карточке банкета.",
        "b1": {
          "t": "Ни одна заявка не потеряется",
          "d": "Заявка → предварительно → подтверждён → идёт → завершён."
        },
        "b2": {
          "t": "Депозиты без путаницы",
          "d": "Депозит принимается и сам зачитывается в счёт банкета."
        },
        "b3": {
          "t": "Зал не продадут дважды",
          "d": "Подтверждённый банкет блокирует зал для броней."
        },
        "b4": {
          "t": "Себестоимость и продукты",
          "d": "Сразу видно маржу банкета и сколько продуктов закупить."
        },
        "f1": "Меню на гостя и на весь стол",
        "f2": "Депозиты наличными и переводом",
        "f3": "Печать коммерческого предложения",
        "f4": "Потребность в продуктах по техкартам",
        "f5": "Заказ банкета на кассе в один клик",
        "who": "Для ресторанов, банкетных залов и кафе, которые принимают праздники и корпоративы."
      },
      "promotions_pro": {
        "title": "Акции и промокоды",
        "tagline": "Счастливые часы, комбо, «второй в подарок», подарки и промокоды — касса применяет лучшую акцию сама, без ошибок кассира.",
        "b1": {
          "t": "Любая механика",
          "d": "Скидка в процентах или суммой, комбо, «1+1», подарок к заказу."
        },
        "b2": {
          "t": "Точные условия",
          "d": "Дни недели, часы, даты, филиалы, тип заказа, первый заказ, тег гостя."
        },
        "b3": {
          "t": "Без конфликтов",
          "d": "Эксклюзивные и совместимые акции: гость получает самую выгодную."
        },
        "b4": {
          "t": "Результат в цифрах",
          "d": "Отчёт: сколько раз сработала акция и во сколько обошлась."
        },
        "f1": "Счастливые часы, в том числе через полночь",
        "f2": "Промокоды с лимитами",
        "f3": "Комбо-наборы и «1+1»",
        "f4": "Подарок к заказу",
        "f5": "Отчёт по акциям",
        "who": "Для заведений, которые хотят заполнить тихие часы и поднять средний чек."
      },
      "delivery": {
        "title": "Своя доставка",
        "tagline": "Зоны на карте, курьеры, статусы и деньги у курьеров — доставка работает как часы, а гость видит статус заказа.",
        "b1": {
          "t": "Зоны и стоимость",
          "d": "Полигоны и радиусы, минимальный заказ, бесплатная доставка от суммы."
        },
        "b2": {
          "t": "Доска доставок",
          "d": "Новые → готовятся → в пути → доставлено: таймеры показывают опоздания."
        },
        "b3": {
          "t": "Экран курьера",
          "d": "«Мои доставки», статусы и геопозиция — с телефона."
        },
        "b4": {
          "t": "Наличные под контролем",
          "d": "Видно, сколько денег у каждого курьера; сдача в кассу — в один клик."
        },
        "f1": "Проверка адреса по зоне",
        "f2": "Назначение курьера",
        "f3": "Статус доставки для гостя",
        "f4": "Сдача наличных курьером",
        "f5": "Отчёт по доставкам",
        "who": "Для заведений с собственными курьерами."
      },
      "reservations": {
        "title": "Бронирование столов",
        "tagline": "Брони на кассе и в ERP: стол заранее отмечается как забронированный — никто не посадит гостей на чужое место.",
        "b1": {
          "t": "Зал с бронями",
          "d": "Видно, какие столы заняты, свободны и забронированы."
        },
        "b2": {
          "t": "Без накладок",
          "d": "Пересекающиеся брони на один стол не создать."
        },
        "b3": {
          "t": "Статус «бронь» за час",
          "d": "Стол сам помечается перед приходом гостей."
        },
        "b4": {
          "t": "История гостя",
          "d": "Бронь связывается с карточкой клиента."
        },
        "f1": "Брони с кассы и из ERP",
        "f2": "Количество гостей и комментарий",
        "f3": "Перенос и отмена",
        "f4": "Работает и на кассе без интернета",
        "f5": "Список броней на день",
        "who": "Для ресторанов и кафе, где столы бронируют заранее."
      },
      "analytics_pro": {
        "title": "Расширенная аналитика",
        "tagline": "ABC-анализ, меню-инжиниринг, food cost и тепловая карта загрузки — видно, какие блюда кормят бизнес, а какие тянут вниз.",
        "b1": {
          "t": "Меню-инжиниринг",
          "d": "Звёзды, рабочие лошадки, загадки и аутсайдеры: что продвигать, что переделать, что убрать."
        },
        "b2": {
          "t": "ABC-анализ",
          "d": "Какие 20% позиций дают 80% выручки и маржи."
        },
        "b3": {
          "t": "Food cost и labor cost",
          "d": "Себестоимость продуктов и труда по дням и категориям."
        },
        "b4": {
          "t": "Тепловая карта",
          "d": "Загрузка по дням недели и часам — график смен под реальный поток гостей."
        },
        "f1": "ABC по выручке, марже, количеству, продуктам и гостям",
        "f2": "Матрица меню",
        "f3": "Prime cost и выручка на час труда",
        "f4": "Сравнение филиалов",
        "f5": "Выгрузка CSV для Excel",
        "who": "Для владельцев и управляющих, которые принимают решения на цифрах."
      },
      "telegram": {
        "title": "Telegram-бот владельца",
        "tagline": "Выручка за день, склад, оплаты поставщикам и тревоги — прямо в Telegram, где бы вы ни были.",
        "b1": {
          "t": "Дневной отчёт",
          "d": "Каждый вечер — выручка, чеки, средний чек, топ блюд."
        },
        "b2": {
          "t": "Важное — сразу",
          "d": "Возвраты, закрытие смены, «заканчивается на складе»."
        },
        "b3": {
          "t": "Команда /today",
          "d": "Итоги дня по запросу одним сообщением."
        },
        "b4": {
          "t": "У каждого — своё",
          "d": "Сотрудник получает только то, на что у него есть права."
        },
        "f1": "Дневной отчёт по филиалам",
        "f2": "Уведомления о сменах и возвратах",
        "f3": "Склад: заканчивается и истекает",
        "f4": "Оплаты поставщикам",
        "f5": "Подключение по одной ссылке",
        "who": "Для владельцев и управляющих, которые хотят держать руку на пульсе."
      },
      "qr_ordering": {
        "title": "Заказ по QR-коду",
        "tagline": "Гость сканирует QR на столе, выбирает блюда и отправляет заказ — он сразу появляется на кассе и на кухне. Меньше ожидания, больше заказов.",
        "b1": {
          "t": "Без ожидания официанта",
          "d": "Гость заказывает, когда готов, — и чаще берёт ещё."
        },
        "b2": {
          "t": "Сразу на кухню",
          "d": "Заказ уходит на экран кухни автоматически."
        },
        "b3": {
          "t": "Позвать официанта и счёт",
          "d": "Кнопки на телефоне гостя — уведомление на кассе."
        },
        "b4": {
          "t": "Статус заказа",
          "d": "Гость видит, что блюдо готовится."
        },
        "f1": "QR для каждого стола с печатью",
        "f2": "Варианты и модификаторы блюд",
        "f3": "Дозаказ в тот же счёт",
        "f4": "Защита от спама заказами",
        "f5": "Уведомления официантам",
        "who": "Для кафе и ресторанов с обслуживанием в зале."
      },
      "debts": {
        "title": "Долги гостей",
        "tagline": "Продажа «в долг» постоянным гостям и сотрудникам компаний — с лимитом, сроком и погашением в кассе. Никаких тетрадей.",
        "b1": {
          "t": "Лимит на гостя",
          "d": "Касса не даст превысить кредитный лимит."
        },
        "b2": {
          "t": "Погашение в кассе",
          "d": "Наличными через смену; долг закрывается сам, старые — первыми."
        },
        "b3": {
          "t": "Отчёт по просрочке",
          "d": "Кто, сколько и как давно должен."
        },
        "b4": {
          "t": "Корректировки и списания",
          "d": "Всё с причиной и в журнале."
        },
        "f1": "Оплата «в долг» на кассе",
        "f2": "Погашение частями",
        "f3": "Возраст долгов",
        "f4": "История по каждому гостю",
        "f5": "Списание безнадёжного долга",
        "who": "Для заведений с постоянными гостями и корпоративными клиентами."
      }
    }
  },
  "invSettings": {
    "title": "Настройки склада",
    "description": "Правила для всех складов компании.",
    "expiry": "Сроки годности",
    "blockExpired": "Не продавать из просроченных партий",
    "blockExpiredHint": "Продажа списывает сначала свежие партии; просроченные — только если других нет, и ждут списания",
    "warningDays": "Предупреждать за, дней",
    "warningDaysHint": "Партии, у которых срок истекает за это время, попадают в «Скоро истекает» и в утреннее уведомление",
    "production": "Производство",
    "explode": "Нет полуфабриката — списывать сырьём",
    "explodeHint": "Если готового полуфабриката на складе не хватает, продажа спишет сырьё по его техкарте. Выключите — полуфабрикат уйдёт в минус, и будет видно, что его не доготовили",
    "safety": "Запас к прогнозу плана производства",
    "safetyHint": "На сколько процентов делать больше среднего расхода",
    "nothing": "Настройки появятся с дополнениями «Склад (расширенный)» или «Производство»."
  },
  "locations": {
    "title": "Места хранения",
    "short": "Место",
    "description": "Склад «{{name}}»: полки, холодильники, зоны",
    "placeholder": "Например: Холодильник №1",
    "name": "Название места",
    "add": "Добавить",
    "empty": "Мест пока нет",
    "emptyHint": "Добавьте полки и холодильники — по ним удобно считать инвентаризацию.",
    "products": "Продуктов: {{count}}",
    "deleteTitle": "Удалить место «{{name}}»?",
    "deleteHint": "Продукты останутся на складе, но без места.",
    "hint": "Закрепить продукт за местом можно в «Остатках»: колонка «Место».",
    "all": "Все места",
    "pick": "Выберите место",
    "countHint": "Будут подсчитаны продукты, закреплённые за этим местом"
  },
  "purchaseRequests": {
    "tabRequests": "Заявки",
    "tabSuggest": "Что заказать",
    "suggest": {
      "purchaseComment": "По рекомендациям: расход и остатки",
      "coverDays": "Закупить на",
      "days": "{{count}} дн.",
      "history": "Смотреть расход",
      "lastDays": "за {{count}} дн.",
      "safety": "Запас",
      "showAll": "Показать всё с расходом",
      "how": "Расход за {{history}} дн. (продажи по техкартам, списания, производство) → прогноз в день с учётом последней недели → на {{cover}} дн. +{{safety}}% запаса, плюс минимальный остаток, минус остаток и то, что уже в заявках.",
      "summaryMoney": "Рекомендуем заказать позиций: {{count}}, примерно на {{sum}}",
      "summary": "Рекомендуем заказать позиций: {{count}}",
      "summaryHint": "Отметьте нужное, поправьте количество и создайте заявку или сразу закупку. Сумма — по цене последней закупки.",
      "selectAll": "Выбрать все",
      "lastPurchase": "Покупали {{date}}",
      "stock": "Остаток",
      "daysLeft": "хватит на ~{{n}} дн.",
      "daily": "Расход в день",
      "trendUp": "неделя: +{{pct}}%",
      "trendDown": "неделя: −{{pct}}%",
      "pending": "Уже в заявках",
      "order": "Заказать",
      "estimate": "Примерно",
      "why": "Почему",
      "reasons": {
        "negative": "В минусе",
        "below_min": "Ниже минимума",
        "runs_out": "Скоро закончится",
        "low_data": "Мало данных"
      },
      "empty": "Пока нечего заказывать",
      "emptyHint": "Расход считается по продажам с техкартами и списаниям. Задайте минимальный остаток в карточке продукта — подскажем, когда его пора докупить.",
      "toRequest": "Создать заявку"
    },
    "title": "Заявки на закупку",
    "description": "Сотрудники пишут, что нужно купить, — управляющий одобряет, закупает по заявке или отказывает. Видно, кто и когда написал и решил.",
    "new": "Новая заявка",
    "newHint": "Что и сколько купить. Можно выбрать продукт из справочника или просто написать название.",
    "send": "Отправить заявку",
    "addLines": "Добавьте хотя бы одну строку с количеством",
    "saved": "Заявка сохранена",
    "created": "Заявка №{{n}} отправлена",
    "editTitle": "Заявка №{{n}}: изменение",
    "what": "Что купить",
    "whatPlaceholder": "Продукт или название",
    "addAsText": "Добавить «{{name}}» без справочника",
    "lineNote": "Заметка к строке",
    "lineNotePlaceholder": "Заметка: марка, жирность, размер…",
    "priority": "Срочность",
    "priorities": {
      "normal": "Обычная",
      "urgent": "Срочно"
    },
    "neededBy": "Нужно к",
    "neededByShort": "Нужно к {{date}}",
    "comment": "Заметка",
    "commentHint": "Зачем и к какому событию, где лучше купить",
    "commentPlaceholder": "Например: на банкет в субботу, молоко заканчивается",
    "rejectReason": "Причина отказа",
    "rejectReasonRequired": "Укажите причину отказа",
    "decisionNote": "Заметка для автора",
    "done": {
      "approve": "Заявка №{{n}} одобрена",
      "reject": "В заявке №{{n}} отказано",
      "purchased": "Заявка №{{n}} закрыта — куплено"
    },
    "decision": {
      "approve": "Одобрить заявку №{{n}}?",
      "reject": "Отказать в заявке №{{n}}?",
      "purchased": "Отметить заявку №{{n}} «куплено»?"
    },
    "decisionHint": {
      "approve": "Автор получит уведомление. Купить можно сразу — кнопка «Оформить закупку».",
      "reject": "Автор увидит причину отказа.",
      "purchased": "Для закупки без проведения на склад. Чтобы товар пришёл на склад — «Оформить закупку»."
    },
    "actions": {
      "approve": "Одобрить",
      "reject": "Отказать",
      "purchased": "Куплено",
      "cancel": "Отозвать",
      "makePurchase": "Оформить закупку"
    },
    "cancelTitle": "Отозвать заявку №{{n}}?",
    "history": {
      "created": "Создал",
      "updated": "Изменил",
      "approved": "Одобрил",
      "rejected": "Отказал",
      "purchased": "Купил",
      "cancelled": "Отозвал"
    },
    "titleN": "Заявка на закупку №{{n}}",
    "purchaseLink": "Закупка от {{date}} на {{sum}}",
    "commentBy": "Заметка от {{name}}",
    "rejectedTitle": "Отказано: {{name}}",
    "noteFrom": "Заметка от {{name}}",
    "notInCatalog": "нет в справочнике",
    "statuses": {
      "submitted": "Ждёт решения",
      "approved": "Одобрена",
      "purchased": "Куплено",
      "rejected": "Отказано",
      "cancelled": "Отозвана"
    },
    "pending": "Ждут решения: {{count}}",
    "pendingHint": "Сотрудники ждут ответа — одобрите, закупите или откажите.",
    "show": "Показать",
    "approvedCount": "Одобрены и ждут закупки: {{count}}",
    "approvedHint": "Откройте заявку и нажмите «Оформить закупку» — строки подставятся сами.",
    "scope": "Чьи заявки",
    "scopeAll": "Все",
    "scopeMine": "Мои",
    "search": "Поиск по товару или заметке",
    "author": "Кто написал",
    "empty": "Заявок пока нет",
    "emptyHint": "Заметили, что что-то заканчивается? Напишите заявку — управляющий увидит её сразу.",
    "purchaseComment": "По заявке на закупку №{{n}}",
    "purchaseFor": "Закупка по заявке №{{n}} ({{name}})",
    "textLinesHint": "Нет в справочнике — добавьте вручную: {{lines}}"
  },
  "requests": {
    "title": "Заявки на склад",
    "description": "Филиал заказывает товар у центрального склада, склад отгружает перемещением, филиал принимает.",
    "new": "Новая заявка",
    "newHint": "Что и сколько нужно на ваш склад. Склад-поставщик получит уведомление.",
    "send": "Отправить заявку",
    "supplier": "У какого склада",
    "supplierHint": "Обычно центральный склад сети",
    "target": "На какой склад",
    "neededBy": "Нужно к",
    "commentPlaceholder": "Например: на выходные, ждём банкет",
    "pickSupplier": "Выберите склад-поставщик",
    "created": "Заявка №{{n}} отправлена: {{wh}}",
    "titleN": "Заявка №{{n}}",
    "ship": "Отгрузить",
    "reject": "Отказать",
    "cancel": "Отозвать",
    "shippedToast": "Заявка №{{n}} отгружена — товар в пути",
    "rejectTitle": "Отказать в заявке №{{n}}?",
    "rejectHint": "Филиал увидит причину отказа.",
    "rejectReason": "Причина отказа",
    "openTransfer": "Перемещение №{{n}}",
    "transferN": "Перемещение №{{n}}",
    "neededByShort": "Нужно к {{date}}",
    "rejected": "Отказано",
    "shipHint": "Проверьте количество: можно отгрузить меньше заказанного или 0, если товара нет. Будет создано перемещение «в пути».",
    "ordered": "Заказано",
    "ourStock": "У нас на складе",
    "toShip": "Отгрузить",
    "shipped": "Отгружено",
    "createdBy": "Создал: {{name}}, {{at}}",
    "decidedBy": "Решение: {{name}}, {{at}}",
    "statuses": {
      "submitted": "Ждёт отгрузки",
      "shipped": "Отгружено",
      "received": "Получено",
      "rejected": "Отказано",
      "cancelled": "Отозвано"
    },
    "incoming": "Заявок к вашему складу: {{count}}",
    "incomingHint": "Филиалы ждут товар — отгрузите или откажите.",
    "dirOut": "Наши заявки",
    "dirIn": "К нашему складу",
    "empty": "Заявок пока нет",
    "emptyHint": "Закажите товар с центрального склада — он придёт перемещением."
  },
  "conversions": {
    "title": "Разделка и сборка",
    "description": "Разделка: туша → вырезка, мякоть, кости. Сборка: несколько товаров → набор. Себестоимость делится между выходами.",
    "new": "Разделка или сборка",
    "post": "Провести",
    "type": "Операция",
    "types": {
      "disassembly": "Разделка",
      "assembly": "Сборка"
    },
    "disHint": "Один продукт на входе — несколько на выходе. Себестоимость входа делится по долям; без долей — пропорционально цене закупки выходов (или количеству).",
    "asmHint": "Несколько продуктов на входе — один на выходе. Его себестоимость = сумма входов.",
    "template": "Шаблон",
    "pickTemplate": "Заполнить из шаблона",
    "inputDis": "Что разделываем",
    "inputAsm": "Из чего собираем",
    "outputDis": "Что получилось",
    "outputAsm": "Что собрали",
    "byShares": "Указать доли себестоимости",
    "share": "Доля",
    "sharesSum": "Сумма долей: {{pct}}%",
    "autoHint": "Доли посчитаются сами: по цене закупки выходов, а если её нет — по количеству.",
    "preview": "Оценка: {{sum}} по последней цене закупки",
    "fill": "Заполните вход и выход",
    "shares100": "Сумма долей должна быть 100%",
    "doneDis": "Разделка проведена",
    "doneAsm": "Сборка проведена",
    "tplName": "Название шаблона, например «Туша говяжья»",
    "saveTemplate": "Сохранить как шаблон",
    "tplFill": "Укажите название и строки шаблона",
    "tplSaved": "Шаблон сохранён",
    "templates": "Шаблоны",
    "useTemplate": "Провести по шаблону",
    "tplDeleteTitle": "Удалить шаблон «{{name}}»?",
    "deleteTitle": "Отменить операцию?",
    "deleteHint": "Вход вернётся на склад, выходы спишутся. Если выходы уже израсходованы — отмена не пройдёт.",
    "cancelDoc": "Отменить",
    "dist": {
      "share": "По долям",
      "price": "По цене закупки",
      "qty": "По количеству"
    },
    "input": "Вход",
    "output": "Выход",
    "unitCost": "Себестоимость",
    "search": "Продукт или комментарий",
    "what": "Что → во что",
    "empty": "Операций пока нет",
    "emptyHint": "Разделайте тушу или соберите подарочный набор — остатки и себестоимость обновятся сами."
  },
  "help": {
    "title": "Справочник",
    "description": "Как настроить и использовать каждую функцию Coca — статей: {{count}}",
    "search": "Поиск по справочнику",
    "searchPlaceholder": "Например: как провести закупку, z-отчёт, техкарта…",
    "results": "Найдено: {{count}} по запросу «{{q}}»",
    "noResults": "Ничего не нашли",
    "noResultsHint": "Попробуйте другие слова или напишите в поддержку — ответим.",
    "popular": "С чего начать",
    "videos": "Видеоуроки",
    "videosHint": "Короткие ролики: как это делается на экране",
    "video": "Видео",
    "sections": "Разделы справочника",
    "allArticles": "Все статьи ({{count}})",
    "contents": "Содержание справочника",
    "breadcrumbs": "Путь",
    "inPlan": "Есть в тарифе: {{name}}",
    "notInPlan": "Не подключено: {{name}}",
    "noPermission": "У вашей роли нет доступа",
    "openSection": "Открыть раздел",
    "howToConnect": "Как подключить",
    "related": "Связанные статьи",
    "notFound": "Не нашли ответ?",
    "notFoundHint": "Опишите вопрос — поддержка ответит прямо в программе.",
    "askSupport": "Написать в поддержку",
    "hint": "Подсказка",
    "more": "Подробнее в справочнике",
    "aboutSection": "Справка по этому разделу",
    "ruOnly": "Справочник пока на русском языке. Переводы появятся в ближайших обновлениях."
  },
  goals: {
    title: "Цели и достижения",
    description: "Цели для заведения, филиала и каждого сотрудника, рейтинг и достижения команды. Выполнение засчитывается само каждый час.",
    myTitle: "Мои цели",
    myDescription: "Ваши цели, достижения и уровень. Прогресс считается по оплаченным заказам.",
    tabs: {
      goals: "Цели",
      leaderboard: "Рейтинг",
      achievements: "Достижения",
    },
    add: "Поставить цель",
    edit: "Изменить цель",
    scan: "Проверить сейчас",
    scanResult: "Засчитано целей: {{goals}}, новых достижений: {{achievements}}",
    empty: "Целей пока нет",
    emptyHint: "Поставьте цель на выручку дня, средний чек или продажи блюда — команда увидит прогресс.",
    myEmpty: "Целей пока нет — их ставит руководитель",
    showOff: "Показать выключенные",
    titlePlaceholder: "Например: Выручка 50 000 за день",
    pickEmployee: "Выберите сотрудника",
    allBranches: "Все филиалы",
    anyCategory: "Любая категория",
    itemFilterHint: "Пусто — все блюда",
    rewardHint: "Например: премия 1000 сом",
    activeHint: "Выключенная цель не считается и не видна сотрудникам",
    fields: {
      title: "Название",
      scope: "Для кого",
      branch: "Филиал",
      employee: "Сотрудник",
      metric: "Что считаем",
      target: "Цель",
      menuItem: "Блюдо",
      category: "Категория",
      period: "Период",
      dateFrom: "С",
      dateTo: "По",
      reward: "Награда",
      points: "Очки за выполнение",
      active: "Цель включена",
    },
    targetHints: {
      revenue: "Сумма оплаченных заказов за период",
      orders: "Число оплаченных заказов",
      avg_check: "Средняя сумма заказа — засчитывается по итогу периода",
      items: "Сколько штук продать",
      new_customers: "Сколько клиентов добавить в базу",
    },
    metrics: {
      revenue: "Выручка",
      orders: "Заказы",
      avg_check: "Средний чек",
      items: "Продано блюд",
      new_customers: "Новые клиенты",
      points: "Очки",
    },
    periods: {
      day: "День",
      week: "Неделя",
      month: "Месяц",
      custom: "Свои даты",
    },
    periodNow: {
      day: "Сегодня",
      week: "Эта неделя",
      month: "Этот месяц",
      custom: "{{from}} — {{to}}",
    },
    scopes: {
      company: "Вся компания",
      branch: "Филиал",
      employee: "Сотрудник",
    },
    done: "Выполнено",
    off: "Выключена",
    progressOf: "{{value}} из {{target}}",
    rewardBadge: "Награда: {{reward}}",
    pointsBadge: "+{{count}} очков",
    history: "История выполнения",
    historyEmpty: "Цель ещё не выполнялась",
    deleteConfirm: "Удалить цель «{{title}}»?",
    deleteHint: "История выполнения и очки сотрудников сохранятся.",
    rank: "Место",
    employee: "Сотрудник",
    value: "Результат",
    points: "Очки",
    level: "Уровень {{level}}",
    pointsTotal: "{{count}} очков",
    leaderboardTitle: "Рейтинг сотрудников филиала",
    leaderboardEmpty: "За период пока нет продаж",
    pointsAllTime: "Очки за всё время: достижения и выполненные личные цели",
    myRank: "Место в рейтинге: {{rank}} из {{count}}",
    nextLevel: "До уровня {{level}}: {{count}} очков",
    maxLevel: "Максимальный уровень",
    earned: "Получено {{date}}",
    achievementsEarned: "Достижений: {{count}} из {{total}}",
    teamTitle: "Команда",
    teamHint: "Уровни, очки и полученные достижения сотрудников",
    teamEmpty: "Пока никто не получил достижений",
    catalogTitle: "Все достижения",
    catalogHint: "Выдаются сами за действия в кассе, сменах и доставке — проверка раз в час",
    tiers: {
      bronze: "Бронза",
      silver: "Серебро",
      gold: "Золото",
      platinum: "Платина",
    },
    ach: {
      first_order: { title: "Первый заказ", hint: "Провести первый оплаченный заказ" },
      orders_100: { title: "100 заказов", hint: "Провести 100 оплаченных заказов" },
      orders_1000: { title: "1000 заказов", hint: "Провести 1000 оплаченных заказов" },
      orders_5000: { title: "Легенда зала", hint: "Провести 5000 оплаченных заказов" },
      items_500: { title: "500 блюд", hint: "Продать 500 позиций" },
      items_5000: { title: "5000 блюд", hint: "Продать 5000 позиций" },
      big_table: { title: "Большой стол", hint: "Обслужить заказ на 10 гостей и больше" },
      first_shift: { title: "Первая смена", hint: "Отработать первую смену" },
      shifts_50: { title: "50 смен", hint: "Отработать 50 смен" },
      shifts_200: { title: "200 смен", hint: "Отработать 200 смен" },
      clean_cash_10: { title: "Точная касса", hint: "Закрыть 10 кассовых смен без расхождения" },
      clean_cash_50: { title: "Безупречная касса", hint: "Закрыть 50 кассовых смен без расхождения" },
      customers_10: { title: "10 новых клиентов", hint: "Добавить 10 клиентов в базу" },
      customers_100: { title: "100 новых клиентов", hint: "Добавить 100 клиентов в базу" },
      deliveries_10: { title: "10 доставок", hint: "Доставить 10 заказов" },
      deliveries_100: { title: "100 доставок", hint: "Доставить 100 заказов" },
      deliveries_500: { title: "500 доставок", hint: "Доставить 500 заказов" },
      goal_first: { title: "Первая цель", hint: "Выполнить первую личную цель" },
      goals_10: { title: "10 целей", hint: "Выполнить 10 личных целей" },
      goals_50: { title: "50 целей", hint: "Выполнить 50 личных целей" },
      top_seller: { title: "Лучший продавец недели", hint: "Самая большая выручка в филиале за неделю" },
    },
  },
  mixedPay: {
    label: "Смешанная",
    cash: "Наличными",
    rest: "Остальное",
    invalid: "Обе части должны быть больше нуля",
    partial: "Проведено частично: {{paid}}. Вторая часть не прошла — проверьте и доплатите.",
  },
  menuPacks: {
    title: "Готовые меню",
    subtitle: "Меню под ваш формат: блюда с фото и описаниями, продукты с ценами закупки, полуфабрикаты и техкарты с калькуляцией",
    howTitle: "Как это работает",
    how: "Выберите набор под свой формат и посмотрите блюда. Покупка — один раз, по счёту. После оплаты загрузите набор в меню целиком или выборочно: появятся категории, позиции с фото, продукты, полуфабрикаты и опубликованные ТТК. Цены и граммовки потом можно поменять.",
    empty: "Готовых меню пока нет",
    footer: "Себестоимость рассчитана по ценам закупки в Бишкеке — после загрузки она пересчитается по вашим ценам продуктов.",
    open: "Смотреть",
    owned: "Куплено",
    counts: "{{items}} блюд · {{semis}} полуфабрикатов · {{products}} продуктов",
    state: {
      available: "Можно купить",
      pending: "Ожидает оплаты",
      owned: "Куплено",
    },
    stat: {
      items: "блюд",
      semis: "полуфабрикатов",
      products: "продуктов",
      photos: "фото",
    },
    avgFoodCost: "Средний фудкост набора — {{pct}}%",
    fc: "фудкост {{pct}}%",
    minutes: "{{n}} мин",
    buy: "Купить за {{price}}",
    showInvoice: "Показать счёт",
    ownedNow: "Набор открыт — можно загружать в меню",
    askOwner: "Купить набор может владелец или администратор (право «Подписка: управление»).",
    noPrice: "Набор пока не продаётся в валюте вашей подписки — напишите в поддержку.",
    pendingHint: "Счёт {{n}} ждёт оплаты. Набор откроется сразу после оплаты.",
    currencyHint: "Цены набора в сомах — для валюты {{currency}} пересчёт не настроен, проверьте цены после загрузки.",
    imported: "Загружен: {{n}} раз",
    importAgain: "Загрузить ещё раз",
    price: "Цена",
    cost: "Себестоимость",
    yield: "Выход",
    calories: "Ккал",
    cookTime: "Готовится",
    variants: "Размеры",
    modifiers: "Модификаторы",
    allergens: "Аллергены",
    semis: "Полуфабрикаты",
    semiOutput: "Выход {{qty}} {{unit}} · {{cost}}",
    photoCredit: "Фото: {{author}}, {{license}}",
    photosNote: "Фото — Wikimedia Commons (свободные лицензии; автор и лицензия указаны в карточке блюда). Себестоимость — по ценам закупки набора.",
    units: {
      g: "г",
      ml: "мл",
      pcs: "шт",
    },
    recipe: {
      title: "Техкарта",
      product: "Продукт",
      gross: "Брутто",
      waste: "Отход",
      loss: "Потери",
      takeaway: "на вынос",
      instructions: "Технология приготовления",
      locked: "Граммовки, отходы и технология откроются после покупки.",
    },
    invoice: {
      title: "Счёт {{n}}",
      pack: "Готовое меню «{{name}}»",
      bank: "Реквизиты для оплаты",
      after: "Набор откроется сразу после оплаты счёта. Все счета — в разделе «Подписка».",
      print: "Распечатать счёт",
      all: "Все счета",
    },
    import: {
      open: "Загрузить в меню",
      title: "Загрузить «{{name}}»",
      submit: "Загрузить ({{n}})",
      photos: "Фото блюд",
      recipes: "Техкарты, продукты и полуфабрикаты",
      recipesHint: "Продукты с ценами закупки, ПФ и опубликованные ТТК — себестоимость посчитается сразу",
      inactive: "Скрыть позиции до проверки",
      inactiveHint: "Позиции появятся выключенными — включите их в «Меню», когда проверите цены.",
      repeatHint: "Позиции, которые уже есть в меню с таким же названием, пропускаются. Продукты, категории и группы модификаторов с тем же названием используются повторно.",
      done: "Загружено позиций: {{n}}",
      resultTitle: "Набор загружен",
      toMenu: "Открыть меню",
      skipped: "Уже были в меню — пропущено: {{n}}",
      counts: {
        items: "Позиции",
        categories: "Новые категории",
        products: "Продукты",
        semis: "Полуфабрикаты",
        recipes: "Техкарты",
        groups: "Группы модификаторов",
        photos: "Фото",
      },
    },
  },
  waiterZones: {
    title: "Официанты по залам",
    description: "Кто обслуживает какие залы и столы: если официанта нет на смене, стол сразу получает следующий; можно включить автораспределение.",
    tabs: {
      now: "Сейчас",
      zones: "Зоны",
      settings: "Настройки",
    },
    add: "Добавить зону",
    edit: "Изменить зону",
    empty: "Зон пока нет",
    emptyHint: "Создайте зону: зал или столы и официанты по порядку. Новые заказы на эти столы будут сразу уходить нужному официанту.",
    namePlaceholder: "Основной зал",
    fields: {
      name: "Название",
      scope: "Что обслуживает",
      hall: "Зал",
      tables: "Столы",
      mode: "Как распределять",
      waiters: "Официанты",
      active: "Зона включена",
    },
    scopes: {
      branch: "Весь филиал",
      hall: "Зал",
      tables: "Отдельные столы",
    },
    modes: {
      priority: "По приоритету",
      round_robin: "По очереди",
      least_loaded: "Кто свободнее",
    },
    modeHints: {
      priority: "Стол получает первый по списку, кто на смене. Нет его — второй, и так далее.",
      round_robin: "Автораспределение: столы по очереди — следующий стол тому, кто дольше всех не получал стол.",
      least_loaded: "Автораспределение: стол тому, у кого сейчас меньше всего открытых столов.",
    },
    pickHall: "Выберите зал",
    pickTables: "Выберите столы",
    branchHint: "Запасная зона: работает для столов, у которых нет своей зоны или в их зоне сейчас никого нет на смене.",
    orderHint: "Порядок важен: первый — основной официант, остальные — замена по очереди.",
    addWaiter: "Добавить официанта",
    moveUp: "Выше",
    moveDown: "Ниже",
    activeHint: "Выключенная зона не участвует в распределении.",
    table: "Стол {{number}}",
    tablesList: "Столы: {{list}}",
    off: "Выключена",
    inactive: "Недоступен",
    onShift: "На смене",
    offShift: "Не на смене",
    deleteConfirm: "Удалить зону «{{name}}»?",
    deleteHint: "Столы, которые уже обслуживают официанты зоны, останутся у них.",
    orderRule: "Стол получает первая подходящая зона: сначала «Отдельные столы», потом «Зал», потом «Весь филиал». Если в зоне никого нет на смене — берётся следующая.",
    noZonesNow: "Зон нет — заказы остаются у того, кто их открыл. Создайте зону на вкладке «Зоны».",
    notTracking: "Смены не учитываются: все официанты зон считаются на месте.",
    staffTitle: "Официанты",
    staffHint: "Кто на смене и сколько у кого открытых столов.",
    staffEmpty: "Нет официантов в зонах и никто не отметил смену",
    openTables: "Открытых столов: {{count}}",
    servedBy: "Обслуживает {{name}} · заказ №{{number}}",
    free: "Свободен",
    nextIs: "Новый заказ получит: {{name}} ({{zone}})",
    nextNobody: "Сейчас некому — заказ останется у того, кто его откроет",
    settings: {
      requireShift: "Учитывать рабочие смены",
      requireShiftHint: "Стол получает только тот, кто отметил приход и не на перерыве.",
      reassignOnLeave: "Передавать столы ушедшего",
      reassignOnLeaveHint: "Официант закрыл смену — его открытые столы сразу переходят к следующему по зоне.",
      assignStaffOrders: "Распределять заказы кассира",
      assignStaffOrdersHint: "Заказ на стол, открытый кассиром или администратором, сразу получает официант зоны.",
    },
  },
};

type Shape<T> = { [K in keyof T]: T[K] extends string ? string : Shape<T[K]> };
export type Dictionary = Shape<typeof ru>;
